webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(536);
	
	__webpack_require__(458);
	
	var _whatwgFetch = __webpack_require__(1046);
	
	var _whatwgFetch2 = _interopRequireDefault(_whatwgFetch);
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueAsyncComputed = __webpack_require__(891);
	
	var _vueAsyncComputed2 = _interopRequireDefault(_vueAsyncComputed);
	
	var _vueFilter = __webpack_require__(893);
	
	var _vueFilter2 = _interopRequireDefault(_vueFilter);
	
	var _vueProgressbar = __webpack_require__(1041);
	
	var _vueProgressbar2 = _interopRequireDefault(_vueProgressbar);
	
	var _elementUi = __webpack_require__(818);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	__webpack_require__(841);
	
	__webpack_require__(843);
	
	var _vueI18n = __webpack_require__(895);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _hu_hu = __webpack_require__(449);
	
	var _hu_hu2 = _interopRequireDefault(_hu_hu);
	
	var _en_us = __webpack_require__(448);
	
	var _en_us2 = _interopRequireDefault(_en_us);
	
	var _locale = __webpack_require__(85);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	__webpack_require__(128);
	
	var _store = __webpack_require__(87);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(452);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _App = __webpack_require__(896);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(450);
	
	var _DataForm = __webpack_require__(897);
	
	var _DataForm2 = _interopRequireDefault(_DataForm);
	
	var _DataTable = __webpack_require__(413);
	
	var _DataTable2 = _interopRequireDefault(_DataTable);
	
	var _FaIcon = __webpack_require__(898);
	
	var _FaIcon2 = _interopRequireDefault(_FaIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (!window.fetch) {
	  window.fetch = _whatwgFetch2.default;
	}
	
	_vue2.default.use(_vueAsyncComputed2.default);
	
	_vue2.default.use(_vueFilter2.default);
	
	_vue2.default.use(_vueProgressbar2.default, {
	  color: 'rgb(32, 160, 255)',
	  failedColor: 'red',
	  height: '2px'
	});
	
	_vue2.default.use(_elementUi2.default);
	
	_vue2.default.use(_vueI18n2.default);
	
	_vue2.default.locale('hu', _hu_hu2.default);
	_vue2.default.locale('en', _en_us2.default);
	
	_vue2.default.component(_DataForm2.default.name, _DataForm2.default);
	_vue2.default.component(_DataTable2.default.name, _DataTable2.default);
	_vue2.default.component(_FaIcon2.default.name, _FaIcon2.default);
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  router: _router2.default,
	  store: _store2.default,
	  components: { App: _App2.default },
	  created: function created() {
	    var lang = window.localStorage.lang || 'en';
	
	    _vue2.default.config.lang = lang;
	    _locale2.default.use(lang);
	  }
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(76);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _call = function () {
	  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	    var e,
	        message,
	        _args = arguments;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _store2.default.commit('INCREMENT_PROGRESS');
	
	            _context.prev = 1;
	            _context.next = 4;
	            return _fetch.apply(undefined, _args);
	
	          case 4:
	            return _context.abrupt('return', _context.sent);
	
	          case 7:
	            _context.prev = 7;
	            _context.t0 = _context['catch'](1);
	            e = _context.t0;
	
	
	            if (_context.t0.message === 'Failed to fetch') {
	              e = {
	                message: 'failed_to_connect_to_server'
	              };
	            }
	
	            message = e.message || e;
	
	
	            _store2.default.commit('SHOW_NOTIFICATION', { message: message, id: errorId++, type: 'error' });
	
	            throw e;
	
	          case 14:
	            _context.prev = 14;
	
	            _store2.default.commit('DECREMENT_PROGRESS');
	            return _context.finish(14);
	
	          case 17:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this, [[1, 7, 14, 17]]);
	  }));
	
	  return function _call() {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var _fetch = function () {
	  var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(url, method, data) {
	    var headers, _options, resourceUrl, resp, _data;
	
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            headers = new Headers({
	              'Authorization': 'Bearer ' + _auth2.default.token,
	              'Accept': 'application/json',
	              'Content-Type': 'application/json'
	            });
	            _options = { headers: headers, method: method };
	
	
	            if (data) {
	              _options.body = data;
	            }
	
	            if (_options.body && typeof _options.body !== 'string' && !(_options.body instanceof String)) {
	              _options.body = (0, _stringify2.default)(_options.body);
	            }
	
	            resourceUrl = '/' + url;
	            _context2.prev = 5;
	            _context2.next = 8;
	            return fetch(resourceUrl, _options);
	
	          case 8:
	            resp = _context2.sent;
	            _context2.next = 11;
	            return resp.json();
	
	          case 11:
	            _data = _context2.sent;
	
	            if (!(resp.status >= 400)) {
	              _context2.next = 15;
	              break;
	            }
	
	            if (resp.status === 401) {
	              _auth2.default.logout();
	
	              window.location.reload();
	            }
	
	            throw _data;
	
	          case 15:
	            return _context2.abrupt('return', _data);
	
	          case 18:
	            _context2.prev = 18;
	            _context2.t0 = _context2['catch'](5);
	
	            if (!_context2.t0.error) {
	              _context2.next = 22;
	              break;
	            }
	
	            throw _context2.t0.error;
	
	          case 22:
	            throw _context2.t0;
	
	          case 23:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this, [[5, 18]]);
	  }));
	
	  return function _fetch(_x, _x2, _x3) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	exports.get = get;
	exports.post = post;
	exports.put = put;
	exports.patch = patch;
	exports.deletex = deletex;
	
	var _auth = __webpack_require__(101);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(87);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function get(url) {
	  return _call(url, 'GET');
	}
	
	function post(url, data) {
	  return _call(url, 'POST', data);
	}
	
	function put(url, data) {
	  return _call(url, 'PUT', data);
	}
	
	function patch(url, data) {
	  return _call(url, 'PATCH', data);
	}
	
	function deletex(url) {
	  return _call(url, 'DELETE');
	}
	
	var errorId = 0;

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(52);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _lodash = __webpack_require__(75);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (namespace, computedNameOrFuncs, funcs) {
	  var computedName = computedNameOrFuncs;
	  var functions = funcs;
	
	  if (_lodash2.default.isObject(computedNameOrFuncs)) {
	    computedName = namespace;
	    functions = computedNameOrFuncs;
	  }
	
	  return {
	    computed: (0, _defineProperty3.default)({}, computedName || namespace, function () {
	      var entities = this.$store.getters[namespace + '/data'](this.$store.dispatch);
	
	      if (functions && functions.filter) {
	        entities = entities.filter(functions.filter.bind(this));
	      }
	
	      if (functions && functions.map) {
	        entities = entities.map(functions.map.bind(this));
	      }
	
	      return entities;
	    })
	  };
	};

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(865)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(460),
	  /* template */
	  __webpack_require__(1035),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SYSTEM_PARAMETERS = exports.EXTERNAL_SERVICE_EDIT = exports.EXTERNAL_SERVICES = exports.ACCESS_SCHEMES_EDIT = exports.ACCESS_SCHEMES = exports.EVENTS = exports.LOCATION_EDIT = exports.LOCATIONS = exports.MOBILE_GROUP_EDIT = exports.MOBILE_GROUPS = exports.RESTORE_MOBILE_ACCESS = exports.SINGLE_SWITCH_ACCESS = exports.SINGLE_MOBIL_ACCESS = exports.SWITCH_EDIT = exports.SWITCHES = exports.MOBILE_EDIT = exports.MOBILES = exports.SWITCH_GROUP_EDIT = exports.SWITCH_GROUPS = exports.CONTROLLER_EDIT = exports.CONTROLLERS = exports.CHILD_SERVER_DETAILS = exports.SERVER_DETAILS = exports.ORGANISATION_EDIT = exports.ORGANISATIONS = exports.OWNER_EDIT = exports.OWNERS = exports.USER_LEVEL_EDIT = exports.USER_LEVELS = exports.PERSON_EDIT = exports.PERSONS = exports.USER_EDIT = exports.USERS = exports.WELCOME = exports.LOGIN = exports.HOME = undefined;
	
	var _Dashboard = __webpack_require__(412);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _Login = __webpack_require__(900);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Welcome = __webpack_require__(952);
	
	var _Welcome2 = _interopRequireDefault(_Welcome);
	
	var _UserList = __webpack_require__(962);
	
	var _UserList2 = _interopRequireDefault(_UserList);
	
	var _UserDetails = __webpack_require__(960);
	
	var _UserDetails2 = _interopRequireDefault(_UserDetails);
	
	var _PersonList = __webpack_require__(938);
	
	var _PersonList2 = _interopRequireDefault(_PersonList);
	
	var _PersonDetails = __webpack_require__(936);
	
	var _PersonDetails2 = _interopRequireDefault(_PersonDetails);
	
	var _UserLevelList = __webpack_require__(959);
	
	var _UserLevelList2 = _interopRequireDefault(_UserLevelList);
	
	var _UserLevelDetails = __webpack_require__(958);
	
	var _UserLevelDetails2 = _interopRequireDefault(_UserLevelDetails);
	
	var _OwnerList = __webpack_require__(935);
	
	var _OwnerList2 = _interopRequireDefault(_OwnerList);
	
	var _OwnerDetails = __webpack_require__(934);
	
	var _OwnerDetails2 = _interopRequireDefault(_OwnerDetails);
	
	var _OrganizationList = __webpack_require__(933);
	
	var _OrganizationList2 = _interopRequireDefault(_OrganizationList);
	
	var _OrganizationDetails = __webpack_require__(932);
	
	var _OrganizationDetails2 = _interopRequireDefault(_OrganizationDetails);
	
	var _ServerDetails = __webpack_require__(942);
	
	var _ServerDetails2 = _interopRequireDefault(_ServerDetails);
	
	var _ControllerList = __webpack_require__(911);
	
	var _ControllerList2 = _interopRequireDefault(_ControllerList);
	
	var _ControllerDetails = __webpack_require__(908);
	
	var _ControllerDetails2 = _interopRequireDefault(_ControllerDetails);
	
	var _SwitchList = __webpack_require__(956);
	
	var _SwitchList2 = _interopRequireDefault(_SwitchList);
	
	var _SwitchDetails = __webpack_require__(955);
	
	var _SwitchDetails2 = _interopRequireDefault(_SwitchDetails);
	
	var _SwitchGroupList = __webpack_require__(954);
	
	var _SwitchGroupList2 = _interopRequireDefault(_SwitchGroupList);
	
	var _SwitchGroupDetails = __webpack_require__(953);
	
	var _SwitchGroupDetails2 = _interopRequireDefault(_SwitchGroupDetails);
	
	var _MobileList = __webpack_require__(929);
	
	var _MobileList2 = _interopRequireDefault(_MobileList);
	
	var _MobileDetails = __webpack_require__(928);
	
	var _MobileDetails2 = _interopRequireDefault(_MobileDetails);
	
	var _SingleMobileAccess = __webpack_require__(905);
	
	var _SingleMobileAccess2 = _interopRequireDefault(_SingleMobileAccess);
	
	var _SingleSwitchAccess = __webpack_require__(906);
	
	var _SingleSwitchAccess2 = _interopRequireDefault(_SingleSwitchAccess);
	
	var _RestoreMobileAccess = __webpack_require__(930);
	
	var _RestoreMobileAccess2 = _interopRequireDefault(_RestoreMobileAccess);
	
	var _MobileGroupList = __webpack_require__(927);
	
	var _MobileGroupList2 = _interopRequireDefault(_MobileGroupList);
	
	var _MobileGroupDetails = __webpack_require__(926);
	
	var _MobileGroupDetails2 = _interopRequireDefault(_MobileGroupDetails);
	
	var _LocationList = __webpack_require__(925);
	
	var _LocationList2 = _interopRequireDefault(_LocationList);
	
	var _LocationDetails = __webpack_require__(924);
	
	var _LocationDetails2 = _interopRequireDefault(_LocationDetails);
	
	var _EventList = __webpack_require__(918);
	
	var _EventList2 = _interopRequireDefault(_EventList);
	
	var _profiles = __webpack_require__(127);
	
	var _AccessSchemeList = __webpack_require__(904);
	
	var _AccessSchemeList2 = _interopRequireDefault(_AccessSchemeList);
	
	var _AccessSchemeDetails = __webpack_require__(903);
	
	var _AccessSchemeDetails2 = _interopRequireDefault(_AccessSchemeDetails);
	
	var _ExternalServiceList = __webpack_require__(922);
	
	var _ExternalServiceList2 = _interopRequireDefault(_ExternalServiceList);
	
	var _ExternalServiceDetails = __webpack_require__(921);
	
	var _ExternalServiceDetails2 = _interopRequireDefault(_ExternalServiceDetails);
	
	var _SystemParameterList = __webpack_require__(957);
	
	var _SystemParameterList2 = _interopRequireDefault(_SystemParameterList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GROUP_ADMININSTRATION = 'administration';
	var GROUP_DEVICES = 'devices';
	var GROUP_MONITORING = 'monitoring';
	
	var HOME = exports.HOME = 'home';
	
	var LOGIN = exports.LOGIN = 'login';
	
	var WELCOME = exports.WELCOME = 'welcome';
	
	var USERS = exports.USERS = 'user-list';
	var USER_EDIT = exports.USER_EDIT = 'user-edit';
	
	var PERSONS = exports.PERSONS = 'persons-list';
	var PERSON_EDIT = exports.PERSON_EDIT = 'person-edit';
	
	var USER_LEVELS = exports.USER_LEVELS = 'user-level-list';
	var USER_LEVEL_EDIT = exports.USER_LEVEL_EDIT = 'user-level-edit';
	
	var OWNERS = exports.OWNERS = 'owner-list';
	var OWNER_EDIT = exports.OWNER_EDIT = 'owner-edit';
	
	var ORGANISATIONS = exports.ORGANISATIONS = 'organization-list';
	var ORGANISATION_EDIT = exports.ORGANISATION_EDIT = 'organization-edit';
	
	var SERVER_DETAILS = exports.SERVER_DETAILS = 'server-details';
	var CHILD_SERVER_DETAILS = exports.CHILD_SERVER_DETAILS = 'child-server-details';
	
	var CONTROLLERS = exports.CONTROLLERS = 'controller-list';
	var CONTROLLER_EDIT = exports.CONTROLLER_EDIT = 'controller-edit';
	
	var SWITCH_GROUPS = exports.SWITCH_GROUPS = 'switch-group-list';
	var SWITCH_GROUP_EDIT = exports.SWITCH_GROUP_EDIT = 'switch-group-edit';
	
	var MOBILES = exports.MOBILES = 'mobile-list';
	var MOBILE_EDIT = exports.MOBILE_EDIT = 'mobile-edit';
	
	var SWITCHES = exports.SWITCHES = 'switch-list';
	var SWITCH_EDIT = exports.SWITCH_EDIT = 'switch-edit';
	
	var SINGLE_MOBIL_ACCESS = exports.SINGLE_MOBIL_ACCESS = 'single-mobil-access';
	var SINGLE_SWITCH_ACCESS = exports.SINGLE_SWITCH_ACCESS = 'single-switch-access';
	
	var RESTORE_MOBILE_ACCESS = exports.RESTORE_MOBILE_ACCESS = 'restore-mobile-access';
	
	var MOBILE_GROUPS = exports.MOBILE_GROUPS = 'mobile-group-list';
	var MOBILE_GROUP_EDIT = exports.MOBILE_GROUP_EDIT = 'mobile-group-edit';
	
	var LOCATIONS = exports.LOCATIONS = 'location-list';
	var LOCATION_EDIT = exports.LOCATION_EDIT = 'location-edit';
	
	var EVENTS = exports.EVENTS = 'event-list';
	
	var ACCESS_SCHEMES = exports.ACCESS_SCHEMES = 'access-schemes-list';
	var ACCESS_SCHEMES_EDIT = exports.ACCESS_SCHEMES_EDIT = 'access-scheme-edit';
	
	var EXTERNAL_SERVICES = exports.EXTERNAL_SERVICES = 'external-service-list';
	var EXTERNAL_SERVICE_EDIT = exports.EXTERNAL_SERVICE_EDIT = 'external-service-edit';
	
	var SYSTEM_PARAMETERS = exports.SYSTEM_PARAMETERS = 'system-parameter-list';
	
	var hideFromNav = true;
	
	var routes = [{ path: '/', name: HOME, component: _Dashboard2.default, meta: { hideFromNav: hideFromNav } }, { path: '/login', name: LOGIN, component: _Login2.default, meta: { hideFromNav: hideFromNav } }, { path: '/welcome', name: WELCOME, component: _Welcome2.default, meta: { hideFromNav: hideFromNav } }, { path: '/users', name: USERS, component: _UserList2.default, meta: { permission: 'VIEW_USERS', group: GROUP_ADMININSTRATION } }, { path: '/users/:id', name: USER_EDIT, component: _UserDetails2.default, meta: { hideFromNav: hideFromNav, permission: 'VIEW_USERS' } }, { path: '/persons', name: PERSONS, component: _PersonList2.default, meta: { permission: 'VIEW_PERSONS', group: GROUP_ADMININSTRATION } }, { path: '/person/:id', name: PERSON_EDIT, component: _PersonDetails2.default, meta: { hideFromNav: hideFromNav, permission: 'VIEW_USERS' } }, { path: '/user-levels', name: USER_LEVELS, component: _UserLevelList2.default, meta: { permission: 'VIEW_USER_LEVELS', group: GROUP_ADMININSTRATION } }, { path: '/user-levels/:id', name: USER_LEVEL_EDIT, component: _UserLevelDetails2.default, meta: { hideFromNav: hideFromNav, permission: 'VIEW_USER_LEVELS' } }, { path: '/mobiles', name: MOBILES, component: _MobileList2.default, meta: { permission: 'VIEW_MOBILES', group: GROUP_ADMININSTRATION } }, { path: '/mobiles/:id', name: MOBILE_EDIT, component: _MobileDetails2.default, meta: { hideFromNav: hideFromNav, permission: 'VIEW_MOBILES' } }, { path: '/access/mobile/:id', name: SINGLE_MOBIL_ACCESS, component: _SingleMobileAccess2.default, meta: { hideFromNav: hideFromNav, permission: 'VIEW_SINGLE_MOBILE_ACCESSES' } }, { path: '/access/switch/:id', name: SINGLE_SWITCH_ACCESS, component: _SingleSwitchAccess2.default, meta: { hideFromNav: hideFromNav, permission: 'VIEW_SINGLE_MOBILE_ACCESSES' } }, { path: '/mobile/restore/:id', name: RESTORE_MOBILE_ACCESS, component: _RestoreMobileAccess2.default, meta: { hideFromNav: hideFromNav, permission: 'RESTORE_MOBILE_ACCESSES' } }, { path: '/server', name: SERVER_DETAILS, component: _ServerDetails2.default, meta: { permission: 'VIEW_SERVERS', group: GROUP_DEVICES } }, { path: '/server/:id', name: CHILD_SERVER_DETAILS, component: _ServerDetails2.default, meta: { hideFromNav: hideFromNav, permission: 'VIEW_SERVERS' } }, { path: '/controllers', name: CONTROLLERS, component: _ControllerList2.default, meta: { permission: 'VIEW_CONTROLLERS', group: GROUP_DEVICES } }, { path: '/controllers/:id', name: CONTROLLER_EDIT, component: _ControllerDetails2.default, meta: { hideFromNav: hideFromNav, permission: 'VIEW_CONTROLLERS' } }, { path: '/switches', name: SWITCHES, component: _SwitchList2.default, meta: { permission: 'VIEW_SWITCHES', group: GROUP_DEVICES } }, { path: '/switches/:id', name: SWITCH_EDIT, component: _SwitchDetails2.default, meta: { hideFromNav: hideFromNav, permission: 'VIEW_SWITCHES' } }, { path: '/events/entry', name: EVENTS + '-entry', component: _EventList2.default, meta: { permission: 'VIEW_EVENTS', group: GROUP_MONITORING, profile: _profiles.ENTRY } }, { path: '/events/registration', name: EVENTS + '-registration', component: _EventList2.default, meta: { permission: 'VIEW_EVENTS', group: GROUP_MONITORING, profile: _profiles.REGISTRATION } }, { path: '/events/system', name: EVENTS + '-system', component: _EventList2.default, meta: { permission: 'VIEW_EVENTS', group: GROUP_MONITORING, profile: _profiles.SYSTEM } }, { path: '/events/input', name: EVENTS + '-input', component: _EventList2.default, meta: { permission: 'VIEW_EVENTS', group: GROUP_MONITORING, profile: _profiles.INPUT } }, { path: '*', redirect: HOME, meta: { hideFromNav: hideFromNav } }];
	
	if (false) {
	  var enterpriseRoutes = [{ path: '/mobile-groups', name: MOBILE_GROUPS, component: _MobileGroupList2.default, meta: { permission: 'VIEW_MOBILE_GROUPS', group: GROUP_ADMININSTRATION } }, { path: '/mobile-groups/:id', name: MOBILE_GROUP_EDIT, component: _MobileGroupDetails2.default, meta: { hideFromNav: hideFromNav, permission: 'VIEW_MOBILE_GROUPS' } }, { path: '/switch-groups', name: SWITCH_GROUPS, component: _SwitchGroupList2.default, meta: { permission: 'VIEW_SWITCH_GROUPS', group: GROUP_ADMININSTRATION } }, { path: '/switch-groups/:id', name: SWITCH_GROUP_EDIT, component: _SwitchGroupDetails2.default, meta: { hideFromNav: hideFromNav, permission: 'VIEW_SWITCH_GROUPS' } }, { path: '/access-schemes', name: ACCESS_SCHEMES, component: _AccessSchemeList2.default, meta: { permission: 'VIEW_ACCESS_SCHEMES', group: GROUP_ADMININSTRATION } }, { path: '/access-schemes/:id', name: ACCESS_SCHEMES_EDIT, component: _AccessSchemeDetails2.default, meta: { hideFromNav: hideFromNav, permission: 'VIEW_ACCESS_SCHEMES' } }, { path: '/pending', name: PENDING_ACCESSES, component: PendingAccessList, meta: { permission: 'VIEW_SINGLE_MOBILE_ACCESSES', group: GROUP_ADMININSTRATION } }, { path: '/external-services', name: EXTERNAL_SERVICES, component: _ExternalServiceList2.default, meta: { permission: 'VIEW_EXTERNAL_SERVICES', group: GROUP_ADMININSTRATION } }, { path: '/external-services/:id', name: EXTERNAL_SERVICE_EDIT, component: _ExternalServiceDetails2.default, meta: { hideFromNav: hideFromNav, permission: 'VIEW_EXTERNAL_SERVICES' } }, { path: '/system-parameter', name: SYSTEM_PARAMETERS, component: _SystemParameterList2.default, meta: { permission: 'VIEW_SYSTEM_PARAMETERS', group: GROUP_ADMININSTRATION } }, { path: '/locations', name: LOCATIONS, component: _LocationList2.default, meta: { permission: 'VIEW_LOCATIONS', group: GROUP_ADMININSTRATION } }, { path: '/locations/:id', name: LOCATION_EDIT, component: _LocationDetails2.default, meta: { hideFromNav: hideFromNav, permission: 'VIEW_LOCATIONS' } }, { path: '/owners', name: OWNERS, component: _OwnerList2.default, meta: { permission: 'VIEW_OWNERS', group: GROUP_ADMININSTRATION } }, { path: '/owners/:id', name: OWNER_EDIT, component: _OwnerDetails2.default, meta: { hideFromNav: hideFromNav, permission: 'VIEW_OWNERS' } }, { path: '/organizations', name: ORGANISATIONS, component: _OrganizationList2.default, meta: { permission: 'VIEW_ORGANIZATIONS', group: GROUP_ADMININSTRATION } }, { path: '/organizations/:id', name: ORGANISATION_EDIT, component: _OrganizationDetails2.default, meta: { hideFromNav: hideFromNav, permission: 'VIEW_ORGANIZATIONS' } }];
	
	  routes = routes.concat(enterpriseRoutes);
	}
	
	exports.default = routes;

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutations = undefined;
	
	var _defineProperty2 = __webpack_require__(52);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(13);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(418);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuexLocalstorage = __webpack_require__(1044);
	
	var _socketPlugin = __webpack_require__(457);
	
	var _socketPlugin2 = _interopRequireDefault(_socketPlugin);
	
	var _moduleFactory = __webpack_require__(130);
	
	var _moduleFactory2 = _interopRequireDefault(_moduleFactory);
	
	var _appFunctions = __webpack_require__(455);
	
	var _appFunctions2 = _interopRequireDefault(_appFunctions);
	
	var _scheduledJobs = __webpack_require__(456);
	
	var _scheduledJobs2 = _interopRequireDefault(_scheduledJobs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var guestUser = {
	  loggedIn: false,
	  name: 'guest'
	};
	
	var persist = (0, _vuexLocalstorage.createStorage)({
	  namespace: 'ulockme',
	  initialState: {
	    user: guestUser
	  }
	});
	
	var state = {
	  user: persist.get('user'),
	  progress: 0,
	  notification: null
	};
	
	var getters = {
	  loggedIn: function loggedIn(state) {
	    return state.user.loggedIn;
	  },
	  currentUser: function currentUser(state) {
	    return state.user;
	  },
	  hasPermission: function hasPermission(state) {
	    return function (_ref) {
	      var permission = _ref.permission,
	          serverId = _ref.serverId;
	
	      var allowedOnServers = state.user.permissions.filter(function (p) {
	        return p.appFunctions.includes(permission);
	      });
	
	      if (!allowedOnServers.length) {
	        return false;
	      }
	
	      if (allowedOnServers.filter(function (p) {
	        return p.server.isCentral;
	      }).length) {
	        return true;
	      }
	
	      if (!serverId) {
	        return allowedOnServers.filter(function (p) {
	          return p.server.isSelf;
	        }).length;
	      }
	
	      return allowedOnServers.filter(function (p) {
	        return p.server.id === serverId;
	      }).length;
	    };
	  }
	};
	
	var mutations = exports.mutations = {
	  updateUser: function updateUser(state, user) {
	    state.user = user;
	    persist.set('user', user);
	  },
	  resetUser: function resetUser(state) {
	    state.user = guestUser;
	    persist.set('user', guestUser);
	  },
	  INCREMENT_PROGRESS: function INCREMENT_PROGRESS(state) {
	    state.progress = state.progress + 1;
	  },
	  DECREMENT_PROGRESS: function DECREMENT_PROGRESS(state) {
	    state.progress = state.progress - 1;
	  },
	  SHOW_NOTIFICATION: function SHOW_NOTIFICATION(state, notification) {
	    state.notification = notification;
	  }
	};
	
	var actions = {};
	
	var store = new _vuex2.default.Store({
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions,
	  modules: (0, _extends4.default)({}, ['users', 'persons', 'owners', 'organizations', 'user-levels', 'servers', 'controllers', 'switch-groups', 'mobiles', 'switches', 'mobile-groups', 'locations', 'event-types', 'preregistrations', 'access-schemes', 'external-services', 'readers', 'inputs', 'system-parameters', 'pending-mobile-accesses', 'mobile-notification-settings'].reduce(function (acc, curr) {
	    return (0, _extends4.default)({}, acc, (0, _defineProperty3.default)({}, curr, (0, _moduleFactory2.default)(curr)));
	  }, {}), {
	    'app-functions': _appFunctions2.default,
	    'scheduled-jobs': _scheduledJobs2.default
	  }),
	  plugins: [_socketPlugin2.default],
	
	  strict: ("production") !== 'production'
	});
	
	exports.default = store;

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(204);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(544);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _http = __webpack_require__(8);
	
	var _store = __webpack_require__(87);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Auth = function () {
	  function Auth() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, Auth);
	
	    setTimeout(function () {
	      if (_this.token) {
	        _this.refreshUserPermissions();
	      }
	    }, 10);
	  }
	
	  (0, _createClass3.default)(Auth, [{
	    key: 'login',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(email, password) {
	        var body, resp;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                body = {
	                  email: email, password: password
	                };
	                _context.next = 3;
	                return (0, _http.post)('auth', body);
	
	              case 3:
	                resp = _context.sent;
	
	
	                if (!resp.message) {
	                  _store2.default.commit('updateUser', resp);
	                }
	
	                return _context.abrupt('return', resp);
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function login(_x, _x2) {
	        return _ref.apply(this, arguments);
	      }
	
	      return login;
	    }()
	  }, {
	    key: 'refreshUserPermissions',
	    value: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var user;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (this.loggedIn()) {
	                  _context2.next = 2;
	                  break;
	                }
	
	                return _context2.abrupt('return');
	
	              case 2:
	                _context2.prev = 2;
	                _context2.next = 5;
	                return (0, _http.post)('auth/refresh');
	
	              case 5:
	                user = _context2.sent;
	
	                _store2.default.commit('updateUser', user);
	                _context2.next = 12;
	                break;
	
	              case 9:
	                _context2.prev = 9;
	                _context2.t0 = _context2['catch'](2);
	
	                console.error('Failed to refresh permissions!', _context2.t0);
	
	              case 12:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[2, 9]]);
	      }));
	
	      function refreshUserPermissions() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return refreshUserPermissions;
	    }()
	  }, {
	    key: 'logout',
	    value: function logout() {
	      _store2.default.commit('resetUser');
	    }
	  }, {
	    key: 'loggedIn',
	    value: function loggedIn() {
	      return _store2.default.state.user.loggedIn;
	    }
	  }, {
	    key: 'token',
	    get: function get() {
	      return _store2.default.state.user.token;
	    }
	  }, {
	    key: 'user',
	    get: function get() {
	      return _store2.default.state.user;
	    }
	  }]);
	  return Auth;
	}();
	
	var AuthInstance = new Auth();
	
	exports.default = AuthInstance;

/***/ }),
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ALL = exports.INPUT = exports.SYSTEM = exports.REGISTRATION = exports.ENTRY = undefined;
	
	var _defineProperty2 = __webpack_require__(52);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _ENTRY$REGISTRATION$S;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ENTRY = exports.ENTRY = 'entry';
	var REGISTRATION = exports.REGISTRATION = 'registration';
	var SYSTEM = exports.SYSTEM = 'system';
	var INPUT = exports.INPUT = 'input';
	var ALL = exports.ALL = 'all';
	
	exports.default = (_ENTRY$REGISTRATION$S = {}, (0, _defineProperty3.default)(_ENTRY$REGISTRATION$S, ENTRY, {
	  eventTypeId: [10, 110, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214]
	}), (0, _defineProperty3.default)(_ENTRY$REGISTRATION$S, REGISTRATION, {
	  eventTypeId: [4, 5, 6, 7, 9, 104, 105, 106, 107, 109, 7006, 7007, 7008]
	}), (0, _defineProperty3.default)(_ENTRY$REGISTRATION$S, SYSTEM, {
	  eventTypeId: [2, 3, 11, 12, 13, 14, 15, 16, 17, 20, 21, 22, 23, 102, 103, 111, 112, 113, 114, 115, 7000, 7001, 7004, 7005]
	}), (0, _defineProperty3.default)(_ENTRY$REGISTRATION$S, INPUT, {
	  eventTypeId: [215, 216, 217, 218, 219, 220, 221, 222]
	}), (0, _defineProperty3.default)(_ENTRY$REGISTRATION$S, ALL, {}), _ENTRY$REGISTRATION$S);

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(204);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _socket = __webpack_require__(882);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	var _detectBrowser = __webpack_require__(811);
	
	var _detectBrowser2 = _interopRequireDefault(_detectBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Socket = function Socket() {
	  (0, _classCallCheck3.default)(this, Socket);
	
	  var opts = {};
	
	  if (_detectBrowser2.default.name !== 'ie' || _detectBrowser2.default.version >= 10) {
	    opts.transports = ['websocket'];
	  }
	
	  this.socket = (0, _socket2.default)('/', opts);
	};
	
	var singleInstance = new Socket();
	
	exports.default = singleInstance.socket;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(52);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _lodash = __webpack_require__(75);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (namespace, computedName, idProvider) {
	  return {
	    computed: (0, _defineProperty3.default)({}, computedName, function () {
	      var id = void 0;
	
	      if (this.hasOwnProperty(idProvider)) {
	        id = this[idProvider];
	      } else if (_lodash2.default.isFunction(idProvider)) {
	        id = idProvider.apply(this);
	      }
	
	      return this.$store.getters[namespace + '/findById'](id, this.$store.dispatch);
	    })
	  };
	};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DELETE = exports.EDIT = exports.CREATE = exports.REQUEST_BY_ID = exports.REQUEST_ALL = undefined;
	
	var _extends4 = __webpack_require__(13);
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	var _defineProperty2 = __webpack_require__(52);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _values = __webpack_require__(540);
	
	var _values2 = _interopRequireDefault(_values);
	
	exports.default = function (namespace) {
	  var _actions, _mutations;
	
	  var _subscribed = false;
	
	  function subscribeForChanges() {
	    if (!_subscribed) {
	      _socket2.default.emit('subscribeChanges', { namespace: namespace }, function () {
	        return console.debug('Subscribed for model: ' + namespace);
	      });
	
	      _subscribed = true;
	    }
	  }
	
	  var state = {
	    data: {},
	    requestedAll: false,
	    loading: false,
	    fetching: false,
	    forceUpdate: false,
	    lastUpdateTime: null,
	    changeList: []
	  };
	
	  var getters = {
	    loading: function loading(state) {
	      return state.loading;
	    },
	    data: function data(state) {
	      return function (dispatch) {
	        if (!dispatch) {
	          throw new Error('Please provide dispatch as paramter!');
	        }
	
	        subscribeForChanges();
	
	        if ((!state.requestedAll || state.forceUpdate) && !state.fetching) {
	          dispatch(namespace + '/' + REQUEST_ALL);
	        }
	
	        return (0, _values2.default)(state.data).filter(function (item) {
	          return !item.err;
	        });
	      };
	    },
	    findById: function findById(state) {
	      return function (id, dispatch) {
	        if (!id || id === 'new') {
	          console.warn('findById called without id');
	
	          return {};
	        }
	
	        var item = state.data[id] || {};
	
	        if (!dispatch) {
	          return item;
	        }
	
	        subscribeForChanges();
	
	        if (!state.fetching && (!item.id || state.changeList.includes(id))) {
	          dispatch(namespace + '/' + REQUEST_BY_ID, id);
	        }
	
	        return !item.id ? { id: id } : item;
	      };
	    }
	  };
	
	  var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, REQUEST_ALL, function (_ref) {
	    var _this = this;
	
	    var commit = _ref.commit;
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              commit(SET_LOADING, true);
	              commit('setFetching', true);
	
	              commit('requestedAll');
	
	              _context.prev = 3;
	              _context.t0 = commit;
	              _context.t1 = ADD_ALL;
	              _context.next = 8;
	              return (0, _http.get)('api/v1/' + namespace);
	
	            case 8:
	              _context.t2 = _context.sent;
	              (0, _context.t0)(_context.t1, _context.t2);
	              _context.next = 17;
	              break;
	
	            case 12:
	              _context.prev = 12;
	              _context.t3 = _context['catch'](3);
	
	              console.error('Failed to retrieve ' + namespace + ' from server:', _context.t3);
	
	              commit(ADD_ALL, []);
	
	              throw _context.t3;
	
	            case 17:
	              _context.prev = 17;
	
	              commit(SET_LOADING, false);
	              commit('setFetching', false);
	              return _context.finish(17);
	
	            case 21:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this, [[3, 12, 17, 21]]);
	    }))();
	  }), (0, _defineProperty3.default)(_actions, REQUEST_BY_ID, function (_ref2, id) {
	    var _this2 = this;
	
	    var commit = _ref2.commit;
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              commit(SET_LOADING, true);
	              commit('setFetching', true);
	
	              _context2.prev = 2;
	              _context2.t0 = commit;
	              _context2.t1 = SET_ONE;
	              _context2.next = 7;
	              return (0, _http.get)('api/v1/' + namespace + '/' + id);
	
	            case 7:
	              _context2.t2 = _context2.sent;
	              (0, _context2.t0)(_context2.t1, _context2.t2);
	              _context2.next = 16;
	              break;
	
	            case 11:
	              _context2.prev = 11;
	              _context2.t3 = _context2['catch'](2);
	
	              console.error('Failed to retrieve ' + namespace + '/' + id + ' from server:', _context2.t3);
	
	              commit(SET_ONE, { id: id, err: _context2.t3 });
	
	              throw _context2.t3;
	
	            case 16:
	              _context2.prev = 16;
	
	              commit(SET_LOADING, false);
	              commit('setFetching', false);
	              return _context2.finish(16);
	
	            case 20:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2, [[2, 11, 16, 20]]);
	    }))();
	  }), (0, _defineProperty3.default)(_actions, CREATE, function (_ref3, item) {
	    var _this3 = this;
	
	    var commit = _ref3.commit;
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	      var created;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              commit(SET_LOADING, true);
	
	              _context3.prev = 1;
	              _context3.next = 4;
	              return (0, _http.post)('api/v1/' + namespace + '/new', item);
	
	            case 4:
	              created = _context3.sent;
	
	
	              commit(SET_ONE, created);
	              _context3.next = 12;
	              break;
	
	            case 8:
	              _context3.prev = 8;
	              _context3.t0 = _context3['catch'](1);
	
	              console.error('Failed to insert ' + namespace, _context3.t0);
	
	              throw _context3.t0;
	
	            case 12:
	              _context3.prev = 12;
	
	              commit(SET_LOADING, false);
	              return _context3.finish(12);
	
	            case 15:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this3, [[1, 8, 12, 15]]);
	    }))();
	  }), (0, _defineProperty3.default)(_actions, EDIT, function (_ref4, item) {
	    var _this4 = this;
	
	    var commit = _ref4.commit;
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              commit(SET_LOADING, true);
	
	              _context4.prev = 1;
	              _context4.next = 4;
	              return (0, _http.post)('api/v1/' + namespace + '/' + item.id, item);
	
	            case 4:
	
	              commit(SET_ONE, item);
	              _context4.next = 11;
	              break;
	
	            case 7:
	              _context4.prev = 7;
	              _context4.t0 = _context4['catch'](1);
	
	              console.error('Failed to edit ' + namespace + '/' + item.id, _context4.t0);
	
	              throw _context4.t0;
	
	            case 11:
	              _context4.prev = 11;
	
	              commit(SET_LOADING, false);
	              return _context4.finish(11);
	
	            case 14:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this4, [[1, 7, 11, 14]]);
	    }))();
	  }), (0, _defineProperty3.default)(_actions, DELETE, function (_ref5, item) {
	    var _this5 = this;
	
	    var commit = _ref5.commit;
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              commit(SET_LOADING, true);
	
	              _context5.prev = 1;
	              _context5.next = 4;
	              return (0, _http.deletex)('api/v1/' + namespace + '/' + item.id);
	
	            case 4:
	
	              commit(REMOVE_ONE, item);
	              _context5.next = 11;
	              break;
	
	            case 7:
	              _context5.prev = 7;
	              _context5.t0 = _context5['catch'](1);
	
	              console.error('Failed to delete ' + namespace + '/' + item.id, _context5.t0);
	
	              throw _context5.t0;
	
	            case 11:
	              _context5.prev = 11;
	
	              commit(SET_LOADING, false);
	              return _context5.finish(11);
	
	            case 14:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this5, [[1, 7, 11, 14]]);
	    }))();
	  }), _actions);
	
	  var i = 0;
	
	  var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, ADD_ALL, function (state) {
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    console.time(namespace + '-' + i + '-' + data.length);
	
	    var newStateData = {};
	
	    for (var _i = 0; _i < data.length; _i++) {
	      var curr = data[_i];
	
	      newStateData[curr.id] = curr;
	    }
	
	    state.data = newStateData;
	
	    console.timeEnd(namespace + '-' + i + '-' + data.length);
	
	    state.forceUpdate = false;
	    state.toUpdateIds = [];
	    state.lastUpdateTime = new Date();
	    i++;
	  }), (0, _defineProperty3.default)(_mutations, SET_ONE, function (state, item) {
	    state.data = (0, _extends5.default)({}, state.data, (0, _defineProperty3.default)({}, item.id, item));
	    state.changeList = state.changeList.filter(function (i) {
	      return i !== item.id;
	    });
	    state.lastUpdateTime = new Date();
	  }), (0, _defineProperty3.default)(_mutations, REMOVE_ONE, function (state, item) {
	    state.data = (0, _values2.default)(state.data).filter(function (i) {
	      return i.id !== item.id;
	    }).reduce(function (acc, curr) {
	      return (0, _extends5.default)({}, acc, (0, _defineProperty3.default)({}, curr.id, curr));
	    }, {});
	    state.changeList = state.changeList.filter(function (i) {
	      return i !== item.id;
	    });
	    state.lastUpdateTime = new Date();
	  }), (0, _defineProperty3.default)(_mutations, SET_LOADING, function (state, loading) {
	    state.loading = loading;
	  }), (0, _defineProperty3.default)(_mutations, SET_FORCE_UPDATE, function (state, forceUpdate) {
	    state.forceUpdate = forceUpdate;
	  }), (0, _defineProperty3.default)(_mutations, 'requestedAll', function requestedAll(state) {
	    state.requestedAll = true;
	  }), (0, _defineProperty3.default)(_mutations, 'setFetching', function setFetching(state, fetching) {
	    state.fetching = fetching;
	  }), (0, _defineProperty3.default)(_mutations, 'addToChanges', function addToChanges(state, id) {
	    state.changeList.push(id);
	  }), _mutations);
	
	  return {
	    namespaced: true,
	    state: state,
	    getters: getters,
	    actions: actions,
	    mutations: mutations
	  };
	};
	
	var _http = __webpack_require__(8);
	
	var _socket = __webpack_require__(128);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SET_LOADING = 'setLoading';
	var ADD_ALL = 'addAll';
	var SET_ONE = 'setOne';
	var REMOVE_ONE = 'removeOne';
	var SET_FORCE_UPDATE = 'setForceUpdate';
	
	var REQUEST_ALL = exports.REQUEST_ALL = 'requestAll';
	var REQUEST_BY_ID = exports.REQUEST_BY_ID = 'requestById';
	var CREATE = exports.CREATE = 'create';
	var EDIT = exports.EDIT = 'edit';
	var DELETE = exports.DELETE = 'delete';

/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(489),
	  /* template */
	  __webpack_require__(1018),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(490),
	  /* template */
	  __webpack_require__(1000),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 193 */,
/* 194 */,
/* 195 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  'label': 'mon',
	  'value': '1'
	}, {
	  'label': 'tue',
	  'value': '2'
	}, {
	  'label': 'wed',
	  'value': '3'
	}, {
	  'label': 'thu',
	  'value': '4'
	}, {
	  'label': 'fri',
	  'value': '5'
	}, {
	  'label': 'sat',
	  'value': '6'
	}, {
	  'label': 'sun',
	  'value': '7'
	}];

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{ label: 'inputType.None', value: 0 }, { label: 'inputType.Switch1Toggle', value: 1 }, { label: 'inputType.Switch2Toggle', value: 2 }, { label: 'inputType.Switch3Toggle', value: 3 }, { label: 'inputType.Switch4Toggle', value: 4 }, { label: 'inputType.Switch1On', value: 5 }, { label: 'inputType.Switch2On', value: 6 }, { label: 'inputType.Switch3On', value: 7 }, { label: 'inputType.Switch4On', value: 8 }, { label: 'inputType.AllSwitchOn', value: 9 }, { label: 'inputType.Switch1Off', value: 10 }, { label: 'inputType.Switch2Off', value: 11 }, { label: 'inputType.Switch3Off', value: 12 }, { label: 'inputType.Switch4Off', value: 13 }, { label: 'inputType.AllSwitchOff', value: 14 }, { label: 'inputType.OpenSensor', value: 15 }, { label: 'inputType.Dorbell', value: 16 }, { label: 'inputType.FireAlarm', value: 17 }, { label: 'inputType.SecurityAlarm', value: 18 }, { label: 'inputType.TermalSensor', value: 19 }, { label: 'inputType.MoveSensor', value: 20 }, { label: 'inputType.OtherSensor', value: 21 }, { label: 'inputType.IntrusionDetection', value: 22 }];

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'name': { rules: [{ required: true }, { max: 80 }] },
	  'description': { rules: [{ max: 80 }] },
	  'street': { rules: [{ max: 250 }] },
	  'zip': { rules: [{ max: 12 }] },
	  'city': { rules: [{ max: 80 }] },
	  'contact_name': { rules: [{ max: 80 }] },
	  'contact_phone': { rules: [{ max: 16 }] },
	  'contact_email': { rules: [{ type: 'email' }, { max: 254 }] }
	};

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'name': {
	    type: 'text',
	    rules: [{ required: true }, { max: 80 }]
	  },
	  'street': {
	    type: 'text',
	    rules: [{ max: 250 }]
	  },
	  'zip': {
	    type: 'number',
	    rules: [{ type: 'number', max: 12 }]
	  },
	  'city': {
	    type: 'text',
	    rules: [{ max: 80 }]
	  },
	  'taxno': {
	    type: 'text',
	    rules: [{ max: 20 }]
	  },
	  'regno': {
	    type: 'text',
	    rules: [{ max: 80 }]
	  },
	  'contact_name': {
	    type: 'text',
	    rules: [{ max: 80 }]
	  },
	  'contact_phone': {
	    type: 'text',
	    rules: [{ max: 16 }]
	  },
	  'contact_email': {
	    type: 'email',
	    rules: [{ type: 'email' }, { max: 254 }]
	  }
	};

/***/ }),
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(866)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(461),
	  /* template */
	  __webpack_require__(1036),
	  /* scopeId */
	  "data-v-e16b6992",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(856)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(463),
	  /* template */
	  __webpack_require__(999),
	  /* scopeId */
	  "data-v-5254c232",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(471),
	  /* template */
	  __webpack_require__(1003),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(854)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(472),
	  /* template */
	  __webpack_require__(993),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(525),
	  /* template */
	  __webpack_require__(974),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(527),
	  /* template */
	  __webpack_require__(983),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  value: 10,
	  label: 'SuperAdmin'
	}, {
	  value: 5,
	  label: 'DeviceAdmin'
	}, {
	  value: 4,
	  label: 'KeyAdmin'
	}, {
	  value: 3,
	  label: 'Keeper'
	}, {
	  value: 2,
	  label: 'PowerUser'
	}, {
	  value: 1,
	  label: 'User'
	}];

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RadarChart = exports.BarChart = exports.LineChart = exports.PieChart = undefined;
	
	var _assign = __webpack_require__(51);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vueChartjs = __webpack_require__(892);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mergeOptions(options) {
	  return (0, _assign2.default)({
	    responsive: true,
	    maintainAspectRatio: false,
	    scales: {
	      yAxes: [{
	        gridLines: {
	          display: true }
	      }],
	      xAxes: [{
	        gridLines: {
	          display: false },
	        categoryPercentage: 1,
	        barPercentage: 0.7
	      }]
	    }
	  }, options);
	}
	
	var PieChart = exports.PieChart = _vueChartjs.Pie.extend({
	  mixins: [_vueChartjs.mixins.reactiveProp],
	  props: ['chartData', 'options'],
	  mounted: function mounted() {
	    this.renderChart(this.chartData, mergeOptions(this.options));
	  }
	});
	
	var LineChart = exports.LineChart = _vueChartjs.Line.extend({
	  mixins: [_vueChartjs.mixins.reactiveProp],
	  props: ['chartData', 'options'],
	  mounted: function mounted() {
	    this.renderChart(this.chartData, mergeOptions(this.options));
	  }
	});
	
	var BarChart = exports.BarChart = _vueChartjs.Bar.extend({
	  mixins: [_vueChartjs.mixins.reactiveProp],
	  props: ['chartData', 'options'],
	  mounted: function mounted() {
	    this.renderChart(this.chartData, mergeOptions(this.options));
	  }
	});
	
	var RadarChart = exports.RadarChart = _vueChartjs.Radar.extend({
	  mixins: [_vueChartjs.mixins.reactiveProp],
	  props: ['chartData', 'options'],
	  mounted: function mounted() {
	    this.renderChart(this.chartData, mergeOptions(this.options));
	  }
	});

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  'x': 0,
	  'y': 1,
	  'w': 1,
	  'h': 12,
	  'i': '0',
	  'component': { 'title': 'Server time', 'name': 'SystemTime', 'w': 1, 'h': 8, 'needsPadding': true },
	  'moved': false
	}, {
	  'x': 1,
	  'y': 1,
	  'w': 2,
	  'h': 12,
	  'i': '1',
	  'component': { 'title': 'Server location', 'name': 'SystemLocation', 'w': 1, 'h': 8, 'needsPadding': true },
	  'moved': false
	}, {
	  'x': 3,
	  'y': 1,
	  'w': 1,
	  'h': 12,
	  'i': '2',
	  'component': { 'title': 'Emergency functions', 'name': 'EmergencyFunctions', 'w': 1, 'h': 9, 'needsPadding': true },
	  'moved': false
	}, {
	  'x': 2,
	  'y': 16,
	  'w': 2,
	  'h': 26,
	  'i': '3',
	  'component': { 'title': 'Switchgroups and switch controll', 'name': 'SwitchControll', 'w': 1, 'h': 20, 'needsPadding': true },
	  'moved': false }, {
	  'x': 0,
	  'y': 43,
	  'w': 2,
	  'h': 45,
	  'i': '4',
	  'component': {
	    'title': 'Events',
	    'name': 'EventTable',
	    'configName': 'EventTableConfig',
	    'w': 2,
	    'h': 45,
	    'isConfiguring': false,
	    'properties': { 'showSearch': false } },
	  'moved': false
	}, {
	  'x': 2,
	  'y': 43,
	  'w': 2,
	  'h': 45,
	  'i': '5',
	  'component': {
	    'title': 'Event statistics',
	    'name': 'EventStatistics',
	    'w': 2,
	    'h': 40,
	    'needsPadding': true,
	    'configName': 'EventStatisticsConfig',
	    'isConfiguring': false
	  },
	  'moved': false
	}, {
	  'x': 0,
	  'y': 16,
	  'w': 2,
	  'h': 26,
	  'i': '6',
	  'component': { 'title': 'LAN status', 'name': 'LANStatus', 'w': 1, 'h': 20, 'needsPadding': true },
	  'moved': false
	}];

/***/ }),
/* 447 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  0: {
	    type: 'bt',
	    success: 'success'
	  },
	  1: {
	    type: 'rfid',
	    success: 'success'
	  },
	  2: {
	    type: 'qr',
	    success: 'success'
	  },
	  3: {
	    type: 'bt',
	    success: 'fail-unregistered'
	  },
	  4: {
	    type: 'rfid',
	    success: 'fail-unregistered'
	  },
	  5: {
	    type: 'qr',
	    success: 'fail-unregistered'
	  },
	  6: {
	    type: 'bt',
	    success: 'fail-disabled'
	  },
	  7: {
	    type: 'rfid',
	    success: 'fail-disabled'
	  },
	  8: {
	    type: 'qr',
	    success: 'fail-disabled'
	  },
	  9: {
	    type: 'bt',
	    success: 'fail-out-of-interval'
	  },
	  10: {
	    type: 'rfid',
	    success: 'fail-out-of-interval'
	  },
	  11: {
	    type: 'qr',
	    success: 'fail-out-of-interval'
	  }
	};

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'ulockme': 'ulockme',
	  'login.welcome': 'Ulockme server login',
	  'title.edit.user-level': 'Edit user profile',
	  'title.create.user-level': 'Define new user profile',
	  'title': {
	    'controller-details': 'Controller details',
	    'email-notification': 'E-mail notification',
	    'create-prereg': 'Create preregistration',
	    'edit-mobile': 'Edit mobile',
	    'edit-prereg': 'Edit preregistration',
	    'create-access-scheme': 'Create access group',
	    'edit-access-scheme': 'Edit access group',
	    'create-external-service': 'Setup external service',
	    'system-parameters': 'System preferences',
	    'restore-mobile-access': 'Transfer selected accesses',
	    'custom-filters': 'Filter events',
	    'events': 'Events',
	    'edit-switch': 'Edit switch',
	    'switches': 'List of switches',
	    'controllers': 'List of controllers',
	    'access-for': 'Manage access',
	    'accesses-for': 'Manage access',
	    'set-access': 'Setup permissions',
	    'persons': 'Persons',
	    'users': 'Server users',
	    'user-levels': 'Users security profiles',
	    'mobiles': 'Mobiles and ID cards',
	    'preregistrations': ' Keycodes (preregistrations)',
	    'mobile-groups': 'Mobile groups',
	    'switch-groups': 'Switch groups',
	    'locations': 'Locations',
	    'owners': 'Owners',
	    'organizations': 'Organizations',
	    'next-schedule': 'Next-schedule',
	    'pending-jobs': 'Pending-jobs',
	    'access-schemes': 'Access profiles',
	    'pending-accesses': 'Pending accesses',
	    'external-services': 'External services',
	    'edit': {
	      'person': 'Edit person',
	      'owner': 'Edit owner',
	      'organization': 'Edit organization',
	      'user': 'Edit user',
	      'switch-group': 'Edit switch group',
	      'mobile-group': 'Edit mobile group',
	      'location': 'Edit location'
	    },
	    'create': {
	      'owner': 'Create owner',
	      'organization': 'Create organization',
	      'user': 'Create user',
	      'person': 'Create person',
	      'switch-group': 'Create switch group',
	      'mobile-group': 'Create mobile group',
	      'location': 'Create location'
	    },
	    'activate-controller': 'Activate controller',
	    'set-acces': 'Set access',
	    'add-licence': 'Add licence',
	    'remove': 'Remove'
	  },
	  'switchMode': {
	    'offline': 'Offline - controller auth',
	    'online': 'Online - server auth',
	    'anti-pb': 'Online - server auth with Antipassback',
	    'learning': 'Learning - no auth'
	  },
	  'profile': {
	    'toggle': 'Entries',
	    'all': 'All events'
	  },
	  'label': {
	    'workplace': 'Workplace',
	    'class': 'Class',
	    'photo': 'Photo',
	    'address': 'Address',
	    'idcardnumber': 'ID card',
	    'department': 'Organization',
	    'supervisor': 'Supervisor',
	    'otheridentificator': 'Other identificator',
	    'show_distant_switches': 'Allow distant open',
	    'hasEmail': 'Set e-mail notification',
	    'userLevelId': 'Security profile',
	    'userLevel': 'BLE access level',
	    'has-access': 'Set access',
	    'key_type': 'Key type',
	    'timeout': 'Max timeout',
	    'maxTries': 'Max retries',
	    'url': 'URL',
	    'ifVersion': 'Interface version',
	    'espVersion': 'Network module ver',
	    'commitHash': 'Subversion tag',
	    'version': 'Version',
	    'subnetMask': 'Subnet mask',
	    'manualDhcp': 'Static IP',
	    'serverShortCode': 'Server Code',
	    'serverPort': 'Server port',
	    'serverHost': 'Server hostname',
	    'securityType': 'Security mode',
	    'interval': 'Interval',
	    'bytes': 'Command bytes',
	    'topic': 'MQTT topic',
	    'txPower': 'Bluetooth TX power',
	    'restoreMobileId': 'Transfer accesses to (destination)',
	    'profile': 'Selected events',
	    'start_date': 'Start date',
	    'ssid': 'SSID',
	    'secuPassphrase': 'Security pass',
	    'secuType': 'Security type',
	    'serverIp': 'Server IP address',
	    'customDhcp': 'User DHCP',
	    'direction': 'Direction',
	    'switch_id': 'Binding switch',
	    'pausetime': 'Pause time',
	    'autoclosetime': 'Switching time',
	    'mode': 'Working mode',
	    'email': 'Email',
	    'password': 'Password',
	    'name': 'Name',
	    'street': 'Street',
	    'zip': 'Zip',
	    'city': 'City',
	    'taxno': 'Tax number',
	    'regno': 'Registration number',
	    'contact_name': 'Contact Name',
	    'contact_refid': 'Person',
	    'contact_phone': 'Contact phone',
	    'contact_email': 'Contact email',
	    'description': 'Description',
	    'owner_id': 'Owner',
	    'first_name': 'First name',
	    'last_name': 'Last name',
	    'phone': 'Phone',
	    'user_level_id': 'User level',
	    'organization_id': 'organization',
	    'type': 'Type',
	    'x_pos': 'X coordinate',
	    'y_pos': 'Y coordinate',
	    'z_pos': 'Z coordinate',
	    'input_type': 'Input type',
	    'pauseTime': 'Pause time',
	    'autoCloseTime': 'Autoclose time',
	    'keyType': 'Key type',
	    'startDate': 'From',
	    'endDate': 'To',
	    'daily-duration': 'Duration',
	    'days': 'Days',
	    'systemTime': 'Server time',
	    'events': 'Events',
	    'LAN-status': 'LAN status',
	    'switch-controll': 'Switchgroups and switch controll',
	    'emergency-functions': 'Emergency functions',
	    'event-statistics': 'Event statistics',
	    'ipAddress': 'IP Address',
	    'hostName': 'Hostname',
	    'gatewayIp': 'Gateway IP',
	    'isGatewayAlive': 'Gateway health',
	    'serverLocation': 'Server location',
	    'emergencyControll': 'Emergency controll',
	    'mobileId': 'Mobile',
	    'eventTypeId': 'Event type',
	    'dateFrom': 'Starting date',
	    'dateTo': 'Ending date',
	    'size': 'Total results',
	    'controllerIp': 'Manual IP Address',
	    'gateway': 'Gateway',
	    'subNetmask': 'Subnet mask',
	    'ip': 'IP Address',
	    'rssi': 'WiFi RSSI (dB)',
	    'lastHeartbeat': 'Heartbeat time',
	    'lastWifiReconnect': 'WiFi connected',
	    'lastMqttReconnect': 'MQTT connected',
	    'fqdn': 'Hostname (FQDN)',
	    'location_id': 'Location',
	    'license': 'License',
	    'usage': 'Function'
	  },
	  'button': {
	    'add-new': 'Add new',
	    'login': 'Login',
	    'submit': 'Submit',
	    'new': 'Add new',
	    'cancel': 'Cancel',
	    'edit': 'Edit',
	    'save': 'Save',
	    'submit-scheduled': 'Add to scheduled list',
	    'refresh': 'Refresh',
	    'openAll': 'Open all',
	    'normal': 'Normal',
	    'disableAll': 'Disable all',
	    'open': 'Open',
	    'save-scheduled': 'Schedule save',
	    'send': 'Save',
	    'accept': 'Accept',
	    'emergency': 'Emergency',
	    'confirm': 'Confirm'
	  },
	  'operation': {
	    'sync': 'Sync',
	    'edit': 'Edit',
	    'delete': 'Remove',
	    'activate': 'Activate',
	    'disable': 'Disable',
	    'on': 'On',
	    'off': 'Off',
	    'toggle': 'Toggle',
	    'disable-scheduled': 'Scheduled disable',
	    'activate-scheduled': 'Scheduled activate',
	    'delete-scheduled': 'Scheduled remove',
	    'restore': 'Transfer',
	    'single-access': 'Accesses'
	  },
	  'nav': {
	    'home': 'Home',
	    'owner-list': 'Owners',
	    'organization-list': 'Organizations',
	    'user-list': 'Users',
	    'persons-list': 'Persons',
	    'user-level-list': 'User profiles',
	    'logout': 'Logout',
	    'changeLanguage': 'Switch language',
	    'administration': 'Administration',
	    'devices': 'Devices',
	    'server-details': 'Server',
	    'controller-list': 'Controllers',
	    'switch-list': 'Switches',
	    'switch-group-list': 'Switch groups',
	    'mobile-list': 'Mobiles and ID Cards',
	    'mobile-group-list': 'Mobile groups',
	    'location-list': 'Locations',
	    'scheduled-jobs': 'Scheduled jobs',
	    'monitoring': 'Monitoring',
	    'event-list': 'Events',
	    'event-list-entry': 'Entry events',
	    'event-list-registration': 'Registrations',
	    'event-list-system': 'System messages',
	    'event-list-input': 'Sensor events',
	    'preregistration-list': 'Keycodes - pregistrations',
	    'pending-access-list': 'Pending accesses',
	    'access-schemes-list': 'Accesses profiles',
	    'external-service-list': 'External services',
	    'system-parameter-list': 'System preferences'
	  },
	  'lang': {
	    'hungarian': 'Hungarian',
	    'english': 'English'
	  },
	  'secType': {
	    'none': 'None',
	    'WEP': 'WEP',
	    'WPA': 'WPA-PSK',
	    'WPA2': 'WPA2-PSK'
	  },
	  'header.mobile.contact_name': 'Mobile Identifier',
	  'header.switch.name': 'Switch name',
	  'header': {
	    'organization': 'Organization',
	    'address': 'Address',
	    'access-registration-status': 'Processing status',
	    'status': 'Connection status',
	    'rssi': 'WiFi RSSI',
	    'ip': 'IP address',
	    'mobileGroupName': 'Mobile group name',
	    'switchGroupName': 'Switch group name',
	    'controllerDescription': 'Description',
	    'success': 'Acceptance',
	    'controllerNames': 'Granted accesses',
	    'userLevel': 'User level',
	    'id': 'Id',
	    'operations': 'Operations',
	    'name': 'Name',
	    'email': 'Email',
	    'server_name': 'Server name',
	    'controllerName': 'Controller',
	    'state': 'Status',
	    'contact_name': 'Identifier',
	    'fqdn': 'FQDN',
	    'param': 'Parameter',
	    'userName': 'Identifier',
	    'contactRefid': 'Person',
	    'contact_refid': 'Person',
	    'first_name': 'First name',
	    'last_name': 'Last name',
	    'regcode': 'Keycode',
	    'description': 'Description',
	    'owner': 'Owner',
	    'mobileName': 'Access name',
	    'switchName': 'Switch name',
	    'key_type': 'Key type',
	    'type': 'Type',
	    'url': 'Service URL',
	    'attempts': 'Attempts',
	    'occured': 'Date'
	  },
	  'tab': {
	    'notifications': 'Notifications',
	    'groups': 'Groups',
	    'command': 'Test MQTT',
	    'tx-power': 'BLE TX power',
	    'inputs': 'Sensors',
	    'details': 'Details',
	    'serverAccesses': 'Server accesses',
	    'controller-details': 'Name',
	    'switches': 'Switches',
	    'monitoring-settings': 'Monitoring setup',
	    'settings': 'Settings',
	    'controller-wifi-settings': 'WiFi setup',
	    'in-progress-accesses': 'Processing..',
	    'controller-diagnosis': 'Status',
	    'readers': 'Reader setup'
	  },
	  'placeholder': {
	    'mobile_group': 'Mobile group',
	    'switch_group': 'Switch group',
	    'owner_id': 'Select owner (type to filter)',
	    'user_level_id': 'Select user level (type to filter)',
	    'search': 'Search',
	    'input_type': 'Select input type',
	    'type': 'Select type',
	    'select-a-date': 'Select a date',
	    'select-days': 'Select the days',
	    'selectComponent': 'Select a component',
	    'mobileId': 'Select a mobile (optional)',
	    'eventTypeId': 'Select an event type (optional)'
	  },
	  'related-organizations': 'Related organizations',
	  'related-users': 'Related users',
	  'related-mobiles': 'Related mobiles',
	  'related-switches': 'Related switches',
	  'related-servers': 'Related servers',
	  'empty-table': 'No results',
	  'tab.dashboard': 'Dashboard',
	  'switch': 'Switch',
	  'switch.entry-point': 'Entry point',
	  'switch.hidden-system': 'Hidden system',
	  'regStatus': {
	    'none': 'Unassigned',
	    'pending': 'Pending',
	    'active': 'Active',
	    'disabled': 'Disabled',
	    'inprogress': 'Processing..'
	  },
	  'keyType': {
	    'constant': 'Constant',
	    'temporary': 'Temporary',
	    'recurring': 'Recurring'
	  },
	  'switchType': {
	    'gate': 'Gate',
	    'garage': 'Garage',
	    'switch': 'Switch',
	    'light': 'Light'
	  },
	  'inputType': {
	    'None': 'None',
	    'Switch1Toggle': 'Switch #1 Toggle',
	    'Switch2Toggle': 'Switch #2 Toggle',
	    'Switch3Toggle': 'Switch #3 Toggle',
	    'Switch4Toggle': 'Switch #4 Toggle',
	    'Switch1On': 'Switch #1 On',
	    'Switch2On': 'Switch #2 On',
	    'Switch3On': 'Switch #3 On',
	    'Switch4On': 'Switch #4 On',
	    'AllSwitchOn': 'All Switch On',
	    'Switch1Off': 'Switch #1 Off',
	    'Switch2Off': 'Switch #2 Off',
	    'Switch3Off': 'Switch #3 Off',
	    'Switch4Off': 'Switch #4 Off',
	    'AllSwitchOff': 'All Switch Off',
	    'OpenSensor': 'Open Sensor',
	    'Dorbell': 'Dorbell',
	    'FireAlarm': 'Fire Alarm',
	    'SecurityAlarm': 'Security Alarm',
	    'TermalSensor': 'Termal Sensor',
	    'MoveSensor': 'Move Sensor',
	    'OtherSensor': 'Other Sensor'
	  },
	  'eventType': {
	    'AccessCreated': 'Create access',
	    'AccessSent': 'Access sent',
	    'MqttMessageId': 'ACK Message',
	    'ExternalServerMessageSendingTimeout': 'External service timeout',
	    'ControllerWifiReconnection': 'WiFi connect',
	    'ControllerMqttReconnection': 'MQTT connect',
	    'SetControllerDescription': 'Update Controller info',
	    'SetSwitchDescription': 'Switch settings update',
	    'PendingAccessApproved': 'Access arrived to controller',
	    'PendingAccessSaved': 'Access queued for sending',
	    'RequestRegistration': 'Request registration',
	    'AcceptRegistration': 'Accept registration',
	    'DisableRegistration': 'Disable registration',
	    'DeleteRegistration': 'Delete registration',
	    'ActivateRegcode': 'Activate regcode',
	    'ToggleSwitch': 'Toggle switch',
	    'GetRegistrations': 'List keys',
	    'GetRegistrationDetails': 'Key details',
	    'GetLogEntries': 'List events',
	    'GetDiagnosis': 'Show controller info',
	    'SetControllerTime': 'Update controller time',
	    'FailedSetControllerDescription': 'Failed Command r201',
	    'FailedSetSwitchDescription': 'Failed Command r301',
	    'FailedRequestRegistration': 'Failed Command r401',
	    'FailedAcceptRegistration': 'Failed Command r501',
	    'FailedDisableRegistration': 'Failed Command r601',
	    'FailedDeleteRegistration': 'Failed Command r701',
	    'FailedActivateRegcode': 'Failed Command r901',
	    'FailedToggleSwitch': 'Toggle switch failed',
	    'FailedGetRegistrations': 'Failed Command r111',
	    'FailedGetRegistrationDetails': 'Failed Command r211',
	    'FailedGetLogEntries': 'Failed Command r311',
	    'FailedGetDiagnosis': 'Failed Command r411',
	    'FailedSetControllerTime': 'Failed Command r511',
	    'Switch1Toggle': 'Switch #1 Toggle',
	    'Switch2Toggle': 'Switch #2 Toggle',
	    'Switch3Toggle': 'Switch #3 Toggle',
	    'Switch4Toggle': 'Switch #4 Toggle',
	    'Switch1On': 'Switch #1 On',
	    'Switch2On': 'Switch #2 On',
	    'Switch3On': 'Switch #3 On',
	    'Switch4On': 'Switch #4 On',
	    'AllSwitchOn': 'All Switch On',
	    'Switch1Off': 'Switch #1 Off',
	    'Switch2Off': 'Switch #2 Off',
	    'Switch3Off': 'Switch #3 Off',
	    'Switch4Off': 'Switch #4 Off',
	    'AllSwitchOff': 'All Switch Off',
	    'OpenSensor': 'Open Sensor',
	    'Dorbell': 'Dorbell',
	    'FireAlarm': 'Fire Alarm',
	    'SecurityAlarm': 'Security Alarm',
	    'TermalSensor': 'Termal Sensor',
	    'MoveSensor': 'Move Sensor',
	    'OtherSensor': 'Other Sensor'
	  },
	  'event': {
	    'toggle': {
	      'type': {
	        'bt': 'Mobile',
	        'rfid': 'IDCard',
	        'qr': 'QR'
	      },
	      'success': 'Accepted',
	      'fail': 'Rejected',
	      'fail-undefined': 'Learning Undefined',
	      'fail-out-of-interval': 'Time rejected',
	      'fail-unregistered': 'Unregistered'
	    }
	  },
	  'format': {
	    'longDate': 'YYYY.MM.DD HH:mm:ss'
	  },
	  'remove.message': 'Do you really want to delete?',
	  'error': {
	    'dedicated_username': 'The Server word is reserved!'
	  },
	
	  el: {
	    colorpicker: {
	      confirm: 'OK',
	      clear: 'Clear'
	    },
	    datepicker: {
	      now: 'Now',
	      today: 'Today',
	      cancel: 'Cancel',
	      clear: 'Clear',
	      confirm: 'OK',
	      selectDate: 'Select date',
	      selectTime: 'Select time',
	      startDate: 'Start Date',
	      startTime: 'Start Time',
	      endDate: 'End Date',
	      endTime: 'End Time',
	      year: '',
	      month1: 'Jan',
	      month2: 'Feb',
	      month3: 'Mar',
	      month4: 'Apr',
	      month5: 'May',
	      month6: 'Jun',
	      month7: 'Jul',
	      month8: 'Aug',
	      month9: 'Sep',
	      month10: 'Oct',
	      month11: 'Nov',
	      month12: 'Dec',
	
	      weeks: {
	        sun: 'Sun',
	        mon: 'Mon',
	        tue: 'Tue',
	        wed: 'Wed',
	        thu: 'Thu',
	        fri: 'Fri',
	        sat: 'Sat'
	      },
	      months: {
	        jan: 'Jan',
	        feb: 'Feb',
	        mar: 'Mar',
	        apr: 'Apr',
	        may: 'May',
	        jun: 'Jun',
	        jul: 'Jul',
	        aug: 'Aug',
	        sep: 'Sep',
	        oct: 'Oct',
	        nov: 'Nov',
	        dec: 'Dec'
	      }
	    },
	    select: {
	      loading: 'Loading',
	      noMatch: 'No matching data',
	      noData: 'No data',
	      placeholder: 'Select'
	    },
	    cascader: {
	      noMatch: 'No matching data',
	      placeholder: 'Select'
	    },
	    pagination: {
	      goto: 'Go to',
	      pagesize: '/page',
	      total: 'Total {total}',
	      pageClassifier: ''
	    },
	    messagebox: {
	      title: 'Message',
	      confirm: 'OK',
	      cancel: 'Cancel',
	      error: 'Illegal input'
	    },
	    upload: {
	      delete: 'Delete',
	      preview: 'Preview',
	      continue: 'Continue'
	    },
	    table: {
	      emptyText: 'No Data',
	      confirmFilter: 'Confirm',
	      resetFilter: 'Reset',
	      clearFilter: 'All'
	    },
	    tree: {
	      emptyText: 'No Data'
	    }
	  }
	};

/***/ }),
/* 449 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'login.welcome': 'Welcome',
	  'none': 'Ismeretlen'
	};

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(87);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	console.log('isEnterprise', (0));
	
	_vue2.default.mixin({
	  computed: {
	    loggedIn: function loggedIn() {
	      return _store2.default.getters['loggedIn'];
	    },
	    isEnterprise: function isEnterprise() {
	      return !!(0);
	    }
	  },
	  methods: {
	    hasPermission: function hasPermission(permission, serverId) {
	      var hasPermission = _store2.default.getters['hasPermission']({ permission: permission, serverId: serverId });
	
	      if (!hasPermission) {
	        console.warn('No permission: ' + permission);
	      }
	
	      return hasPermission;
	    },
	    showSuccess: function showSuccess(message) {
	      _store2.default.commit('SHOW_NOTIFICATION', { message: message, type: 'success' });
	    },
	    showInfo: function showInfo(message) {
	      _store2.default.commit('SHOW_NOTIFICATION', { message: message, type: 'info' });
	    },
	    showError: function showError(message) {
	      _store2.default.commit('SHOW_NOTIFICATION', { message: message, type: 'error' });
	    },
	    showWarning: function showWarning(message) {
	      _store2.default.commit('SHOW_NOTIFICATION', { message: message, type: 'warning' });
	    }
	  }
	});

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(203);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _slicedToArray2 = __webpack_require__(102);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.default = function (files) {
	  if (!files) {
	    console.warn('No file to read');
	
	    return null;
	  }
	
	  var file = files;
	
	  if (_lodash2.default.isArray(files)) {
	    if (!files.length) {
	      console.warn('No file to read');
	
	      return null;
	    }
	
	    var _files = (0, _slicedToArray3.default)(files, 1);
	
	    file = _files[0];
	  } else if (_lodash2.default.isString(files) && files.startsWith('data:')) {
	    return files;
	  }
	
	  if (!(file instanceof Blob)) {
	    console.warn('No file to read');
	
	    return null;
	  }
	
	  return new _promise2.default(function (res, rej) {
	    var reader = new FileReader();
	
	    reader.onload = function () {
	      if (reader.error) {
	        return rej(reader.error);
	      }
	
	      return res(reader.result);
	    };
	
	    reader.readAsDataURL(file);
	  });
	};
	
	var _lodash = __webpack_require__(75);
	
	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(1042);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _auth = __webpack_require__(101);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _routes = __webpack_require__(59);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _store = __webpack_require__(87);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: _routes2.default
	});
	
	router.beforeEach(function (to, from, next) {
	  if (!_auth2.default.loggedIn() && to.name !== _routes.LOGIN) {
	    var newTo = {
	      name: _routes.LOGIN
	    };
	
	    if (to.name !== _routes.HOME) {
	      newTo.query = { redirect: to.fullPath };
	    }
	
	    next(newTo);
	  } else if (_auth2.default.user.needSetupGuide) {
	    next({
	      name: _routes.WELCOME
	    });
	  } else {
	    var permission = to.meta.permission;
	
	    if (permission && !_store2.default.getters['hasPermission']({ permission: permission })) {
	      return next(from);
	    }
	
	    next();
	  }
	});
	
	exports.default = router;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _http = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  methods: {
	    activateAccess: function activateAccess(access, scheduled) {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return (0, _http.post)('api/v1/mobile-accesses/activate/' + access.id, { scheduled: scheduled });
	
	              case 3:
	
	                _this.showSuccess('access-activated');
	                _context.next = 9;
	                break;
	
	              case 6:
	                _context.prev = 6;
	                _context.t0 = _context['catch'](0);
	
	                console.error(_context.t0);
	
	              case 9:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[0, 6]]);
	      }))();
	    },
	    disableAccess: function disableAccess(access, scheduled) {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.prev = 0;
	                _context2.next = 3;
	                return (0, _http.post)('api/v1/mobile-accesses/disable/' + access.id, { scheduled: scheduled });
	
	              case 3:
	
	                _this2.showSuccess('access-disabled');
	                _context2.next = 9;
	                break;
	
	              case 6:
	                _context2.prev = 6;
	                _context2.t0 = _context2['catch'](0);
	
	                console.error(_context2.t0);
	
	              case 9:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2, [[0, 6]]);
	      }))();
	    },
	    deleteAccess: function deleteAccess(access, scheduled) {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.prev = 0;
	                _context3.next = 3;
	                return (0, _http.post)('api/v1/mobile-accesses/delete/' + access.id, { scheduled: scheduled });
	
	              case 3:
	
	                _this3.showSuccess('access-deleted');
	                _context3.next = 9;
	                break;
	
	              case 6:
	                _context3.prev = 6;
	                _context3.t0 = _context3['catch'](0);
	
	                console.error(_context3.t0);
	
	              case 9:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this3, [[0, 6]]);
	      }))();
	    },
	    getPendingAccesses: function getPendingAccesses() {
	      return (0, _http.get)('api/v1/mobile-accesses/pending');
	    }
	  }
	};

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _defineProperty2 = __webpack_require__(52);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _lodash = __webpack_require__(75);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _http = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (namespace, computedNameOrFuncs, searchConfig, funcs) {
	  var computedName = computedNameOrFuncs;
	  var functions = funcs;
	
	  if (_lodash2.default.isObject(computedNameOrFuncs)) {
	    computedName = namespace;
	    searchConfig = computedNameOrFuncs;
	    functions = searchConfig;
	  }
	
	  return {
	    data: function data() {
	      return (0, _defineProperty3.default)({}, computedName + 'Results', []);
	    },
	
	    computed: (0, _defineProperty3.default)({}, computedName || namespace, function () {
	      var entities = this[computedName + 'Results'];
	
	      if (functions && functions.filter) {
	        entities = entities.filter(functions.filter.bind(this));
	      }
	
	      if (functions && functions.map) {
	        entities = entities.map(functions.map.bind(this));
	      }
	
	      if (functions && functions.sort) {
	        entities = entities.sort(functions.sort.bind(this));
	      }
	
	      return entities;
	    }),
	    methods: (0, _defineProperty3.default)({}, 'fetch' + capitalizeFirstLetter(computedName), function () {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var params, _ref2, data;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                params = _lodash2.default.isFunction(searchConfig) ? searchConfig.call(_this, _this) : searchConfig;
	                _context.next = 3;
	                return (0, _http.post)('api/v1/' + namespace + '/search', params);
	
	              case 3:
	                _ref2 = _context.sent;
	                data = _ref2.data;
	
	
	                _this[computedName + 'Results'] = data;
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    }),
	    beforeMount: function beforeMount() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this2['fetch' + capitalizeFirstLetter(computedName)]();
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    }
	  };
	};
	
	function capitalizeFirstLetter(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moduleFactory = __webpack_require__(130);
	
	var _moduleFactory2 = _interopRequireDefault(_moduleFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var namespace = 'app-functions';
	
	var store = (0, _moduleFactory2.default)(namespace);
	
	var data = store.getters.data;
	
	store.getters.data = function (state) {
	  return function (dispatch) {
	    return data(state)(dispatch).map(function (f) {
	      return { id: f.id, name: 'permission.' + f.id };
	    });
	  };
	};
	
	exports.default = store;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(76);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _moduleFactory = __webpack_require__(130);
	
	var _moduleFactory2 = _interopRequireDefault(_moduleFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var namespace = 'scheduled-jobs';
	
	var store = (0, _moduleFactory2.default)(namespace);
	
	var data = store.getters.data;
	
	store.getters.data = function (state) {
	  return function (dispatch) {
	    return data(state)(dispatch).map(function (f) {
	      f.payload = (0, _stringify2.default)(f.payload);
	
	      return f;
	    });
	  };
	};
	
	exports.default = store;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _socket = __webpack_require__(128);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socketPlugin = function socketPlugin(store) {
	  _socket2.default.on('modelChanged', function (_ref) {
	    var namespace = _ref.namespace,
	        id = _ref.id,
	        operation = _ref.operation;
	
	    console.debug('modelChanged', namespace, id, operation);
	
	    if (id) {
	      switch (operation) {
	        case 'create':
	        case 'edit':
	          store.commit(namespace + '/addToChanges', id);
	
	          break;
	        case 'delete':
	          store.commit(namespace + '/removeOne', { id: id });
	
	          return;}
	    }
	
	    store.commit(namespace + '/setForceUpdate', true);
	  });
	
	  store.subscribe(function (_ref2, state) {
	    var type = _ref2.type,
	        payload = _ref2.payload;
	  });
	};
	
	exports.default = socketPlugin;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(202);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.filter = function (obj, predicate) {
	  return (0, _keys2.default)(obj).filter(function (key) {
	    return predicate(obj[key]);
	  }).reduce(function (res, key) {
	    res[key] = obj[key];
	    return res;
	  }, {});
	};
	
	Object.forEach = function (obj, callback) {
	  return (0, _keys2.default)(obj).map(function (key) {
	    return { key: key, value: obj[key] };
	  }).forEach(callback);
	};

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(418);
	
	var _Notification = __webpack_require__(902);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _NavigationBar = __webpack_require__(901);
	
	var _NavigationBar2 = _interopRequireDefault(_NavigationBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { NavigationBar: _NavigationBar2.default, Notification: _Notification2.default },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['loggedIn']))
	};

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'base-list',
	  data: function data() {
	    return {
	      modelToDelete: null
	    };
	  },
	
	  props: {
	    model: {
	      type: String,
	      required: true
	    },
	    sModel: {
	      type: String,
	      required: true
	    },
	    serverId: {
	      type: String,
	      default: 'server_id'
	    },
	    columns: {
	      type: Array,
	      required: true
	    },
	    hideEditOperation: {
	      type: Boolean,
	      default: false
	    },
	    hideDeleteOperation: {
	      type: Boolean,
	      default: false
	    },
	    hideAddNew: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    detailsRouteName: function detailsRouteName() {
	      return this.sModel + '-edit';
	    },
	    operations: function operations() {
	      var _this = this;
	
	      return [{
	        label: 'edit',
	        icon: 'edit',
	        permission: [this.editPermission, this.model[this.serverId]],
	        precondition: function precondition() {
	          return !_this.hideEditOperation;
	        },
	        method: function method(model) {
	          return _this.$router.push({ name: _this.sModel + '-edit', params: { 'id': model.id } });
	        }
	      }, {
	        label: 'delete',
	        type: 'danger',
	        icon: 'delete',
	        permission: [this.deletePermission, this.model[this.serverId]],
	        precondition: function precondition() {
	          return !_this.hideDeleteOperation;
	        },
	        method: function method(model) {
	          return _this.modelToDelete = model;
	        }
	      }];
	    },
	    createPermission: function createPermission() {
	      return 'CREATE_' + this.sModel.toUpperCase().replace('-', '_');
	    },
	    editPermission: function editPermission() {
	      return 'EDIT_' + this.sModel.toUpperCase().replace('-', '_');
	    },
	    deletePermission: function deletePermission() {
	      return 'DELETE_' + this.sModel.toUpperCase().replace('-', '_');
	    },
	    loading: function loading() {
	      return this.$store.getters[this.model + '/loading'];
	    }
	  },
	  methods: {
	    addNew: function addNew() {
	      this.$router.push({ name: this.detailsRouteName, params: { 'id': 'new' } });
	    },
	    deleteModel: function deleteModel() {
	      this.$store.dispatch(this.model + '/delete', this.modelToDelete);
	      this.modelToDelete = null;
	    }
	  }
	};

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(76);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(51);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vueGridLayout = __webpack_require__(894);
	
	var _LiveEdit = __webpack_require__(899);
	
	var _LiveEdit2 = _interopRequireDefault(_LiveEdit);
	
	var _SystemTime = __webpack_require__(917);
	
	var _SystemTime2 = _interopRequireDefault(_SystemTime);
	
	var _SystemLocation = __webpack_require__(916);
	
	var _SystemLocation2 = _interopRequireDefault(_SystemLocation);
	
	var _EventTable = __webpack_require__(191);
	
	var _EventTable2 = _interopRequireDefault(_EventTable);
	
	var _EventTableConfig = __webpack_require__(192);
	
	var _EventTableConfig2 = _interopRequireDefault(_EventTableConfig);
	
	var _LANStatus = __webpack_require__(914);
	
	var _LANStatus2 = _interopRequireDefault(_LANStatus);
	
	var _SwitchControll = __webpack_require__(915);
	
	var _SwitchControll2 = _interopRequireDefault(_SwitchControll);
	
	var _EmergencyFunctions = __webpack_require__(913);
	
	var _EmergencyFunctions2 = _interopRequireDefault(_EmergencyFunctions);
	
	var _EventStatistics = __webpack_require__(919);
	
	var _EventStatistics2 = _interopRequireDefault(_EventStatistics);
	
	var _EventStatisticsConfig = __webpack_require__(920);
	
	var _EventStatisticsConfig2 = _interopRequireDefault(_EventStatisticsConfig);
	
	var _defaultDashboard = __webpack_require__(446);
	
	var _defaultDashboard2 = _interopRequireDefault(_defaultDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dashboard',
	  data: function data() {
	    var dashboardItems = [{
	      label: 'label.systemTime',
	      value: {
	        title: this.$t('label.systemTime'),
	        name: 'SystemTime',
	        w: 1,
	        h: 8,
	        needsPadding: true
	      }
	    }, {
	      label: 'label.serverLocation',
	      value: {
	        title: this.$t('label.serverLocation'),
	        name: 'SystemLocation',
	        w: 1,
	        h: 8,
	        needsPadding: true
	      }
	    }, {
	      label: 'label.events',
	      value: {
	        title: this.$t('label.events'),
	        name: 'EventTable',
	        configName: 'EventTableConfig',
	        w: 2,
	        h: 45,
	        isConfiguring: false,
	        properties: {
	          showSearch: false }
	      }
	    }, {
	      label: 'label.LAN-status',
	      value: {
	        title: this.$t('label.LAN-status'),
	        name: 'LANStatus',
	        w: 1,
	        h: 20,
	        needsPadding: true
	      }
	    }, {
	      label: 'label.switch-controll',
	      value: {
	        title: this.$t('label.switch-controll'),
	        name: 'SwitchControll',
	        w: 1,
	        h: 20,
	        needsPadding: true
	      }
	    }, {
	      label: 'label.emergency-functions',
	      value: {
	        title: this.$t('label.emergency-functions'),
	        name: 'EmergencyFunctions',
	        w: 1,
	        h: 9,
	        needsPadding: true
	      }
	    }, {
	      label: 'label.event-statistics',
	      value: {
	        title: this.$t('label.event-statistics'),
	        name: 'EventStatistics',
	        w: 2,
	        h: 40,
	        needsPadding: true,
	        configName: 'EventStatisticsConfig',
	        isConfiguring: false
	      }
	    }];
	    return {
	      layout: window.localStorage.layout ? JSON.parse(window.localStorage.layout) : _defaultDashboard2.default,
	      frozen: false,
	      selectedComponent: null,
	      dashboardItems: dashboardItems,
	      options: dashboardItems.map(function (_ref) {
	        var label = _ref.label,
	            value = _ref.value;
	        return { label: label, value: value.name };
	      })
	    };
	  },
	
	  methods: {
	    addDashoardItem: function addDashoardItem() {
	      var _this = this;
	
	      var maxY = this.layout.map(function (i) {
	        return i.y;
	      }).reduce(function (a, i) {
	        return i > a ? i : a;
	      }, 0);
	      var component = (0, _assign2.default)({}, this.dashboardItems.find(function (i) {
	        return i.value.name === _this.selectedComponent;
	      }).value);
	
	      this.layout.push({
	        'x': 0,
	        'y': maxY + 1,
	        'w': component.w || 2,
	        'h': component.h || 20,
	        'i': this.layout.length + '',
	        component: component
	      });
	
	      this.selectedComponent = null;
	    },
	    updateComponent: function updateComponent(component, properties) {
	      component.properties = (0, _assign2.default)({}, component.properties, properties);
	    },
	    removeComponent: function removeComponent(i) {
	      this.layout = this.layout.filter(function (item) {
	        return item.i !== i;
	      });
	    }
	  },
	  watch: {
	    layout: {
	      handler: function handler(layout) {
	        window.localStorage.layout = (0, _stringify2.default)(layout);
	      },
	
	      deep: true
	    }
	  },
	  components: {
	    GridLayout: _vueGridLayout.GridLayout,
	    GridItem: _vueGridLayout.GridItem,
	    LiveEdit: _LiveEdit2.default,
	    SystemTime: _SystemTime2.default,
	    SystemLocation: _SystemLocation2.default,
	    EventTable: _EventTable2.default,
	    EventTableConfig: _EventTableConfig2.default,
	    LANStatus: _LANStatus2.default,
	    SwitchControll: _SwitchControll2.default,
	    EmergencyFunctions: _EmergencyFunctions2.default,
	    EventStatistics: _EventStatistics2.default,
	    EventStatisticsConfig: _EventStatisticsConfig2.default
	  }
	};

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(51);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _stringify = __webpack_require__(76);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(102);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(201);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _keys = __webpack_require__(202);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(75);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dequal = __webpack_require__(810);
	
	var _dequal2 = _interopRequireDefault(_dequal);
	
	var _readFileAsync = __webpack_require__(451);
	
	var _readFileAsync2 = _interopRequireDefault(_readFileAsync);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'data-form',
	  props: {
	    entity: {
	      type: Object,
	      required: true
	    },
	    fields: {
	      type: Object,
	      required: true
	    },
	    model: {
	      type: String
	    },
	    size: {
	      type: String,
	      default: 'large'
	    },
	    cancel: {
	      default: true
	    },
	    cancelAction: {
	      type: Function
	    },
	    labelPosition: {
	      default: 'right'
	    },
	    submitLabel: {
	      default: 'submit'
	    },
	    beforeSubmit: {
	      type: Function,
	      default: function _default() {}
	    },
	    afterSubmit: {
	      type: Function,
	      default: function _default() {}
	    },
	    loading: {
	      type: Boolean,
	      default: false
	    },
	    hideButtons: {
	      type: Boolean,
	      default: false
	    },
	    labelWidth: {
	      default: '150px'
	    },
	    buttons: {
	      type: Array
	    },
	    ignoreEntityChanges: {
	      type: Boolean,
	      default: false
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      formModel: _lodash2.default.cloneDeep(this.entity),
	      formFields: this.fields,
	      isLoading: false,
	      cachedRules: null,
	      changeCount: 0
	    };
	  },
	
	  computed: {
	    rules: function rules() {
	      var _this = this;
	
	      var rules = {};
	
	      (0, _keys2.default)(this.formFields).forEach(function (key) {
	        var entry = _this.formFields[key];
	
	        if (!entry.rules) return;
	
	        rules[key] = entry.rules;
	
	        rules[key].forEach(function (rule) {
	          rule.trigger = rule.trigger !== 'change' ? 'blur' : 'change';
	        });
	      });
	
	      return rules;
	    },
	    visibleFormFields: function visibleFormFields() {
	      return (0, _entries2.default)(this.formFields).map(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            key = _ref2[0],
	            value = _ref2[1];
	
	        return (0, _extends3.default)({}, value, {
	          key: key
	        });
	      }).filter(function (ff) {
	        return !ff.hidden;
	      });
	    }
	  },
	  watch: {
	    entity: function entity(val) {
	      if (this.changeCount > 1 && this.ignoreEntityChanges) {
	        console.debug('[Dataform] Ignoring dataform update (ignoreEntityChanges)');
	
	        return;
	      }
	
	      var newValue = _lodash2.default.cloneDeep(val);
	
	      if ((0, _dequal2.default)(this.formModel, newValue)) {
	        console.debug('[Dataform] Ignoring unchanged value');
	
	        return;
	      }
	
	      this.formModel = newValue;
	      this.changeCount++;
	
	      this.change();
	    },
	
	    fields: {
	      handler: function handler(val) {
	        this.formFields = val;
	      },
	
	      deep: true
	    },
	    loading: function loading(val) {
	      this.isLoading = val;
	    },
	
	    rules: {
	      handler: function handler(val, last) {
	        if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(last)) {
	          this.cachedRules = val;
	        }
	      },
	
	      deep: true,
	      immediate: true
	    }
	  },
	  methods: {
	    getPreview: function getPreview(key) {
	      if (!this.formModel[key]) {
	        return this.fields[key].preview;
	      }
	
	      return this.formModel[key].preview;
	    },
	    handleFileChange: function handleFileChange(key, file) {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var base64data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return (0, _readFileAsync2.default)(file.raw);
	
	              case 2:
	                base64data = _context.sent;
	
	
	                _this2.$set(_this2.formModel, key, {
	                  content: base64data,
	                  name: file.name,
	                  preview: URL.createObjectURL(file.raw)
	                });
	
	                _this2.change();
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }))();
	    },
	    validate: function validate(button) {
	      var _this3 = this;
	
	      this.$refs.form.validate(function (valid) {
	        if (!valid) return;
	
	        if (_this3.model && (!button || button.submit)) {
	          _this3.submit(button);
	        } else {
	          _this3.$emit('submit', _this3.formModel);
	        }
	      });
	    },
	    submit: function submit(button) {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var formModel, action;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                formModel = (0, _assign2.default)({}, _this4.formModel);
	
	
	                if (button && button.params) {
	                  formModel = (0, _assign2.default)({}, formModel, button.params);
	                }
	
	                _this4.beforeSubmit(formModel);
	
	                _this4.isLoading = true;
	
	                _context2.prev = 4;
	                action = _this4.formModel.new ? 'create' : 'edit';
	                _context2.next = 8;
	                return _this4.$store.dispatch(_this4.model + '/' + action, formModel);
	
	              case 8:
	
	                _this4.afterSubmit(formModel);
	                _context2.next = 14;
	                break;
	
	              case 11:
	                _context2.prev = 11;
	                _context2.t0 = _context2['catch'](4);
	
	                console.error(_context2.t0);
	
	              case 14:
	                _context2.prev = 14;
	
	                _this4.isLoading = false;
	                return _context2.finish(14);
	
	              case 17:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this4, [[4, 11, 14, 17]]);
	      }))();
	    },
	    remoteMethod: function remoteMethod(field) {
	      var _this5 = this;
	
	      var filterHandler = this.formFields[field].filter;
	
	      if (!filterHandler) {
	        return;
	      }
	
	      return function (query) {
	        _this5.formFields[field].options = filterHandler(query);
	      };
	    },
	    onCancel: function onCancel() {
	      if (this.cancelAction) {
	        this.cancelAction();
	      } else {
	        this.$router.back();
	      }
	    },
	    changeNum: function changeNum(field) {
	      this.formModel[field] = parseInt(this.formModel[field]);
	
	      this.change();
	    },
	    change: function change() {
	      this.$emit('change', this.formModel);
	    }
	  }
	};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(52);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(13);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _lodash = __webpack_require__(75);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'data-table',
	  props: {
	    model: {
	      type: [String, Array],
	      required: true
	    },
	    columns: {
	      type: Array,
	      required: true
	    },
	    rowKey: {
	      type: String,
	      default: 'id'
	    },
	    size: {
	      type: Number,
	      default: 10
	    },
	
	    operations: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    plusCells: {
	      type: Array
	    },
	    isSelected: {
	      type: Function,
	      required: false
	    },
	    pagination: {
	      type: Array,
	      default: function _default() {
	        return ['top'];
	      }
	    },
	    singleSelect: {
	      default: false
	    },
	    showSearch: {
	      type: Boolean,
	      default: true
	    },
	    order: {
	      type: Object,
	      default: function _default() {
	        return {
	          sortBy: null,
	          ascending: true
	        };
	      }
	    },
	    disableLoadingIndicator: {
	      type: Boolean,
	      default: false
	    },
	    customSort: {
	      type: Function
	    }
	  },
	  data: function data() {
	    return {
	      isColumSelectorVisible: false,
	      selectedColumns: this.computeNormalizedColumns(),
	      currentPage: 1,
	      localSize: parseInt(localStorage.paginationSize) || this.size,
	      sortBy: this.order.sortBy,
	      ascending: this.order.ascending,
	      tableDataChanged: false,
	      searchText: null
	    };
	  },
	
	  computed: {
	    tableData: function tableData() {
	      if (typeof this.model === 'string') {
	        return this.$store.getters[this.model + '/data'](this.$store.dispatch);
	      } else if (this.model instanceof Array) {
	        return this.model;
	      }
	    },
	    filteredData: function filteredData() {
	      var _this = this;
	
	      var paginatedData = this.tableData.slice();
	
	      if (!this.searchText) {
	        return paginatedData;
	      }
	
	      return paginatedData.filter(function (item) {
	        var match = false;
	
	        Object.forEach(item, function (_ref) {
	          var key = _ref.key,
	              value = _ref.value;
	
	          if (!_this.columns.includes(key)) {
	            return;
	          }
	
	          if (value && value.includes instanceof Function && value.toLowerCase().includes(_this.searchText.toLowerCase())) {
	            match = true;
	          }
	        });
	
	        return match;
	      });
	    },
	    paginatedData: function paginatedData() {
	      var _this2 = this;
	
	      var paginatedData = this.filteredData;
	
	      paginatedData = paginatedData.sort(function (a, b) {
	        return _this2._sort(a, b) * (_this2.ascending ? 1 : -1);
	      });
	
	      var from = (this.currentPage - 1) * this.localSize;
	      var to = from + this.localSize;
	
	      return paginatedData.slice(from, to);
	    },
	    translatedData: function translatedData() {
	      var _this3 = this;
	
	      var translateColumns = this.columns.filter(function (c) {
	        return c.includes('[T]');
	      }).map(function (c) {
	        return c.replace('[T]', '');
	      });
	
	      return this.paginatedData.map(function (row) {
	        return (0, _extends4.default)({}, row, translateColumns.reduce(function (acc, curr) {
	          return (0, _extends4.default)({}, acc, (0, _defineProperty3.default)({}, curr, _this3.$t(row[curr])));
	        }, {}));
	      });
	    },
	    normalizedColumns: function normalizedColumns() {
	      return this.computeNormalizedColumns();
	    },
	    orderedSelectedColumns: function orderedSelectedColumns() {
	      var _this4 = this;
	
	      this.selectedColumns.sort(function (a, b) {
	        return _this4.normalizedColumns.indexOf(a) - _this4.normalizedColumns.indexOf(b);
	      });
	
	      return this.selectedColumns;
	    },
	    total: function total() {
	      return this.filteredData.length;
	    },
	    loading: function loading() {
	      if (this.disableLoadingIndicator) {
	        return false;
	      }
	
	      return this.$store.getters[this.model + '/loading'];
	    }
	  },
	  mounted: function mounted() {
	    this.tableDataChanged = true;
	  },
	  beforeUpdate: function beforeUpdate() {
	    var _this5 = this;
	
	    if (!this.tableDataChanged) return;
	    if (!this.isSelected || !this.$refs.table) return;
	
	    this.tableDataChanged = false;
	
	    this.tableData.forEach(function (row) {
	      _this5.$refs.table.toggleRowSelection(row, _this5.isSelected(row));
	    });
	  },
	
	  methods: {
	    isOperationVisible: function isOperationVisible(operation, row) {
	      if (!operation.precondition && !operation.permission) {
	        return true;
	      }
	
	      if (operation.permission) {
	        if (_lodash2.default.isArray(operation.permission) && !this.hasPermission(operation.permission[0], row[operation.permission[1]])) {
	          return false;
	        } else if (_lodash2.default.isString(operation.permission) && !this.hasPermission(operation.permission)) {
	          return false;
	        }
	      }
	
	      if (operation.precondition) {
	        if (_lodash2.default.isFunction(operation.precondition) && !operation.precondition(row)) {
	          return false;
	        }
	      }
	
	      return true;
	    },
	    handleSortChange: function handleSortChange(_ref2) {
	      var prop = _ref2.prop,
	          order = _ref2.order;
	
	      this.sortBy = prop;
	      this.ascending = order !== 'descending';
	    },
	    handleSizeChange: function handleSizeChange(size) {
	      this.localSize = size;
	      localStorage.paginationSize = size;
	    },
	    handleCurrentChange: function handleCurrentChange(currentPage) {
	      this.currentPage = currentPage;
	    },
	    handleSelectionChange: function handleSelectionChange(selection) {
	      this.$emit('selection-change', selection);
	    },
	    sortMethod: function sortMethod(a, b) {
	      return this._sort(a, b) === 1;
	    },
	    _sort: function _sort(a, b) {
	      if (this.customSort) {
	        return this.customSort(a, b);
	      }
	
	      var sortBy = this.sortBy || this.columns[0];
	
	      if (a[sortBy] instanceof String) {
	        return a[sortBy].localeCompare(b[sortBy]);
	      }
	
	      return a[sortBy] > b[sortBy] ? 1 : -1;
	    },
	    rowClick: function rowClick(row, event, column) {
	      this.$emit('row-click', row, event, column);
	    },
	    showOperationsColumn: function showOperationsColumn() {
	      var _this6 = this;
	
	      return this.operations.filter(function (op) {
	        return _this6.paginatedData.filter(function (row) {
	          return _this6.isOperationVisible(op, row);
	        }).length;
	      }).length;
	    },
	    computeNormalizedColumns: function computeNormalizedColumns() {
	      return this.columns.map(function (c) {
	        return c.replace('[T]', '');
	      });
	    }
	  },
	  watch: {
	    tableData: function tableData() {
	      this.tableDataChanged = true;
	    },
	    '$lang': function $lang() {
	      this.tableDataChanged = true;
	    },
	    size: function size(v) {
	      this.localSize = v;
	    },
	    columns: function columns() {
	      this.selectedColumns = this.computeNormalizedColumns();
	    }
	  }
	};

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(842);
	
	exports.default = {
	  name: 'fa-icon',
	  props: {
	    icon: {
	      type: String,
	      required: true
	    },
	    animated: {
	      type: Boolean,
	      default: false
	    },
	    size: String
	  },
	  computed: {
	    klass: function klass() {
	      var spin = this.animated ? 'fa-spin' : '';
	      return 'fa fa-' + this.icon + ' ' + spin;
	    }
	  }
	};

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'LiveEdit',
	  props: {
	    value: {
	      type: [String, Object],
	      required: true
	    },
	    editable: {
	      type: Boolean,
	      default: true
	    },
	    placeholder: {
	      type: String
	    }
	  },
	  data: function data() {
	    return {
	      modelvalue: this.value,
	      isEditing: false
	    };
	  },
	
	  methods: {
	    textClicked: function textClicked() {
	      if (this.editable) {
	        this.isEditing = true;
	      }
	    },
	    finalize: function finalize() {
	      this.isEditing = false;
	    }
	  },
	  watch: {
	    modelvalue: function modelvalue(val) {
	      this.$emit('input', val);
	    }
	  },
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        el.getElementsByTagName('input')[0].focus();
	      }
	    }
	  }
	};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _auth = __webpack_require__(101);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'login',
	  data: function data() {
	    return {
	      model: {
	        email: '',
	        password: ''
	      },
	      fields: {
	        email: {
	          type: 'email',
	          rules: [{ required: true }, { type: 'email' }]
	        },
	        password: {
	          type: 'password',
	          rules: [{ required: true }]
	        }
	      }
	    };
	  },
	
	  methods: {
	    submit: function submit(model) {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var redirect;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return _auth2.default.login(model.email, model.password);
	
	              case 3:
	                redirect = _this.$route.query.redirect || '/';
	
	
	                _this.$router.push(redirect);
	                _context.next = 9;
	                break;
	
	              case 7:
	                _context.prev = 7;
	                _context.t0 = _context['catch'](0);
	
	              case 9:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[0, 7]]);
	      }))();
	    }
	  }
	};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(51);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _routes = __webpack_require__(59);
	
	var _auth = __webpack_require__(101);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _locale = __webpack_require__(85);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'navigation-bar',
	  data: function data() {
	    return {
	      defaultRoute: this.$route
	    };
	  },
	
	  computed: {
	    routes: function routes() {
	      var routes = [];
	
	      this.$router.options.routes.filter(this._showItem).forEach(function (route) {
	        if (route.meta && route.meta.group) {
	          var submenu = routes.find(function (r) {
	            return r.name === route.meta.group;
	          });
	
	          if (!submenu) {
	            submenu = { name: route.meta.group, routes: [] };
	            routes.push(submenu);
	          }
	
	          submenu.routes.push(route);
	        } else {
	          routes.push(route);
	        }
	      });
	
	      return routes;
	    },
	    currentRoute: function currentRoute() {
	      return (0, _assign2.default)({}, this.$route);
	    }
	  },
	  methods: {
	    logout: function logout() {
	      _auth2.default.logout();
	      this.$router.push({ name: _routes.LOGIN });
	    },
	    changeLang: function changeLang(lang) {
	      _vue2.default.config.lang = lang;
	      _locale2.default.use(lang);
	
	      window.localStorage.lang = lang;
	    },
	    _showItem: function _showItem(_ref) {
	      var _ref$meta = _ref.meta,
	          meta = _ref$meta === undefined ? {} : _ref$meta;
	
	      if (meta.hideFromNav) {
	        return false;
	      }
	
	      if (meta.hideWhenLoggedIn && this.loggedIn) {
	        return false;
	      }
	
	      if (meta.permission && !this.hasPermission(meta.permission)) {
	        return false;
	      }
	
	      return true;
	    }
	  }
	};

/***/ }),
/* 468 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'notification',
	  computed: {
	    progress: function progress() {
	      return this.$store.state.progress;
	    },
	    notification: function notification() {
	      return this.$store.state.notification;
	    }
	  },
	  watch: {
	    progress: function progress(newValue, oldValue) {
	      var _this = this;
	
	      if (newValue > 0 && oldValue > 0) {
	        return;
	      }
	
	      if (newValue > 0) {
	        this.$Progress.start();
	      } else {
	        setTimeout(function () {
	          if (newValue <= 0) {
	            _this.$Progress.finish();
	          }
	        }, 400);
	      }
	    },
	    notification: function notification(_ref) {
	      var type = _ref.type,
	          message = _ref.message;
	
	      var notify = this.$notify.error;
	
	      if (type === 'success') {
	        notify = this.$notify.success;
	      } else if (type === 'warning') {
	        notify = this.$notify.warning;
	      } else if (type === 'info') {
	        notify = this.$notify.info;
	      }
	
	      notify({ title: this.$t(message) });
	    }
	  }
	};

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _stringify = __webpack_require__(76);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _DataTable = __webpack_require__(413);
	
	var _DataTable2 = _interopRequireDefault(_DataTable);
	
	var _AccessForm = __webpack_require__(414);
	
	var _AccessForm2 = _interopRequireDefault(_AccessForm);
	
	var _http = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'access-sheme-details',
	  data: function data() {
	    return {
	      groups: [],
	      currentTab: null,
	      selectedSwitchGroupId: null,
	      selectedMobileGroupId: null,
	      isLoading: false
	    };
	  },
	
	  computed: {
	    accessScheme: function accessScheme() {
	      var id = this.$route.params.id;
	
	      if (id === 'new') {
	        return { new: true };
	      }
	
	      return this.$store.getters['access-schemes/findById'](id, this.$store.dispatch);
	    },
	    action: function action() {
	      return this.accessScheme.new ? 'create' : 'edit';
	    }
	  },
	  methods: {
	    submit: function submit(formModel) {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var _formModel$id, id, name, user_level_id, key_type, start_date, _formModel$start_hour, start_hour, _formModel$start_minu, start_minute, end_date, _formModel$end_hour, end_hour, _formModel$end_minute, end_minute, _formModel$days, days, data;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _formModel$id = formModel.id, id = _formModel$id === undefined ? 'new' : _formModel$id, name = formModel.name, user_level_id = formModel.user_level_id, key_type = formModel.key_type, start_date = formModel.start_date, _formModel$start_hour = formModel.start_hour, start_hour = _formModel$start_hour === undefined ? formModel.duration[0].getHours() : _formModel$start_hour, _formModel$start_minu = formModel.start_minute, start_minute = _formModel$start_minu === undefined ? formModel.duration[0].getMinutes() : _formModel$start_minu, end_date = formModel.end_date, _formModel$end_hour = formModel.end_hour, end_hour = _formModel$end_hour === undefined ? formModel.duration[1].getHours() : _formModel$end_hour, _formModel$end_minute = formModel.end_minute, end_minute = _formModel$end_minute === undefined ? formModel.duration[1].getMinutes() : _formModel$end_minute, _formModel$days = formModel.days, days = _formModel$days === undefined ? (0, _stringify2.default)(formModel.days) : _formModel$days;
	                data = {
	                  name: name,
	                  user_level_id: user_level_id,
	                  key_type: key_type,
	                  start_date: start_date,
	                  days: days
	                };
	
	
	                if (key_type !== 'constant') {
	                  data.end_date = end_date;
	
	                  if (key_type !== 'temporary') {
	                    data.start_hour = start_hour;
	                    data.start_minute = start_minute;
	                    data.end_hour = end_hour;
	                    data.end_minute = end_minute;
	                  }
	                }
	
	                _context.prev = 3;
	                _context.next = 6;
	                return (0, _http.post)('api/v1/access-schemes/' + id, data);
	
	              case 6:
	
	                _this.showSuccess('access-scheme-saved');
	                _context.next = 13;
	                break;
	
	              case 9:
	                _context.prev = 9;
	                _context.t0 = _context['catch'](3);
	
	                console.error(_context.t0);
	
	                _this.showError('failed-to-save-access-scheme');
	
	              case 13:
	                _this.$router.back();
	
	              case 14:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[3, 9]]);
	      }))();
	    },
	    filterSwitchGroups: function filterSwitchGroups(query) {
	      return this.$store.getters['switch-groups/data'](this.$store.dispatch).map(function (i) {
	        return { label: i.name, value: i.id };
	      }).filter(function (i) {
	        return i.label.toLowerCase().includes((query || '').toLowerCase());
	      });
	    },
	    filterMobileGroups: function filterMobileGroups(query) {
	      return this.$store.getters['mobile-groups/data'](this.$store.dispatch).map(function (i) {
	        return { label: i.name, value: i.id };
	      }).filter(function (i) {
	        return i.label.toLowerCase().includes((query || '').toLowerCase());
	      });
	    },
	    submitGroups: function submitGroups() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                data = {
	                  accessSchemeId: _this2.accessScheme.id,
	                  switchGroupId: _this2.selectedSwitchGroupId,
	                  mobileGroupId: _this2.selectedMobileGroupId
	                };
	                _context2.prev = 1;
	                _context2.next = 4;
	                return (0, _http.post)('api/v1/access-schemes/set-groups', data);
	
	              case 4:
	                _this2.showSuccess('groups-updated');
	                _this2.getGroups();
	                _context2.next = 11;
	                break;
	
	              case 8:
	                _context2.prev = 8;
	                _context2.t0 = _context2['catch'](1);
	
	                console.error(_context2.t0);
	
	              case 11:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2, [[1, 8]]);
	      }))();
	    },
	    switchGroupSelected: function switchGroupSelected(switchGroupId) {
	      this.selectedSwitchGroupId = switchGroupId;
	    },
	    mobileGroupSelected: function mobileGroupSelected(mobileGroupId) {
	      this.selectedMobileGroup = mobileGroupId;
	    },
	    getGroups: function getGroups() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        var id, groups;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                id = _this3.$route.params.id;
	                _context3.prev = 1;
	                _context3.next = 4;
	                return (0, _http.post)('api/v1/mobile-access-groups/search', {
	                  accessSchemeId: id,
	                  size: 10000000000
	                });
	
	              case 4:
	                groups = _context3.sent;
	
	                _this3.groups = groups.data;
	                _context3.next = 11;
	                break;
	
	              case 8:
	                _context3.prev = 8;
	                _context3.t0 = _context3['catch'](1);
	
	                console.error(_context3.t0);
	
	              case 11:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this3, [[1, 8]]);
	      }))();
	    },
	    deleteMobileAccessGroup: function deleteMobileAccessGroup(row) {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        var id;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                id = row.id;
	                _context4.next = 3;
	                return (0, _http.deletex)('api/v1/mobile-access-groups/' + id);
	
	              case 3:
	                _this4.groups = _this4.groups.filter(function (g) {
	                  return g.id !== id;
	                });
	
	              case 4:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this4);
	      }))();
	    },
	    cancel: function cancel() {
	      this.$router.back();
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.getGroups();
	  },
	
	  components: { DataTable: _DataTable2.default, AccessForm: _AccessForm2.default }
	};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseList = __webpack_require__(46);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'access-scheme-list',
	  components: { BaseList: _BaseList2.default }
	};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(51);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(76);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _days = __webpack_require__(195);
	
	var _days2 = _interopRequireDefault(_days);
	
	var _userLevels = __webpack_require__(444);
	
	var _userLevels2 = _interopRequireDefault(_userLevels);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'access-form',
	  props: {
	    access: {
	      type: Object,
	      required: true
	    },
	    buttons: {
	      type: Array
	    },
	    additionalFields: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    hideUserLevel: {
	      type: Boolean,
	      default: false
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    showRegStatus: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    var formModel = this._fillDefaultsToAccess(this.access);
	
	    return {
	      unlocked: false,
	      formModel: formModel
	    };
	  },
	
	  computed: {
	    fields: function fields() {
	      var fields = {};
	
	      if (this.showRegStatus) {
	        fields = {
	          'registration_status_switch_value': {
	            type: 'switch',
	            label: 'has-access'
	          }
	        };
	
	        if (!this.formModel.registration_status_switch_value) {
	          return fields;
	        }
	      }
	
	      fields = (0, _extends3.default)({}, fields, {
	        'key_type': {
	          type: 'radio',
	          options: [{
	            value: 'constant',
	            label: 'keyType.constant'
	          }, {
	            value: 'temporary',
	            label: 'keyType.temporary'
	          }, {
	            value: 'recurring',
	            label: 'keyType.recurring'
	          }]
	        }
	      });
	
	      if (!this.hideUserLevel) {
	        fields = (0, _extends3.default)({
	          'user_level_id': {
	            type: 'select',
	            options: _userLevels2.default
	          }
	        }, fields);
	      }
	
	      if (this.formModel.key_type === 'constant') {
	        fields = (0, _extends3.default)({}, fields, {
	          'start_date': { type: 'datetime', format: 'yyyy-MM-dd HH:mm' }
	        });
	      } else if (this.formModel.key_type === 'temporary') {
	        fields = (0, _extends3.default)({}, fields, {
	          'start_date': { type: 'datetime', format: 'yyyy-MM-dd HH:mm' },
	          'end_date': { type: 'datetime', format: 'yyyy-MM-dd HH:mm' }
	        });
	      } else {
	        fields = (0, _extends3.default)({}, fields, {
	          'start_date': { type: 'date' },
	          'end_date': { type: 'date' },
	          'duration': { type: 'time', format: 'HH:mm' },
	          'days': {
	            type: 'select',
	            options: _days2.default,
	            multiple: true
	          }
	        });
	      }
	
	      return (0, _extends3.default)({}, this.additionalFields, fields);
	    }
	  },
	  methods: {
	    saveAccess: function saveAccess() {
	      this.submitAccess(true);
	    },
	    sendAccess: function sendAccess() {
	      this.submitAccess(false);
	    },
	    submitAccess: function submitAccess(scheduled) {
	      this.$emit('submit', this._formatAccess(this.formModel, scheduled), scheduled);
	      this.unlocked = false;
	    },
	    onChange: function onChange(val) {
	      this.formModel = val;
	      this.$emit('change', this._formatAccess(val));
	    },
	    _formatAccess: function _formatAccess(formModel, scheduled) {
	      var _formModel$id = formModel.id,
	          id = _formModel$id === undefined ? 'new' : _formModel$id,
	          switch_id = formModel.switch_id,
	          mobile_id = formModel.mobile_id,
	          user_id = formModel.user_id,
	          _formModel$registrati = formModel.registration_status,
	          registration_status = _formModel$registrati === undefined ? 'active' : _formModel$registrati,
	          user_level_id = formModel.user_level_id,
	          key_type = formModel.key_type,
	          start_date = formModel.start_date,
	          end_date = formModel.end_date;
	
	
	      if (this.showRegStatus && !formModel.registration_status_switch_value) {
	        return { registration_status: 'none' };
	      }
	
	      var data = {
	        id: id,
	        switch_id: switch_id,
	        mobile_id: mobile_id,
	        user_id: user_id,
	        registration_status: registration_status,
	        user_level_id: user_level_id,
	        key_type: key_type,
	        start_date: start_date,
	        scheduled: scheduled
	      };
	
	      if (key_type !== 'constant') {
	        data.end_date = end_date;
	
	        if (key_type !== 'temporary') {
	          var from = new Date(formModel.duration[0]);
	          var to = new Date(formModel.duration[1]);
	
	          data.start_hour = from.getHours();
	          data.start_minute = from.getMinutes();
	          data.end_hour = to.getHours();
	          data.end_minute = to.getMinutes();
	
	          data.days = (0, _stringify2.default)(formModel.days);
	        }
	      }
	
	      return data;
	    },
	    _fillDefaultsToAccess: function _fillDefaultsToAccess(access) {
	      function now() {
	        var now = new Date();
	        now.setSeconds(0);
	
	        return now;
	      }
	
	      var _access = (0, _assign2.default)({}, {
	        user_level_id: 1,
	        key_type: 'constant',
	        start_date: now(),
	        end_date: now(),
	        duration: [now(), now()],
	        days: [],
	        registration_status: 'active',
	        registration_status_switch_value: ['active', 'peding'].includes(access.registration_status)
	      }, access);
	
	      if (!(_access.start_date instanceof Date)) {
	        _access.start_date = new Date(_access.start_date);
	        _access.start_date.setSeconds(0);
	      }
	
	      if (!(_access.end_date instanceof Date)) {
	        _access.end_date = new Date(_access.end_date);
	        _access.end_date.setSeconds(0);
	      }
	
	      if (typeof _access.days === 'string') {
	        _access.days = JSON.parse(_access.days);
	      }
	
	      this.$emit('change', this._formatAccess(_access));
	
	      return _access;
	    }
	  },
	  watch: {
	    access: {
	      handler: function handler(newValue) {
	        this.formModel = this._fillDefaultsToAccess(newValue);
	      },
	
	      deep: true
	    }
	  }
	};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _assign = __webpack_require__(51);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _toConsumableArray2 = __webpack_require__(205);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _api = __webpack_require__(453);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _AccessForm = __webpack_require__(414);
	
	var _AccessForm2 = _interopRequireDefault(_AccessForm);
	
	var _http = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'single-access',
	  props: {
	    accessHolders: {
	      type: Array,
	      required: true
	    },
	    columns: {
	      type: Array,
	      required: true
	    },
	    mobileId: {
	      type: String
	    },
	    switchId: {
	      type: String
	    },
	    unprocessedAccesses: {
	      type: Array
	    }
	  },
	  data: function data() {
	    return {
	      selectedAccess: null,
	      regStatusFilter: 'none'
	    };
	  },
	
	  computed: {
	    visibleAccessHolders: function visibleAccessHolders() {
	      var _this = this;
	
	      if (this.regStatusFilter === 'inprogress') {
	        return this.unprocessedAccesses;
	      }
	
	      return this.accessHolders.filter(function (a) {
	        if (_this.regStatusFilter === 'none' && !a.access) {
	          return true;
	        }
	
	        return a.access && a.access.registration_status === _this.regStatusFilter;
	      });
	    },
	    operations: function operations() {
	      var _this2 = this;
	
	      if (['none', 'inprogress'].includes(this.regStatusFilter)) return [];
	
	      return [{
	        label: 'activate-scheduled',
	        type: 'success',
	        method: function method(_ref) {
	          var access = _ref.access;
	          return _this2.activateAccess(access, true);
	        },
	        precondition: function precondition(s) {
	          return s.access && s.access.registration_status !== 'active' && s.access.registration_status !== 'none';
	        }
	      }, {
	        label: 'activate',
	        type: 'success',
	        method: function method(_ref2) {
	          var access = _ref2.access;
	          return _this2.activateAccess(access, false);
	        },
	        precondition: function precondition(s) {
	          return s.access && s.access.registration_status !== 'active' && s.access.registration_status !== 'none';
	        }
	      }, {
	        label: 'disable-scheduled',
	        type: 'warning',
	        method: function method(_ref3) {
	          var access = _ref3.access;
	          return _this2.disableAccess(access, true);
	        },
	        precondition: function precondition(s) {
	          return s.access && s.access.registration_status === 'active';
	        }
	      }, {
	        label: 'disable',
	        type: 'warning',
	        method: function method(_ref4) {
	          var access = _ref4.access;
	          return _this2.disableAccess(access, false);
	        },
	        precondition: function precondition(s) {
	          return s.access && s.access.registration_status === 'active';
	        }
	      }, {
	        label: 'delete-scheduled',
	        type: 'danger',
	        method: function method(_ref5) {
	          var access = _ref5.access;
	          return _this2.deleteAccess(access, true);
	        },
	        precondition: function precondition(s) {
	          return s.access && s.access.registration_status !== 'none';
	        }
	      }, {
	        label: 'delete',
	        type: 'danger',
	        method: function method(_ref6) {
	          var access = _ref6.access;
	          return _this2.deleteAccess(access, false);
	        },
	        precondition: function precondition(s) {
	          return s.access && s.access.registration_status !== 'none';
	        }
	      }];
	    },
	    extendedColumns: function extendedColumns() {
	      if (this.regStatusFilter === 'inprogress') {
	        return [].concat((0, _toConsumableArray3.default)(this.columns), ['[T]access-registration-status']);
	      }
	
	      return this.columns;
	    }
	  },
	  methods: {
	    accessHolderSelected: function accessHolderSelected(accessHolder) {
	      var access = (0, _assign2.default)({}, accessHolder.access || {});
	
	      access.switch_id = this.switchId || accessHolder.id;
	      access.mobile_id = this.mobileId || accessHolder.id;
	
	      this.selectedAccess = access;
	    },
	    onSubmit: function onSubmit(formModel, scheduled) {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return (0, _http.post)('api/v1/mobile-accesses/' + formModel.id, formModel);
	
	              case 3:
	
	                _this3.showSuccess('access-saved');
	
	                _this3.selectedAccess = null;
	                _context.next = 10;
	                break;
	
	              case 7:
	                _context.prev = 7;
	                _context.t0 = _context['catch'](0);
	
	                console.error(_context.t0);
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this3, [[0, 7]]);
	      }))();
	    }
	  },
	  components: { AccessForm: _AccessForm2.default },
	  mixins: [_api2.default]
	};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SingleAccess = __webpack_require__(415);
	
	var _SingleAccess2 = _interopRequireDefault(_SingleAccess);
	
	var _findAll = __webpack_require__(33);
	
	var _findAll2 = _interopRequireDefault(_findAll);
	
	var _findOne = __webpack_require__(129);
	
	var _findOne2 = _interopRequireDefault(_findOne);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'single-mobile-access',
	  computed: {
	    mobileId: function mobileId() {
	      return this.$route.params.id;
	    },
	    accessHolders: function accessHolders() {
	      var _this = this;
	
	      return this.switches.map(function (s) {
	        return (0, _extends3.default)({}, s, {
	          access: (_this.mobile.mobileAccesses || []).find(function (a) {
	            return a.switch_id === s.id;
	          })
	        });
	      }).filter(function (s) {
	        return s.usage === 'entry-point';
	      });
	    }
	  },
	  components: { SingleAccess: _SingleAccess2.default },
	  mixins: [(0, _findAll2.default)('switches'), (0, _findOne2.default)('mobiles', 'mobile', function () {
	    return this.mobileId;
	  }), (0, _findAll2.default)('pending-mobile-accesses', 'unprocessedAccesses', {
	    filter: function filter(access) {
	      return access.mobile_id === this.mobileId;
	    },
	    map: function map(access) {
	      return (0, _extends3.default)({}, this.switches.find(function (s) {
	        return s.id === access.switch_id;
	      }), { access: access });
	    }
	  })]
	};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SingleAccess = __webpack_require__(415);
	
	var _SingleAccess2 = _interopRequireDefault(_SingleAccess);
	
	var _findAll = __webpack_require__(33);
	
	var _findAll2 = _interopRequireDefault(_findAll);
	
	var _findOne = __webpack_require__(129);
	
	var _findOne2 = _interopRequireDefault(_findOne);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'single-switch-access',
	  computed: {
	    switchId: function switchId() {
	      return this.$route.params.id;
	    },
	    accessHolders: function accessHolders() {
	      var _this = this;
	
	      return this.mobiles.map(function (m) {
	        return (0, _extends3.default)({}, m, {
	          access: (m.mobileAccesses || []).find(function (a) {
	            return a.switch_id === _this.switchId;
	          })
	        });
	      });
	    }
	  },
	  components: { SingleAccess: _SingleAccess2.default },
	  mixins: [(0, _findAll2.default)('mobiles'), (0, _findOne2.default)('switches', 'swithc', function () {
	    return this.switchId;
	  }), (0, _findAll2.default)('pending-mobile-accesses', 'unprocessedAccesses', {
	    filter: function filter(access) {
	      return access.switch_id === this.switchId;
	    },
	    map: function map(access) {
	      return (0, _extends3.default)({}, this.mobiles.find(function (m) {
	        return m.id === access.mobile_id;
	      }), { access: access });
	    }
	  })]
	};

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _http = __webpack_require__(8);
	
	exports.default = {
	  name: 'command-builder',
	  props: {
	    controller: {
	      type: Object,
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      message: {
	        topic: 'dlink',
	        bytes: ''
	      },
	      fields: {
	        'topic': {
	          rules: [{ required: true }, { max: 12 }]
	        },
	        'bytes': {
	          rules: [{ required: true }],
	          type: 'textarea'
	        },
	        'interval': {
	          type: 'number'
	        }
	      }
	    };
	  },
	
	  methods: {
	    submit: function submit(data) {
	      var _this = this;
	
	      if (data.interval) {
	        clearInterval(this.timerId);
	
	        var interval = data.interval;
	
	        delete data.interval;
	
	        this.timerId = setInterval(function () {
	          return _this.submit(data);
	        }, interval);
	      }
	
	      (0, _http.post)('api/v1/controllers/command/' + this.controller.id, data);
	    },
	    stopTimer: function stopTimer() {
	      clearInterval(this.timerId);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timerId);
	  }
	};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ControllerForm = __webpack_require__(910);
	
	var _ControllerForm2 = _interopRequireDefault(_ControllerForm);
	
	var _ServerSwitchForm = __webpack_require__(416);
	
	var _ServerSwitchForm2 = _interopRequireDefault(_ServerSwitchForm);
	
	var _SwitchForm = __webpack_require__(417);
	
	var _SwitchForm2 = _interopRequireDefault(_SwitchForm);
	
	var _ReaderForm = __webpack_require__(939);
	
	var _ReaderForm2 = _interopRequireDefault(_ReaderForm);
	
	var _InputForm = __webpack_require__(923);
	
	var _InputForm2 = _interopRequireDefault(_InputForm);
	
	var _ControllerWifiSetting = __webpack_require__(963);
	
	var _ControllerWifiSetting2 = _interopRequireDefault(_ControllerWifiSetting);
	
	var _ControllerDiagnosis = __webpack_require__(909);
	
	var _ControllerDiagnosis2 = _interopRequireDefault(_ControllerDiagnosis);
	
	var _CommandBuilder = __webpack_require__(907);
	
	var _CommandBuilder2 = _interopRequireDefault(_CommandBuilder);
	
	var _ControllerTxPower = __webpack_require__(912);
	
	var _ControllerTxPower2 = _interopRequireDefault(_ControllerTxPower);
	
	var _findAll = __webpack_require__(33);
	
	var _findAll2 = _interopRequireDefault(_findAll);
	
	var _findOne = __webpack_require__(129);
	
	var _findOne2 = _interopRequireDefault(_findOne);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'controller-details',
	  computed: {
	    controllerId: function controllerId() {
	      return this.$route.params.id;
	    }
	  },
	  mixins: [(0, _findAll2.default)('mobiles'), (0, _findAll2.default)('preregistrations'), (0, _findOne2.default)('controllers', 'controller', function () {
	    return this.controllerId;
	  }), (0, _findAll2.default)('readers', 'relatedReaders', {
	    filter: function filter(r) {
	      return r.controller_id === this.$route.params.id;
	    }
	  }), (0, _findAll2.default)('inputs', 'relatedInputs', {
	    filter: function filter(i) {
	      return i.controller_id === this.$route.params.id;
	    }
	  }), (0, _findAll2.default)('switches', {
	    filter: function filter(s) {
	      return s.controller_id === this.$route.params.id;
	    }
	  }), (0, _findAll2.default)('pending-mobile-accesses', 'unprocessedAccesses', {
	    filter: function filter(access) {
	      if (!this.controller || !this.controller.switches) {
	        return false;
	      }
	
	      return this.controller.switches.map(function (s) {
	        return s.id;
	      }).includes(access.switch_id);
	    },
	    map: function map(access) {
	      return (0, _extends3.default)({}, access, {
	        key_type: 'keyType.' + access.key_type,
	        switch: this.controller.switches.find(function (s) {
	          return s.id === access.switch_id;
	        })
	      });
	    }
	  })],
	  components: {
	    ServerSwitchForm: _ServerSwitchForm2.default,
	    SwitchForm: _SwitchForm2.default,
	    ControllerWifiSetting: _ControllerWifiSetting2.default,
	    ReaderForm: _ReaderForm2.default,
	    InputForm: _InputForm2.default,
	    ControllerDiagnosis: _ControllerDiagnosis2.default,
	    ControllerForm: _ControllerForm2.default,
	    CommandBuilder: _CommandBuilder2.default,
	    ControllerTxPower: _ControllerTxPower2.default
	  }
	};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _EventTable = __webpack_require__(191);
	
	var _EventTable2 = _interopRequireDefault(_EventTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'controller-diagnosis',
	  props: {
	    controller: {
	      type: Object,
	      required: true
	    }
	  },
	  computed: {
	    formData: function formData() {
	      return (0, _extends3.default)({}, this.controller, {
	        rssi: this.controller.status === 'offline' ? 'offline' : this.controller.rssi + ' dB'
	      });
	    },
	    eventFilters: function eventFilters() {
	      return {
	        eventTypeId: [7004, 7005],
	        controllerId: this.controller.id
	      };
	    }
	  },
	  components: {
	    EventTable: _EventTable2.default
	  }
	};

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inputTypes = __webpack_require__(196);
	
	var _inputTypes2 = _interopRequireDefault(_inputTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'controller-form',
	  props: {
	    controller: {
	      type: Object,
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      fields: {
	        'name': {
	          rules: [{ required: true }, { max: 12 }]
	        },
	        'description': {
	          rules: [{ required: true }, { max: 18 }]
	        },
	        'input_type': {
	          type: 'select',
	          options: _inputTypes2.default
	        },
	        'x_pos': { type: 'number' },
	        'y_pos': { type: 'number' },
	        'z_pos': { type: 'number' }
	      },
	      buttons: [{
	        label: 'submit-scheduled',
	        submit: true,
	        params: {
	          scheduled: true
	        }
	      }, {
	        label: 'submit',
	        submit: true,
	        params: {
	          scheduled: false
	        }
	      }]
	    };
	  }
	};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _routes = __webpack_require__(59);
	
	var _http = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'controller-list',
	  data: function data() {
	    return {
	      showActivateDialog: false,
	      controllerToActivate: {},
	      loading: false,
	      modelToDelete: null
	    };
	  },
	
	  computed: {
	    operations: function operations() {
	      var _this = this;
	
	      return [{
	        label: 'edit',
	        icon: 'edit',
	        method: this._editOperation,
	        permission: ['EDIT_CONTROLLER', 'server_id'],
	        precondition: function precondition(controller) {
	          return controller.connected;
	        }
	      }, {
	        label: 'activate',
	        method: this._activateOperation,
	        permission: ['ACTIVATE_CONTROLLER', 'server_id'],
	        precondition: function precondition(controller) {
	          return !controller.connected;
	        },
	        disabled: function disabled(controller) {
	          return !controller.activable;
	        }
	      }, {
	        label: 'delete',
	        type: 'danger',
	        icon: 'delete',
	        method: function method(model) {
	          return _this.modelToDelete = model;
	        },
	        permission: ['DELETE_CONTROLLER', 'server_id']
	      }, {
	        label: 'sync',
	        method: this.synchronizeOperation,
	        permission: ['SYNCHRONIZE_CONTROLLER', 'server_id']
	      }];
	    }
	  },
	  methods: {
	    _editOperation: function _editOperation(_ref) {
	      var id = _ref.id;
	
	      this.$router.push({ name: _routes.CONTROLLER_EDIT, params: { id: id } });
	    },
	    _activateOperation: function _activateOperation(controller) {
	      this.showActivateDialog = true;
	      this.controllerToActivate = controller;
	    },
	    _deleteOperation: function _deleteOperation() {
	      this.$store.dispatch('controllers/delete', this.modelToDelete);
	      this.modelToDelete = null;
	    },
	    synchronizeOperation: function synchronizeOperation(controller) {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return (0, _http.post)('api/v1/controllers/synchronizeData/' + controller.id);
	
	              case 3:
	                _context.next = 8;
	                break;
	
	              case 5:
	                _context.prev = 5;
	                _context.t0 = _context['catch'](0);
	
	                console.error(_context.t0);
	
	              case 8:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[0, 5]]);
	      }))();
	    },
	    cancelActivation: function cancelActivation() {
	      this.showActivateDialog = false;
	    },
	    activateController: function activateController() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var id;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                id = _this3.controllerToActivate.id;
	
	                _this3.loading = true;
	
	                _context2.prev = 2;
	                _context2.next = 5;
	                return (0, _http.post)('api/v1/controllers/activate', { id: id });
	
	              case 5:
	
	                _this3.controllerToActivate.connected = true;
	                _context2.next = 11;
	                break;
	
	              case 8:
	                _context2.prev = 8;
	                _context2.t0 = _context2['catch'](2);
	
	                console.error(_context2.t0);
	
	              case 11:
	                _context2.prev = 11;
	
	                _this3.loading = false;
	                _this3.showActivateDialog = false;
	                return _context2.finish(11);
	
	              case 15:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this3, [[2, 8, 11, 15]]);
	      }))();
	    },
	    emergency: function emergency() {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this4.loading = true;
	
	                _context3.next = 3;
	                return (0, _http.post)('api/v1/emergency', { 'state': 2 });
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this4);
	      }))();
	    }
	  }
	};

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _http = __webpack_require__(8);
	
	exports.default = {
	  name: 'controller-tx-power',
	  props: {
	    controller: {
	      type: Object,
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      fields: {
	        'txPower': {
	          rules: [{ required: true, type: 'number', max: 15, min: 0 }],
	          type: 'number'
	        }
	      }
	    };
	  },
	
	  methods: {
	    submit: function submit(_ref) {
	      var txPower = _ref.txPower;
	
	      (0, _http.post)('api/v1/controllers/txpower/' + this.controller.id, { txPower: txPower });
	    }
	  }
	};

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _http = __webpack_require__(8);
	
	exports.default = {
	  name: 'emergency-function',
	  methods: {
	    sendEmergency: function sendEmergency(state) {
	      (0, _http.post)('api/v1/emergency', { state: state });
	    }
	  }
	};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _http = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'lan-status',
	  props: {},
	  data: function data() {
	    return {
	      status: {
	        address: null,
	        hostName: null,
	        gatewayIp: null,
	        isGatewayAlive: null,
	        publicIp: null
	      },
	      loading: false
	    };
	  },
	
	  computed: {},
	  methods: {
	    updateStatus: function updateStatus() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.loading = true;
	                _context.next = 3;
	                return (0, _http.get)('api/v1/status/lan');
	
	              case 3:
	                _this.status = _context.sent;
	
	                _this.loading = false;
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    }
	  },
	  created: function created() {
	    this.updateStatus();
	  }
	};

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(51);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _http = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'switch-controll',
	  computed: {
	    switchGroups: function switchGroups() {
	      var groups = this.$store.getters['switch-groups/data'](this.$store.dispatch);
	      var switches = this.$store.getters['switches/data'](this.$store.dispatch);
	
	      return groups.map(function (g) {
	        var group = (0, _assign2.default)({}, g);
	
	        group.switches = group.relatedSwitchIds.map(function (id) {
	          return switches.find(function (s) {
	            return s.id === id;
	          }) || {};
	        });
	
	        return group;
	      });
	    }
	  },
	  methods: {
	    toggleSwitch: function toggleSwitch(s, state) {
	      (0, _http.post)('api/v1/toggle/' + s.id, { state: state });
	    },
	    toggleGroup: function toggleGroup(g, state) {
	      (0, _http.post)('api/v1/toggle/group/' + g.id, { state: state });
	    }
	  }
	};

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'system-location',
	  computed: {
	    currentServer: function currentServer() {
	      var servers = this.$store.getters['servers/data'](this.$store.dispatch);
	      return servers.find(function (s) {
	        return s.self;
	      }) || {};
	    },
	    serverLocation: function serverLocation() {
	      var locationId = this.currentServer.location_id;
	
	      if (!locationId) {
	        return '-';
	      }
	      var location = this.$store.getters['locations/findById'](locationId, this.$store.dispatch);
	
	      var name = location.name,
	          zip = location.zip,
	          city = location.city,
	          street = location.street;
	
	      return name + ', ' + zip + ' ' + city + ', ' + street;
	    }
	  }
	};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _http = __webpack_require__(8);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'system-time',
	  data: function data() {
	    return {
	      startingServerTime: null,
	      startingBrowserTime: null,
	      actualBrowserTime: null,
	      timerId: null
	    };
	  },
	
	  computed: {
	    actualServerTime: function actualServerTime() {
	      if (!this.startingServerTime) {
	        return '';
	      }
	
	      var sst = this.startingServerTime.getTime();
	      var sbt = this.startingBrowserTime.getTime();
	      var abt = this.actualBrowserTime.getTime();
	
	      var ast = sst + (abt - sbt);
	
	      return (0, _moment2.default)(ast).format(this.$t('format.longDate'));
	    }
	  },
	  beforeCreate: function beforeCreate() {
	    var _this = this;
	
	    (0, _http.get)('api/v1/serverTime').then(function (_ref) {
	      var time = _ref.time;
	
	      _this.startingServerTime = new Date(time);
	      _this.startingBrowserTime = new Date();
	      _this.actualBrowserTime = new Date();
	
	      _this.timerId = setInterval(function () {
	        _this.actualBrowserTime = new Date();
	      }, 1000);
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timerId);
	  }
	};

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _EventTableConfig = __webpack_require__(192);
	
	var _EventTableConfig2 = _interopRequireDefault(_EventTableConfig);
	
	var _EventTable = __webpack_require__(191);
	
	var _EventTable2 = _interopRequireDefault(_EventTable);
	
	var _profiles = __webpack_require__(127);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'event-list',
	  data: function data() {
	    return {
	      collapse: null,
	      filters: {}
	    };
	  },
	
	  computed: {
	    mergedFilters: function mergedFilters() {
	      return (0, _extends3.default)({}, this.filters, _profiles2.default[this.profile]);
	    },
	    profile: function profile() {
	      return this.$route.meta.profile;
	    }
	  },
	  methods: {
	    filtersChanged: function filtersChanged(filters) {
	      this.filters = filters;
	    }
	  },
	  components: {
	    EventListConfig: _EventTableConfig2.default,
	    EventTable: _EventTable2.default
	  }
	};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _toConsumableArray2 = __webpack_require__(205);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _charts = __webpack_require__(445);
	
	var _http = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'event-statistics',
	  props: {
	    filters: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	  data: function data() {
	    return {
	      data: null,
	      timerId: null
	    };
	  },
	
	  computed: {
	    chartData: function chartData() {
	      if (!this.data) {
	        return null;
	      }
	      var dataSet = this.data.reduce(function (acc, curr) {
	        return {
	          data: [].concat((0, _toConsumableArray3.default)(acc.data), [curr.count]),
	          labels: [].concat((0, _toConsumableArray3.default)(acc.labels), [curr.time])
	        };
	      }, { data: [], labels: [] });
	
	      return {
	        labels: dataSet.labels,
	        datasets: [{
	          label: '# of events',
	          data: dataSet.data,
	          backgroundColor: 'rgb(87, 193, 123)',
	          borderColor: 'rgb(87, 193, 123)',
	          borderWidth: 1
	        }]
	      };
	    }
	  },
	  methods: {
	    _fetchStatistics: function _fetchStatistics() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return (0, _http.post)('api/v1/events/statistics', _this.filters);
	
	              case 2:
	                data = _context.sent;
	
	
	                _this.data = data;
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    refresh: function refresh() {
	      this._fetchStatistics();
	      this.timerId = setTimeout(this.refresh, 15 * 1000);
	    }
	  },
	  created: function created() {
	    this.refresh();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearTimeout(this.timerId);
	  },
	
	  components: {
	    BarChart: _charts.BarChart
	  }
	};

/***/ }),
/* 488 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'event-statistics-config',
	  props: {
	    filters: {
	      type: Object,
	      default: function _default() {
	        return {
	          mobileId: '',
	          eventTypeId: '',
	          count: 10,
	          unit: 'days'
	        };
	      }
	    }
	  },
	  computed: {
	    fields: function fields() {
	      return {
	        mobileId: {
	          type: 'select',
	          options: this.filterOptions('mobiles')(''),
	          filter: this.filterOptions('mobiles'),
	          placeholder: true
	        },
	        eventTypeId: {
	          type: 'select',
	          options: this.filterOptions('event-types', function (model) {
	            return { label: 'eventType.' + model.name, value: model.id };
	          })(''),
	          filter: this.filterOptions('event-types', function (model) {
	            return { label: 'eventType.' + model.name, value: model.id };
	          }),
	          placeholder: true
	        },
	        unit: {
	          type: 'select',
	          options: [{ label: 'days', value: 'days' }, { label: 'hours', value: 'hours' }, { label: 'minutes', value: 'minutes' }]
	        },
	        count: {
	          type: 'number',
	          max: 100,
	          rules: [{ type: 'number', max: 100 }]
	        }
	      };
	    }
	  },
	  methods: {
	    filtersChanged: function filtersChanged(filters) {
	      this.$emit('propertiesChanged', { filters: filters });
	    },
	    filterOptions: function filterOptions(model) {
	      var _this = this;
	
	      var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (model) {
	        return { label: model.contact_name, value: model.id };
	      };
	
	      return function (query) {
	        var models = _this.$store.getters[model + '/data'](_this.$store.dispatch);
	
	        return models.map(map).reverse().filter(function (option) {
	          return option.label.toLowerCase().includes((query || '').toLowerCase());
	        }).slice(0, 10);
	      };
	    }
	  },
	  create: function create() {
	    this.filterOptions('mobiles')('');
	    this.filterOptions('event-types')('');
	  }
	};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _EventTableConfig = __webpack_require__(192);
	
	var _EventTableConfig2 = _interopRequireDefault(_EventTableConfig);
	
	var _http = __webpack_require__(8);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(75);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _profiles = __webpack_require__(127);
	
	var _findAll = __webpack_require__(33);
	
	var _findAll2 = _interopRequireDefault(_findAll);
	
	var _toggleTypes = __webpack_require__(447);
	
	var _toggleTypes2 = _interopRequireDefault(_toggleTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'event-table',
	  props: {
	    filters: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    showSearch: {
	      type: Boolean,
	      default: true
	    },
	    profile: {
	      type: String
	    },
	    columns: {
	      type: Array
	    }
	  },
	  data: function data() {
	    return {
	      events: [],
	      debouncedGetEvents: _lodash2.default.debounce(this.getEvents, 700),
	      loading: false,
	      timerId: null
	    };
	  },
	
	  computed: {
	    mappedEvents: function mappedEvents() {
	      var _this = this;
	
	      if (this.profile === _profiles.ENTRY) {
	        return this.events.map(function (event) {
	          var additionalFields = {};
	
	          var relatedSwitch = _this.switches.find(function (s) {
	            return s.controller_id === event.controller_id && s.index === event.param % 20;
	          });
	
	          if (relatedSwitch) {
	            additionalFields.switchName = relatedSwitch.name;
	          }
	
	          if (!event.mobile_id) {
	            additionalFields.userName = _this.$t('unknown');
	            additionalFields.personName = _this.$t('unknown');
	          }
	
	          if (event.param === 0) {
	            additionalFields.type = _this.$t('event.toggle.type.rfid');
	            additionalFields.success = _this.$t('event.toggle.success');
	          } else if (event.param === 255) {
	            additionalFields.type = _this.$t('event.toggle.type.rfid');
	            additionalFields.success = _this.$t('event.toggle.fail-undefined');
	          } else {
	            var type = _toggleTypes2.default[Math.floor(event.param / 20)];
	
	            if (type) {
	              additionalFields.type = _this.$t('event.toggle.type.' + type.type);
	              additionalFields.success = _this.$t('event.toggle.' + type.success);
	            }
	          }
	
	          return (0, _extends3.default)({}, event, additionalFields);
	        });
	      }
	
	      return this.events;
	    },
	    computedColumns: function computedColumns() {
	      if (this.columns) {
	        return this.columns;
	      }
	
	      if (this.profile === _profiles.ENTRY) {
	        return ['occured', 'userName', 'personName', 'controllerName', 'switchName', 'type', 'success'];
	      } else if (this.profile === _profiles.REGISTRATION) {
	        return ['occured', 'name', 'userName', 'controllerName', 'controllerDescription'];
	      } else if (this.profile === _profiles.SYSTEM) {
	        return ['occured', 'controllerName', 'controllerDescription', 'controllerIp', 'name'];
	      } else if (this.profile === _profiles.INPUT) {
	        return ['occured', 'name', 'user_name', 'controllerName', 'controllerDescription'];
	      }
	
	      return ['occured', '[T]name', 'param', 'userName'];
	    }
	  },
	  methods: {
	    getEvents: function getEvents() {
	      var _this2 = this;
	
	      var showLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var events;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this2.loading = showLoading && true;
	
	                _context.next = 3;
	                return (0, _http.post)('api/v1/events', _this2.filters);
	
	              case 3:
	                events = _context.sent;
	
	
	                _this2.loading = false;
	
	                _this2.events = events.data.map(function (e) {
	                  e.occured = (0, _moment2.default)(e.occured).format(_this2.$t('format.longDate'));
	                  e.name = _this2.$t('eventType.' + e.name);
	
	                  return e;
	                });
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }))();
	    },
	    refresh: function refresh() {
	      this.debouncedGetEvents(false);
	      this.timerId = setTimeout(this.refresh, 15 * 1000);
	    }
	  },
	  watch: {
	    filters: {
	      handler: function handler() {
	        this.debouncedGetEvents();
	      },
	
	      deep: true
	    },
	    profile: function profile() {
	      this.events = [];
	      this.loading = true;
	    }
	  },
	  created: function created() {
	    this.refresh();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearTimeout(this.timerId);
	  },
	
	  components: {
	    EventListConfig: _EventTableConfig2.default
	  },
	  mixins: [(0, _findAll2.default)('switches')]
	};

/***/ }),
/* 490 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'event-table-config',
	  props: {
	    filters: {
	      type: Object,
	      default: function _default() {
	        return {
	          mobileId: null,
	          eventTypeId: null,
	          dateFrom: null,
	          dateTo: null,
	          size: 100
	        };
	      }
	    },
	    hideEventTypeId: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    fields: function fields() {
	      return {
	        mobileId: {
	          type: 'select',
	          options: this.filterOptions('mobiles')(''),
	          filter: this.filterOptions('mobiles'),
	          placeholder: true
	        },
	        eventTypeId: {
	          type: 'select',
	          options: this.filterOptions('event-types', function (model) {
	            return { label: 'eventType.' + model.name, value: model.id };
	          })(''),
	          filter: this.filterOptions('event-types', function (model) {
	            return { label: 'eventType.' + model.name, value: model.id };
	          }),
	          placeholder: true,
	          hidden: this.hideEventTypeId
	        },
	        dateFrom: {
	          type: 'datetime'
	        },
	        dateTo: {
	          type: 'datetime'
	        },
	        size: {
	          type: 'number',
	          max: 10000,
	          rules: [{ type: 'number', max: 10000 }]
	        }
	      };
	    }
	  },
	  methods: {
	    filtersChanged: function filtersChanged(filters) {
	      this.$emit('filtersChanged', filters);
	      this.$emit('propertiesChanged', { filters: filters });
	    },
	    filterOptions: function filterOptions(model) {
	      var _this = this;
	
	      var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (model) {
	        return { label: model.contact_name, value: model.id };
	      };
	
	      return function (query) {
	        var models = _this.$store.getters[model + '/data'](_this.$store.dispatch);
	
	        var result = models.map(map);
	
	        result = result.filter(function (option) {
	          return option.label.toLowerCase().includes((query || '').toLowerCase());
	        });
	
	        result = result.reverse();
	
	        return result.slice(0, 10);
	      };
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.filtersChanged(this.filters);
	  }
	};

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'external-service-details',
	  data: function data() {
	    return {
	      formModel: null
	    };
	  },
	
	  computed: {
	    fields: function fields() {
	      var baseFields = {
	        'id': {
	          type: 'text',
	          label: 'name',
	          rules: [{ required: true }, { max: 80 }]
	        },
	        'url': {
	          type: 'text',
	          rules: [{ required: true }, { max: 80 }]
	        },
	        'type': {
	          type: 'select',
	          options: ['event', 'online-validator'].map(function (i) {
	            return { label: i, value: i };
	          }),
	          rules: [{ required: true }]
	        }
	      };
	
	      return (0, _extends3.default)({}, baseFields, this.getAdditionalFields(this.formModel || this.externalService));
	    },
	    externalService: function externalService() {
	      var id = this.$route.params.id;
	
	      if (id === 'new') {
	        return { new: true, type: 'event' };
	      }
	
	      return this.$store.getters['external-services/findById'](id, this.$store.dispatch);
	    },
	    action: function action() {
	      return this.externalService.new ? 'create' : 'edit';
	    }
	  },
	  methods: {
	    mapBeforeSubmit: function mapBeforeSubmit(formModel) {
	      formModel.config = {
	        maxTries: formModel.maxTries,
	        timeout: formModel.timeout
	      };
	
	      delete formModel.maxTries;
	      delete formModel.timeout;
	    },
	    afterSubmit: function afterSubmit() {
	      this.$router.back();
	    },
	    onChange: function onChange(formModel) {
	      this.formModel = formModel;
	    },
	    getAdditionalFields: function getAdditionalFields(formModel) {
	      if (!formModel) {
	        return;
	      }
	
	      switch (formModel.type) {
	        case 'event':
	        case 'online-validator':
	          return {
	            'maxTries': {
	              type: 'number',
	              rules: [{ required: true, type: 'number' }]
	            },
	            'timeout': {
	              type: 'number',
	              rules: [{ required: true, type: 'number' }]
	            }
	          };
	      }
	    }
	  }
	};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseList = __webpack_require__(46);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'external-service-list',
	  components: { BaseList: _BaseList2.default }
	};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _findAll = __webpack_require__(33);
	
	var _findAll2 = _interopRequireDefault(_findAll);
	
	var _inputTypes = __webpack_require__(196);
	
	var _inputTypes2 = _interopRequireDefault(_inputTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'input-form',
	  props: {
	    input: {
	      type: Object,
	      required: true
	    }
	  },
	  computed: {
	    fields: function fields() {
	      return {
	        'hardverId': {
	          disabled: true
	        },
	        'name': {},
	        'type': {
	          type: 'select',
	          options: _inputTypes2.default
	        },
	        'event_switch_id': {
	          type: 'select',
	          options: this.switchOptions
	        },
	        'event_timeout': {
	          type: 'number'
	        },
	        'alarm_switch_id': {
	          type: 'select',
	          options: this.switchOptions
	        }
	      };
	    },
	    mappedInput: function mappedInput() {
	      return (0, _extends3.default)({}, this.input, {
	        hardverId: this.input.index === 1 ? this.$t('controller') : this.$t('wiegand')
	      });
	    }
	  },
	  mixins: [(0, _findAll2.default)('switches', 'switchOptions', {
	    filter: function filter(_ref) {
	      var controller_id = _ref.controller_id;
	      return controller_id === this.input.controller_id;
	    },
	    map: function map(_ref2) {
	      var id = _ref2.id,
	          name = _ref2.name;
	      return { value: id, label: name };
	    }
	  })]
	};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _locationFields = __webpack_require__(197);
	
	var _locationFields2 = _interopRequireDefault(_locationFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'location-details',
	  data: function data() {
	    return {
	      relatedServers: [],
	      fields: _locationFields2.default
	    };
	  },
	
	  computed: {
	    location: function location() {
	      var id = this.$route.params.id;
	
	      if (id === 'new') {
	        return { new: true };
	      }
	
	      return this.$store.getters['locations/findById'](id, this.$store.dispatch);
	    },
	    action: function action() {
	      return this.location.new ? 'create' : 'edit';
	    }
	  },
	  methods: {
	    beforeSubmit: function beforeSubmit(formModel) {
	      formModel.relatedServerIds = this.relatedServers.map(function (i) {
	        return i.id;
	      });
	    },
	    afterSubmit: function afterSubmit(formModel) {
	      this.$router.back();
	    },
	    isServerSelected: function isServerSelected(server) {
	      return server.location_id === this.location.id;
	    },
	    serverSelectChanged: function serverSelectChanged(selection) {
	      this.relatedServers = selection;
	    }
	  }
	};

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseList = __webpack_require__(46);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'location-list',
	  components: { BaseList: _BaseList2.default }
	};

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'mobile-group-details',
	  data: function data() {
	    return {
	      newRelatedMobileIds: [],
	      fields: {
	        'name': {
	          type: 'text',
	          rules: [{ required: true }, { max: 80 }]
	        },
	        'description': {
	          type: 'textarea',
	          rules: [{ required: true }, { max: 80 }]
	        }
	      }
	    };
	  },
	
	  computed: {
	    mobileGroup: function mobileGroup() {
	      var id = this.$route.params.id;
	
	      if (id === 'new') {
	        return { new: true, relatedMobileIds: [] };
	      }
	
	      return this.$store.getters['mobile-groups/findById'](id, this.$store.dispatch);
	    },
	    action: function action() {
	      return this.mobileGroup.new ? 'create' : 'edit';
	    }
	  },
	  methods: {
	    beforeSubmit: function beforeSubmit(model) {
	      model.newRelatedMobileIds = this.newRelatedMobileIds;
	    },
	    afterSubmit: function afterSubmit() {
	      this.$router.back();
	    },
	    isMobileSelected: function isMobileSelected(mobile) {
	      return (this.mobileGroup.relatedMobileIds || []).includes(mobile.id);
	    },
	    mobileSelectChanged: function mobileSelectChanged(selectedMobiles) {
	      this.newRelatedMobileIds = selectedMobiles.map(function (c) {
	        return c.id;
	      });
	    }
	  }
	};

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseList = __webpack_require__(46);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'mobile-group-list',
	  components: { BaseList: _BaseList2.default }
	};

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NotificationSettings = __webpack_require__(931);
	
	var _NotificationSettings2 = _interopRequireDefault(_NotificationSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'mobile-details',
	  data: function data() {
	    return {
	      currentTab: 0,
	      fields: {
	        'contact_name': {
	          rules: [{ max: 80 }]
	        },
	        'contact_phone': {
	          rules: [{ max: 16 }]
	        },
	        'contact_email': {
	          rules: [{ type: 'email' }, { max: 254 }]
	        },
	        'contact_refid': {
	          rules: [{ max: 80 }]
	        },
	        'show_distant_switches': {
	          type: 'checkbox'
	        }
	      }
	    };
	  },
	
	  computed: {
	    mobile: function mobile() {
	      var id = this.$route.params.id;
	
	      return this.$store.getters['mobiles/findById'](id, this.$store.dispatch);
	    }
	  },
	  components: {
	    NotificationSettings: _NotificationSettings2.default
	  }
	};

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _from = __webpack_require__(199);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _set = __webpack_require__(541);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _routes = __webpack_require__(59);
	
	var _findAll = __webpack_require__(33);
	
	var _findAll2 = _interopRequireDefault(_findAll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'mobile-list',
	  data: function data() {
	    return {
	      modelToDelete: null
	    };
	  },
	
	  computed: {
	    mappedMobiles: function mappedMobiles() {
	      var _this = this;
	
	      return this.mobiles.map(function (mobile) {
	        var relatedControllers = mobile.mobileAccesses.filter(function (a) {
	          return a.registration_status && a.registration_status !== 'none';
	        }).map(function (a) {
	          return _this.switches.find(function (s) {
	            return s.id === a.switch_id;
	          });
	        }).map(function (s) {
	          return _this.controllers.find(function (c) {
	            return s && c.id === s.controller_id;
	          });
	        }).map(function (c) {
	          return c ? c.name : null;
	        });
	
	        var set = new _set2.default(relatedControllers);
	        var arr = (0, _from2.default)(set);
	        arr.sort();
	
	        return (0, _extends3.default)({}, mobile, {
	          controllerNames: arr.join(', '),
	          mobileGroupNames: mobile.mobileGroups.map(function (g) {
	            return g.name;
	          }).join(', ')
	        });
	      });
	    },
	    operations: function operations() {
	      var _this2 = this;
	
	      return [{
	        label: 'edit',
	        permission: 'EDIT_MOBILE',
	        icon: 'edit',
	        method: function method(mobile) {
	          return _this2.$router.push({ name: _routes.MOBILE_EDIT, params: { 'id': mobile.id } });
	        }
	      }, {
	        label: 'single-access',
	        permission: 'VIEW_SINGLE_MOBILE_ACCESSES',
	        type: 'success',
	        icon: 'circle-check',
	        method: function method(mobile) {
	          return _this2.$router.push({ name: _routes.SINGLE_MOBIL_ACCESS, params: { 'id': mobile.id } });
	        }
	      }, {
	        label: 'restore',
	        permission: 'RESTORE_MOBILE_ACCESSES',
	        method: function method(mobile) {
	          return _this2.$router.push({ name: _routes.RESTORE_MOBILE_ACCESS, params: { 'id': mobile.id } });
	        }
	      }, {
	        label: 'delete',
	        permission: 'DELETE_MOBILE',
	        type: 'danger',
	        icon: 'delete',
	        method: function method(model) {
	          return _this2.modelToDelete = model;
	        }
	      }];
	    },
	    loading: function loading() {
	      return this.$store.getters['mobiles/loading'];
	    }
	  },
	  methods: {
	    deleteModel: function deleteModel() {
	      this.$store.dispatch('mobiles/delete', this.modelToDelete);
	      this.modelToDelete = null;
	    }
	  },
	  mixins: [(0, _findAll2.default)('mobiles'), (0, _findAll2.default)('switches'), (0, _findAll2.default)('controllers')]
	};

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _findAll = __webpack_require__(33);
	
	var _findAll2 = _interopRequireDefault(_findAll);
	
	var _http = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'RestoreMobileAccess',
	  data: function data() {
	    return {
	      entity: {
	        restoreMobileId: null
	      }
	    };
	  },
	
	  computed: {
	    fields: function fields() {
	      return {
	        restoreMobileId: {
	          type: 'select',
	          options: this.mobiles
	        }
	      };
	    }
	  },
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return (0, _http.post)('api/v1/restore-mobile', {
	                  mobileId: _this.$route.params.id,
	                  restoreMobileId: _this.entity.restoreMobileId
	                });
	
	              case 3:
	
	                _this.showSuccess('restore-success');
	                _this.$router.back();
	                _context.next = 11;
	                break;
	
	              case 7:
	                _context.prev = 7;
	                _context.t0 = _context['catch'](0);
	
	                console.error(_context.t0);
	
	                _this.showError('failed-to-restore');
	
	              case 11:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[0, 7]]);
	      }))();
	    }
	  },
	  mixins: [(0, _findAll2.default)('mobiles', {
	    filter: function filter(mobile) {
	      return mobile.id !== this.$route.params.id;
	    },
	
	    map: function map(mobile) {
	      return { value: mobile.id, label: mobile.contact_name };
	    }
	  })]
	};

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(102);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _findAll = __webpack_require__(33);
	
	var _findAll2 = _interopRequireDefault(_findAll);
	
	var _search = __webpack_require__(454);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _http = __webpack_require__(8);
	
	var _days = __webpack_require__(195);
	
	var _days2 = _interopRequireDefault(_days);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialData = {
	  event_type_ids: [],
	  days: _days2.default.map(function (d) {
	    return d.value;
	  })
	};
	
	var from = new Date();
	var to = new Date();
	
	exports.default = {
	  name: 'notification-settings',
	  props: {
	    mobile: {
	      type: Object,
	      required: true,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	  data: function data() {
	    return {
	      selectedSettings: null
	    };
	  },
	
	  computed: {
	    fields: function fields() {
	      var fields = {
	        'event_type_ids': {
	          type: 'select',
	          label: 'event-types',
	          multiple: true,
	          options: this.eventTypeOptions
	        },
	        'send_push': {
	          type: 'checkbox',
	          disabled: !this.mobile.firebaseToken
	        },
	        'send_email': {
	          type: 'checkbox',
	          disabled: !this.mobile.contact_email
	        },
	        'has_date_filters': {
	          type: 'switch'
	        }
	      };
	
	      if (this.selectedSettings.has_date_filters) {
	        fields = (0, _extends3.default)({}, fields, {
	          'start_date': { type: 'date' },
	          'end_date': { type: 'date' },
	          'duration': { type: 'time', format: 'HH:mm' },
	          'days': {
	            type: 'select',
	            options: _days2.default,
	            multiple: true
	          }
	        });
	      }
	
	      return fields;
	    },
	    operations: function operations() {
	      var _this = this;
	
	      return [{
	        label: 'delete',
	        type: 'danger',
	        icon: 'delete',
	        method: function () {
	          var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(model) {
	            return _regenerator2.default.wrap(function _callee$(_context) {
	              while (1) {
	                switch (_context.prev = _context.next) {
	                  case 0:
	                    _context.next = 2;
	                    return (0, _http.deletex)('api/v1/mobile-notification-settings/' + model.id);
	
	                  case 2:
	                    _this.fetchSettings();
	                    _this.selectedSettings = null;
	
	                  case 4:
	                  case 'end':
	                    return _context.stop();
	                }
	              }
	            }, _callee, _this);
	          }));
	
	          return function method(_x) {
	            return _ref.apply(this, arguments);
	          };
	        }()
	      }];
	    }
	  },
	  methods: {
	    setSelectedSetting: function setSelectedSetting() {
	      var newValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialData;
	      var start_hour = newValue.start_hour,
	          start_minute = newValue.start_minute,
	          end_hour = newValue.end_hour,
	          end_minute = newValue.end_minute,
	          has_date_filters = newValue.has_date_filters,
	          send_push = newValue.send_push,
	          send_email = newValue.send_email;
	
	
	      from.setHours(start_hour || 0);
	      from.setMinutes(start_minute || 0);
	
	      to.setHours(end_hour || 23);
	      to.setMinutes(end_minute || 59);
	
	      this.selectedSettings = (0, _extends3.default)({}, newValue, {
	        duration: [from, to],
	        has_date_filters: !!has_date_filters,
	        send_push: !!send_push,
	        send_email: !!send_email,
	        start_date: newValue.start_date && has_date_filters ? new Date(newValue.start_date) : null,
	        end_date: newValue.end_date && has_date_filters ? new Date(newValue.end_date) : null
	      });
	    },
	    onFormChange: function onFormChange(newValue) {
	      this.selectedSettings = (0, _extends3.default)({}, this.selectedSettings, newValue);
	    },
	    beforeSubmit: function beforeSubmit(model) {
	      var _model$duration = (0, _slicedToArray3.default)(model.duration, 2),
	          from = _model$duration[0],
	          to = _model$duration[1];
	
	      delete model.duration;
	
	      model.start_hour = from.getHours();
	      model.end_hour = to.getHours();
	      model.start_minute = from.getMinutes();
	      model.end_minute = to.getMinutes();
	
	      model.mobile_id = this.mobile.id;
	    },
	    afterSubmit: function afterSubmit() {
	      this.fetchSettings();
	      this.selectedSettings = null;
	    }
	  },
	  mixins: [(0, _findAll2.default)('event-types', 'eventTypeOptions', {
	    map: function map(et) {
	      return {
	        value: et.id,
	        label: et.name
	      };
	    },
	
	    filter: function filter(et) {
	      return et.push_notification;
	    }
	  }), (0, _search2.default)('mobile-notification-settings', 'settings', function (ctx) {
	    return { mobileId: ctx.mobile.id };
	  }, {
	    map: function map(mns) {
	      var _this2 = this;
	
	      return (0, _extends3.default)({}, mns, {
	        eventTypeNames: mns.event_type_ids.map(function (id) {
	          return (_this2.eventTypeOptions.find(function (et) {
	            return et.value === id;
	          }) || {}).label;
	        }).join(', ')
	      });
	    },
	    sort: function sort(mnsa, mnsb) {
	      return mnsa.id.localeCompare(mnsb.id);
	    }
	  })]
	};

/***/ }),
/* 502 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'organization-details',
	  data: function data() {
	    return {
	      relatedUsers: []
	    };
	  },
	
	  computed: {
	    organization: function organization() {
	      var id = this.$route.params.id;
	
	      if (id === 'new') {
	        return { new: true, owner_id: null, relatedUserIds: [] };
	      }
	
	      return this.$store.getters['organizations/findById'](id, this.$store.dispatch);
	    },
	    fields: function fields() {
	      return {
	        'name': {
	          type: 'text',
	          rules: [{ required: true }, { max: 80 }]
	        },
	        'description': {
	          type: 'textarea',
	          rules: [{ required: true }, { max: 80 }]
	        },
	        'owner_id': {
	          type: 'select',
	          options: this.filterOwners(),
	          filter: this.filterOwners,
	          rules: [{ required: true }]
	        }
	      };
	    },
	    action: function action() {
	      return this.organization.new ? 'create' : 'edit';
	    }
	  },
	  methods: {
	    beforeSubmit: function beforeSubmit(formModel) {
	      formModel.relatedUserIds = this.relatedUsers.map(function (u) {
	        return u.id;
	      });
	    },
	    afterSubmit: function afterSubmit(formModel) {
	      this.$router.back();
	    },
	    filterOwners: function filterOwners(query) {
	      var owners = this.$store.getters['owners/data'](this.$store.dispatch);
	
	      return owners.map(function (owner) {
	        return { label: owner.name, value: owner.id };
	      }).filter(function (option) {
	        return option.label.toLowerCase().includes((query || '').toLowerCase());
	      });
	    },
	    isUserSelected: function isUserSelected(user) {
	      return this.organization.relatedUserIds.includes(user.id);
	    },
	    userSelectChanged: function userSelectChanged(users) {
	      this.relatedUsers = users;
	    }
	  }
	};

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseList = __webpack_require__(46);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'organization-list',
	  components: { BaseList: _BaseList2.default }
	};

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ownerFields = __webpack_require__(198);
	
	var _ownerFields2 = _interopRequireDefault(_ownerFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'owner-details',
	  data: function data() {
	    return {
	      relatedOrganizations: [],
	      fields: _ownerFields2.default
	    };
	  },
	
	  computed: {
	    owner: function owner() {
	      var id = this.$route.params.id;
	
	      if (id === 'new') {
	        return { new: true };
	      }
	
	      return this.$store.getters['owners/findById'](id, this.$store.dispatch);
	    },
	    action: function action() {
	      return this.owner.new ? 'create' : 'edit';
	    }
	  },
	  methods: {
	    beforeSubmit: function beforeSubmit(formModel) {
	      formModel.relatedOrganizations = this.relatedOrganizations.map(function (i) {
	        return i.id;
	      });
	    },
	    afterSubmit: function afterSubmit(formModel) {
	      this.$router.back();
	    },
	    isOrganizationSelected: function isOrganizationSelected(org) {
	      return org.owner_id === this.owner.id;
	    },
	    organizationSelectChanged: function organizationSelectChanged(selection) {
	      this.relatedOrganizations = selection;
	    }
	  }
	};

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseList = __webpack_require__(46);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'owner-list',
	  components: { BaseList: _BaseList2.default }
	};

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PersonForm = __webpack_require__(937);
	
	var _PersonForm2 = _interopRequireDefault(_PersonForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'person-details',
	  computed: {
	    person: function person() {
	      var id = this.$route.params.id;
	
	      if (id === 'new') {
	        return { new: true };
	      }
	
	      return this.$store.getters['persons/findById'](id, this.$store.dispatch);
	    },
	    action: function action() {
	      return this.person.new ? 'create' : 'edit';
	    }
	  },
	  components: {
	    PersonForm: _PersonForm2.default
	  }
	};

/***/ }),
/* 507 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'person-form',
	  props: {
	    person: {
	      type: Object,
	      required: true
	    }
	  },
	  computed: {
	    persons: function persons() {
	      var _this = this;
	
	      var persons = this.$store.getters['persons/data'](this.$store.dispatch);
	
	      return persons.filter(function (_ref) {
	        var id = _ref.id;
	        return id !== _this.person.id;
	      }).map(function (_ref2) {
	        var id = _ref2.id,
	            name = _ref2.name;
	        return { value: id, label: name };
	      });
	    },
	    fields: function fields() {
	      var fields = {
	        'name': {
	          type: 'text',
	          rules: [{ required: true }, { max: 101 }]
	        },
	        'address': {
	          type: 'text',
	          rules: [{ max: 120 }]
	        },
	        'idcardnumber': {
	          type: 'text',
	          rules: [{ max: 120 }]
	        },
	        'workplace': {
	          type: 'text',
	          rules: [{ max: 80 }]
	        },
	        'supervisor': {
	          type: 'select',
	          rules: [{ max: 120 }],
	          options: this.persons
	        },
	        'otheridentificator': {
	          type: 'text',
	          rules: [{ max: 120 }]
	        },
	        'picture': {
	          type: 'file',
	          multiple: false,
	          preview: this.person.pictureURL
	        }
	
	      };
	
	      return fields;
	    }
	  },
	  methods: {
	    afterSubmit: function afterSubmit(formModel) {
	      this.$router.back();
	    }
	  }
	};

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseList = __webpack_require__(46);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'person-list',
	  components: { BaseList: _BaseList2.default }
	};

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _findAll = __webpack_require__(33);
	
	var _findAll2 = _interopRequireDefault(_findAll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'reader-form',
	  props: {
	    reader: {
	      type: Object,
	      required: true
	    }
	  },
	  computed: {
	    fields: function fields() {
	      return {
	        'name': {},
	        'type': {
	          disabled: true
	        },
	        'direction': {
	          type: 'select',
	          options: [{ value: 'in', label: 'in' }, { value: 'out', label: 'out' }, { value: 'inout', label: 'inout' }]
	        },
	        'switch_id': {
	          type: 'select',
	          options: this.switchOptions,
	          disabled: this.reader.type === 'bt'
	        }
	      };
	    }
	  },
	  mixins: [(0, _findAll2.default)('switches', 'switchOptions', {
	    filter: function filter(_ref) {
	      var controller_id = _ref.controller_id;
	      return controller_id === this.reader.controller_id;
	    },
	    map: function map(_ref2) {
	      var id = _ref2.id,
	          name = _ref2.name;
	      return { value: id, label: name };
	    }
	  })]
	};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _http = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'licence-uploader',
	  props: {
	    'server': {
	      type: Object,
	      required: true
	    }
	  },
	  computed: {
	    fields: function fields() {
	      return {
	        'license': {
	          type: 'textarea',
	          rules: [{ required: true }]
	        }
	      };
	    }
	  },
	  methods: {
	    submit: function submit(_ref) {
	      var _this = this;
	
	      var id = _ref.id,
	          license = _ref.license;
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return (0, _http.post)('api/v1/servers/add-license', { id: id, license: license });
	
	              case 3:
	                _context.next = 8;
	                break;
	
	              case 5:
	                _context.prev = 5;
	                _context.t0 = _context['catch'](0);
	
	                console.error(_context.t0);
	
	              case 8:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[0, 5]]);
	      }))();
	    }
	  }
	};

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _http = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'parent-server-setup',
	  props: {
	    'server': {
	      type: Object,
	      required: true
	    }
	  },
	  computed: {
	    fields: function fields() {
	      return {
	        'passphrase': {
	          type: 'text',
	          rules: [{ required: true }]
	        },
	        'parent_fqdn': {
	          type: 'text',
	          rules: [{ required: true }]
	        }
	      };
	    }
	  },
	  methods: {
	    submit: function submit(_ref) {
	      var _this = this;
	
	      var id = _ref.id,
	          passphrase = _ref.passphrase,
	          parent_fqdn = _ref.parent_fqdn;
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return (0, _http.post)('api/v1/servers/set-parent', { id: id, passphrase: passphrase, parent_fqdn: parent_fqdn });
	
	              case 3:
	                _context.next = 8;
	                break;
	
	              case 5:
	                _context.prev = 5;
	                _context.t0 = _context['catch'](0);
	
	                console.error(_context.t0);
	
	              case 8:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[0, 5]]);
	      }))();
	    }
	  }
	};

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dashboard = __webpack_require__(412);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _ServerSettings = __webpack_require__(944);
	
	var _ServerSettings2 = _interopRequireDefault(_ServerSettings);
	
	var _ParentServer = __webpack_require__(941);
	
	var _ParentServer2 = _interopRequireDefault(_ParentServer);
	
	var _LicenceUploader = __webpack_require__(940);
	
	var _LicenceUploader2 = _interopRequireDefault(_LicenceUploader);
	
	var _ServerList = __webpack_require__(943);
	
	var _ServerList2 = _interopRequireDefault(_ServerList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'server-details',
	  data: function data() {
	    return {
	      currentTab: '0'
	    };
	  },
	
	  computed: {
	    server: function server() {
	      var id = this.$route.params.id;
	
	      if (!id) {
	        return this.$store.getters['servers/data'](this.$store.dispatch).find(function (s) {
	          return s.self;
	        }) || {};
	      }
	
	      return this.$store.getters['servers/findById'](id, this.$store.dispatch);
	    },
	    childServers: function childServers() {
	      var _this = this;
	
	      return this.$store.getters['servers/data'](this.$store.dispatch).filter(function (s) {
	        return s.parent_server_id === _this.server.id;
	      });
	    }
	  },
	  watch: {
	    $route: function $route() {
	      this.currentTab = 0;
	    }
	  },
	  components: {
	    Dashboard: _Dashboard2.default,
	    ServerSettings: _ServerSettings2.default,
	    ServerList: _ServerList2.default,
	    ParentServer: _ParentServer2.default,
	    LicenceUploader: _LicenceUploader2.default
	  }
	};

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _http = __webpack_require__(8);
	
	var _routes = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'server-list',
	  props: {
	    'servers': {
	      type: Array,
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      showActivateDialog: false,
	      showInactivateDialog: false,
	      serverToActivate: null,
	      serverToInactivate: null,
	      activateFields: {
	        'passphrase': {
	          type: 'text',
	          rules: [{ required: true }]
	        }
	      }
	    };
	  },
	
	  computed: {
	    operations: function operations() {
	      return [{
	        label: 'activate',
	        method: this._activateOperation,
	        permission: ['ACTIVATE_SERVER', 'id'],
	        precondition: function precondition(server) {
	          return !server.connected;
	        }
	      }, {
	        label: 'inactivate',
	        type: 'danger',
	        icon: 'delete',
	        method: this._inactivateOperation,
	        permission: ['INACTIVATE_SERVER', 'id'],
	        precondition: function precondition(server) {
	          return server.connected;
	        }
	      }, {
	        label: 'details',
	        method: this._detailsOperation,
	        permission: ['VIEW_SERVERS', 'id'],
	        precondition: function precondition(server) {
	          return server.connected;
	        }
	      }];
	    }
	  },
	  methods: {
	    _activateOperation: function _activateOperation(server) {
	      this.serverToActivate = server;
	      this.showActivateDialog = true;
	    },
	    activateServer: function activateServer(_ref) {
	      var _this = this;
	
	      var id = _ref.id,
	          passphrase = _ref.passphrase;
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return (0, _http.post)('api/v1/servers/activate', { id: id, passphrase: passphrase });
	
	              case 3:
	                _this.serverToActivate.connected = true;
	                _context.next = 9;
	                break;
	
	              case 6:
	                _context.prev = 6;
	                _context.t0 = _context['catch'](0);
	
	                console.error(_context.t0);
	
	              case 9:
	
	                _this.serverToActivate = {};
	                _this.showActivateDialog = false;
	
	              case 11:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[0, 6]]);
	      }))();
	    },
	    cancelActivation: function cancelActivation() {
	      this.showActivateDialog = false;
	    },
	    _inactivateOperation: function _inactivateOperation(server) {
	      this.serverToInactivate = server;
	      this.showInactivateDialog = true;
	    },
	    inactivateServer: function inactivateServer() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.prev = 0;
	                _context2.next = 3;
	                return (0, _http.post)('api/v1/servers/inactivate', { id: _this2.serverToInactivate.id });
	
	              case 3:
	                _this2.serverToInactivate.connected = false;
	                _context2.next = 9;
	                break;
	
	              case 6:
	                _context2.prev = 6;
	                _context2.t0 = _context2['catch'](0);
	
	                console.error(_context2.t0);
	
	              case 9:
	
	                _this2.serverToInactivate = {};
	                _this2.showInactivateDialog = false;
	
	              case 11:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2, [[0, 6]]);
	      }))();
	    },
	    _detailsOperation: function _detailsOperation(server) {
	      this.$router.push({ name: _routes.CHILD_SERVER_DETAILS, params: { 'id': server.id } });
	    }
	  }
	};

/***/ }),
/* 514 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'server-settings',
	  props: {
	    'server': {
	      type: Object,
	      required: true
	    }
	  },
	  computed: {
	    fields: function fields() {
	      return {
	        'fqdn': {
	          type: 'text',
	          rules: [{ required: true }]
	        },
	        'description': {
	          type: 'text',
	          rules: [{ max: 80 }]
	        },
	        'owner_id': {
	          type: 'select',
	          options: this.filterOptions('owners')(),
	          filter: this.filterOptions('owners'),
	          rules: [{ required: false }],
	          hidden: !this.isEnterprise
	        },
	        'location_id': {
	          type: 'select',
	          options: this.filterOptions('locations')(),
	          filter: this.filterOptions('locations'),
	          rules: [{ required: false }],
	          hidden: !this.isEnterprise
	        }
	      };
	    }
	  },
	  methods: {
	    filterOptions: function filterOptions(model) {
	      var _this = this;
	
	      var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (model) {
	        return { label: model.name, value: model.id };
	      };
	
	      return function (query) {
	        var models = _this.$store.getters[model + '/data'](_this.$store.dispatch);
	
	        return models.map(map).filter(function (option) {
	          return option.label.toLowerCase().includes((query || '').toLowerCase());
	        });
	      };
	    }
	  }
	};

/***/ }),
/* 515 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'admin-modification',
	  data: function data() {
	    return {
	      fields: {
	        'id': {
	          type: 'hidden'
	        },
	        'email': {
	          type: 'email',
	          rules: [{ required: true }, { max: 254 }, { type: 'email' }]
	        },
	        'password': {
	          type: 'password',
	          rules: [{ required: true }, { max: 254 }]
	        }
	      }
	    };
	  },
	
	  computed: {
	    currentUser: function currentUser() {
	      var currentUser = this.$store.getters.currentUser || {};
	
	      return {
	        id: currentUser.id,
	        email: currentUser.email
	      };
	    }
	  },
	  methods: {
	    afterSubmit: function afterSubmit() {
	      this.$emit('next');
	    }
	  }
	};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _http = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ip-setup',
	  data: function data() {
	    return {
	      loading: true,
	      formModel: {
	        customDhcp: false,
	        ipAddress: '',
	        netmask: '',
	        gateway: '',
	        customPorts: false,
	        serverProtocoll: 'https',
	        serverPort: '3334',
	        mqttPort: '8883',
	        websocketPort: '3335'
	      }
	    };
	  },
	
	  computed: {
	    fields: function fields() {
	      var fields = {
	        'customDhcp': {
	          type: 'checkbox'
	        },
	        'ipAddress': {
	          disabled: !this.formModel.customDhcp,
	          type: 'text',
	          rules: [{ max: 16 }]
	        },
	        'netmask': {
	          disabled: !this.formModel.customDhcp,
	          type: 'text',
	          rules: [{ max: 16 }]
	        },
	        'gateway': {
	          disabled: !this.formModel.customDhcp,
	          type: 'text',
	          rules: [{ max: 16 }]
	        },
	        'customPorts': {
	          type: 'checkbox'
	        },
	        'serverProtocoll': {
	          disabled: !this.formModel.customPorts,
	          type: 'radio',
	          options: [{
	            value: 'http',
	            label: 'serverProtocoll.http'
	          }, {
	            value: 'https',
	            label: 'serverProtocoll.https'
	          }]
	        },
	        'serverPort': {
	          disabled: !this.formModel.customPorts,
	          type: 'text',
	          rules: [{ max: 5 }]
	        },
	        'mqttPort': {
	          disabled: !this.formModel.customPorts,
	          type: 'text',
	          rules: [{ max: 5 }]
	        },
	        'websocketPort': {
	          disabled: !this.formModel.customPorts,
	          type: 'text',
	          rules: [{ max: 5 }]
	        }
	      };
	
	      return fields;
	    }
	  },
	  methods: {
	    onChange: function onChange(formModel) {
	      this.formModel = formModel;
	    },
	    onSubmit: function onSubmit(formModel) {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return (0, _http.post)('api/v1/servers/ip-setup', formModel);
	
	              case 3:
	                _this.$emit('next');
	                _context.next = 9;
	                break;
	
	              case 6:
	                _context.prev = 6;
	                _context.t0 = _context['catch'](0);
	
	                console.error(_context.t0);
	
	              case 9:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[0, 6]]);
	      }))();
	    }
	  },
	  beforeMount: function beforeMount() {
	    var _this2 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	      var status;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.next = 2;
	              return (0, _http.get)('api/v1/status/lan');
	
	            case 2:
	              status = _context2.sent;
	
	              _this2.formModel.ipAddress = status.address;
	              _this2.formModel.netmask = status.netmask;
	              _this2.formModel.gateway = status.gatewayIp;
	
	              _this2.loading = false;
	
	            case 7:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }))();
	  }
	};

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _locationFields = __webpack_require__(197);
	
	var _locationFields2 = _interopRequireDefault(_locationFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'location-form',
	  data: function data() {
	    return {
	      model: {
	        id: 'new'
	      },
	      locationFields: _locationFields2.default
	    };
	  },
	
	  computed: {},
	  methods: {
	    afterSubmit: function afterSubmit() {
	      this.$emit('next');
	    }
	  },
	  beforeMount: function beforeMount() {}
	};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _http = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'network-connection',
	  data: function data() {
	    return {
	      formModel: {
	        networkType: 'wifi'
	      }
	    };
	  },
	
	  computed: {
	    fields: function fields() {
	      var fields = {
	        'networkType': {
	          type: 'radio',
	          options: [{
	            value: 'wifi',
	            label: 'networkType.wifi'
	          }, {
	            value: 'cable',
	            label: 'networkType.cable'
	          }]
	        },
	        'ssid': {
	          hidden: this.formModel.networkType === 'cable',
	          rules: [{ required: true }]
	        },
	        'secuType': {
	          hidden: this.formModel.networkType === 'cable',
	          type: 'select',
	          options: [{
	            value: 1,
	            label: 'secType.none'
	          }, {
	            value: 2,
	            label: 'secType.WEP'
	          }, {
	            value: 3,
	            label: 'secType.WPA'
	          }, {
	            value: 4,
	            label: 'secType.WPA2'
	          }]
	        },
	        'secuPassphrase': {
	          hidden: this.formModel.networkType === 'cable',
	          type: 'password',
	          rules: [{ required: true }]
	        }
	      };
	
	      return fields;
	    }
	  },
	  methods: {
	    onChange: function onChange(formModel) {
	      this.formModel = formModel;
	    },
	    onSubmit: function onSubmit(formModel) {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return (0, _http.post)('api/v1/servers/set-network-connetion', formModel);
	
	              case 3:
	                _this.$emit('next');
	                _context.next = 9;
	                break;
	
	              case 6:
	                _context.prev = 6;
	                _context.t0 = _context['catch'](0);
	
	                console.error(_context.t0);
	
	              case 9:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[0, 6]]);
	      }))();
	    }
	  },
	  beforeMount: function beforeMount() {}
	};

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ownerFields = __webpack_require__(198);
	
	var _ownerFields2 = _interopRequireDefault(_ownerFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'owner-form',
	  data: function data() {
	    return {
	      model: {
	        id: 'new'
	      },
	      ownerFields: _ownerFields2.default
	    };
	  },
	
	  computed: {},
	  methods: {
	    afterSubmit: function afterSubmit() {
	      this.$emit('next');
	    }
	  },
	  beforeMount: function beforeMount() {}
	};

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _http = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ssl-setup',
	  data: function data() {
	    return {
	      loading: false,
	      formModel: {
	        sslSetupType: 'auto',
	        certificate: '',
	        key: ''
	      }
	    };
	  },
	
	  computed: {
	    fields: function fields() {
	      var fields = {
	        'sslSetupType': {
	          type: 'radio',
	          options: [{
	            value: 'auto',
	            label: 'sslSetupType.auto'
	          }, {
	            value: 'manual',
	            label: 'networkType.manual'
	          }]
	        },
	        'certificate': {
	          disabled: this.formModel.sslSetupType === 'auto',
	          type: 'textarea'
	        },
	        'key': {
	          disabled: this.formModel.sslSetupType === 'auto',
	          type: 'text'
	        }
	      };
	
	      return fields;
	    }
	  },
	  methods: {
	    onChange: function onChange(formModel) {
	      this.formModel = formModel;
	    },
	    onSubmit: function onSubmit(formModel) {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return (0, _http.post)('api/v1/servers/ssl-setup', formModel);
	
	              case 3:
	                _this.$emit('next');
	                _context.next = 9;
	                break;
	
	              case 6:
	                _context.prev = 6;
	                _context.t0 = _context['catch'](0);
	
	                console.error(_context.t0);
	
	              case 9:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[0, 6]]);
	      }))();
	    }
	  },
	  beforeMount: function beforeMount() {
	    var _this2 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	      var status;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.next = 2;
	              return (0, _http.get)('api/v1/servers/ssl-setup');
	
	            case 2:
	              status = _context2.sent;
	
	
	              _this2.formModel.certificate = status.certificate;
	              _this2.formModel.key = status.key;
	
	              _this2.loading = false;
	
	            case 6:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }))();
	  }
	};

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _http = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'server-domain-setup',
	  data: function data() {
	    return {
	      loading: false,
	      formModel: {
	        customize: false,
	        serverName: '',
	        domainName: '',
	        ip: ''
	      }
	    };
	  },
	
	  computed: {
	    fields: function fields() {
	      var fields = {
	        'customize': {
	          type: 'checkbox'
	        },
	        'serverName': {
	          disabled: !this.formModel.customize,
	          type: 'text'
	        },
	        'domainName': {
	          disabled: !this.formModel.customize,
	          type: 'text'
	        },
	        'ip': {
	          disabled: !this.formModel.customize,
	          type: 'text',
	          rules: [{ max: 16 }]
	        }
	      };
	
	      return fields;
	    }
	  },
	  methods: {
	    onChange: function onChange(formModel) {
	      this.formModel = formModel;
	    },
	    onSubmit: function onSubmit(formModel) {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return (0, _http.post)('api/v1/servers/server-domain-setup', formModel);
	
	              case 3:
	                _this.$emit('next');
	                _context.next = 9;
	                break;
	
	              case 6:
	                _context.prev = 6;
	                _context.t0 = _context['catch'](0);
	
	                console.error(_context.t0);
	
	              case 9:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[0, 6]]);
	      }))();
	    }
	  },
	  beforeMount: function beforeMount() {
	    var _this2 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	      var status;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.next = 2;
	              return (0, _http.get)('api/v1/servers/server-domain-setup');
	
	            case 2:
	              status = _context2.sent;
	
	              _this2.formModel.serverName = status.serverName;
	              _this2.formModel.domainName = status.domainName;
	              _this2.formModel.ip = status.ip;
	
	              _this2.loading = false;
	
	            case 7:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }))();
	  }
	};

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AdminModification = __webpack_require__(945);
	
	var _AdminModification2 = _interopRequireDefault(_AdminModification);
	
	var _OwnerForm = __webpack_require__(949);
	
	var _OwnerForm2 = _interopRequireDefault(_OwnerForm);
	
	var _LocationForm = __webpack_require__(947);
	
	var _LocationForm2 = _interopRequireDefault(_LocationForm);
	
	var _NetworkConnection = __webpack_require__(948);
	
	var _NetworkConnection2 = _interopRequireDefault(_NetworkConnection);
	
	var _IPSetup = __webpack_require__(946);
	
	var _IPSetup2 = _interopRequireDefault(_IPSetup);
	
	var _ServerDomainSetup = __webpack_require__(951);
	
	var _ServerDomainSetup2 = _interopRequireDefault(_ServerDomainSetup);
	
	var _SSLSetup = __webpack_require__(950);
	
	var _SSLSetup2 = _interopRequireDefault(_SSLSetup);
	
	var _routes = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'welcome',
	  data: function data() {
	    return {
	      active: 0,
	      steps: ['AdminModification', 'OwnerForm', 'LocationForm', 'NetworkConnection', 'IpSetup', 'ServerDomainSetup', 'SslSetup']
	    };
	  },
	
	  methods: {
	    next: function next() {
	      if (this.active >= this.steps.length - 1) {
	        this.$router.push({ name: _routes.HOME });
	      } else {
	        this.active++;
	      }
	    }
	  },
	
	  components: {
	    AdminModification: _AdminModification2.default,
	    OwnerForm: _OwnerForm2.default,
	    LocationForm: _LocationForm2.default,
	    NetworkConnection: _NetworkConnection2.default,
	    IpSetup: _IPSetup2.default,
	    ServerDomainSetup: _ServerDomainSetup2.default,
	    SslSetup: _SSLSetup2.default
	  }
	};

/***/ }),
/* 523 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'switch-group-details',
	  data: function data() {
	    return {
	      newRelatedSwitchIds: [],
	      fields: {
	        'name': {
	          type: 'text',
	          rules: [{ required: true }, { max: 80 }]
	        },
	        'description': {
	          type: 'textarea',
	          rules: [{ required: true }, { max: 80 }]
	        }
	      }
	    };
	  },
	
	  computed: {
	    switchGroup: function switchGroup() {
	      var id = this.$route.params.id;
	
	      if (id === 'new') {
	        return { new: true, relatedSwitchIds: [] };
	      }
	
	      return this.$store.getters['switch-groups/findById'](id, this.$store.dispatch);
	    },
	    action: function action() {
	      return this.switchGroup.new ? 'create' : 'edit';
	    }
	  },
	  methods: {
	    beforeSubmit: function beforeSubmit(model) {
	      model.newRelatedSwitchIds = this.newRelatedSwitchIds;
	    },
	    afterSubmit: function afterSubmit() {
	      this.$router.back();
	    },
	    isSwitchSelected: function isSwitchSelected(xswitch) {
	      return this.switchGroup.relatedSwitchIds.includes(xswitch.id);
	    },
	    switchSelectChanged: function switchSelectChanged(selectedSwitches) {
	      this.newRelatedSwitchIds = selectedSwitches.map(function (c) {
	        return c.id;
	      });
	    }
	  }
	};

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseList = __webpack_require__(46);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'switch-group-list',
	  components: { BaseList: _BaseList2.default }
	};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'server-switch-form',
	  props: {
	    switchx: {
	      type: Object,
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      fields: {
	        'usage': {
	          type: 'select',
	          options: [{ label: 'switch.entry-point', value: 'entry-point' }, { label: 'switch.hidden', value: 'hidden' }, { label: 'switch.system', value: 'system' }]
	        },
	        'systemForm': {
	          type: 'hidden'
	        }
	      }
	    };
	  },
	
	  computed: {
	    formValue: function formValue() {
	      return (0, _extends3.default)({}, this.switchx, { 'systemForm': 1 });
	    }
	  }
	};

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SwitchForm = __webpack_require__(417);
	
	var _SwitchForm2 = _interopRequireDefault(_SwitchForm);
	
	var _ServerSwitchForm = __webpack_require__(416);
	
	var _ServerSwitchForm2 = _interopRequireDefault(_ServerSwitchForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'switch-details',
	  computed: {
	    switchx: function switchx() {
	      var id = this.$route.params.id;
	
	      return this.$store.getters['switches/findById'](id, this.$store.dispatch);
	    }
	  },
	  components: {
	    SwitchForm: _SwitchForm2.default,
	    ServerSwitchForm: _ServerSwitchForm2.default
	  }
	};

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var switchTypes = ['garage', 'gate', 'light', 'switch'];
	var switchModes = ['online', 'offline', 'anti-pb', 'learning'];
	
	exports.default = {
	  name: 'switch-form',
	  props: {
	    switchx: {
	      type: Object,
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      fields: {
	        'name': {
	          rules: [{ required: true, max: 12 }]
	        },
	        'type': {
	          type: 'select',
	          rules: [{ required: true, type: 'number' }],
	          options: switchTypes.map(function (t, i) {
	            return { label: 'switchType.' + t, value: i + 1 };
	          })
	        },
	        'pausetime': {
	          type: 'number',
	          rules: [{ type: 'number', required: true }]
	        },
	        'autoclosetime': {
	          type: 'number',
	          rules: [{ type: 'number', required: true }]
	        },
	        'mode': {
	          type: 'select',
	          rules: [{ required: true }],
	          options: switchModes.map(function (t) {
	            return { label: 'switchMode.' + t, value: t };
	          })
	        },
	        'systemForm': {
	          type: 'hidden'
	        }
	      },
	      buttons: [{
	        label: 'submit-scheduled',
	        submit: true,
	        icon: 'time',
	        type: 'success',
	        params: {
	          scheduled: true
	        }
	      }, {
	        label: 'submit',
	        icon: 'circle-check',
	        submit: true,
	        params: {
	          scheduled: false
	        }
	      }]
	    };
	  },
	
	  computed: {
	    formValue: function formValue() {
	      return (0, _extends3.default)({}, this.switchx, { 'systemForm': 0 });
	    }
	  }
	};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(545);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _findAll = __webpack_require__(33);
	
	var _findAll2 = _interopRequireDefault(_findAll);
	
	var _routes = __webpack_require__(59);
	
	var _http = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'switch-list',
	  methods: {
	    sort: function sort(first, second) {
	      var comp = first.controllerName.localeCompare(second.controllerName);
	
	      if (comp !== 0) {
	        return comp;
	      }
	
	      return first.name.localeCompare(second.name);
	    }
	  },
	  computed: {
	    operations: function operations() {
	      var _this = this;
	
	      return [{
	        label: 'edit',
	        icon: 'edit',
	        permission: ['EDIT_SWITCH', 'server_id'],
	        method: function method(swithc) {
	          return _this.$router.push({ name: _routes.SWITCH_EDIT, params: { 'id': swithc.id } });
	        }
	      }, {
	        label: 'single-access',
	        type: 'success',
	        icon: 'circle-check',
	        permission: ['VIEW_SINGLE_MOBILE_ACCESSES', 'server_id'],
	        method: function method(swithc) {
	          return _this.$router.push({ name: _routes.SINGLE_SWITCH_ACCESS, params: { 'id': swithc.id } });
	        }
	      }, {
	        label: 'off',
	        type: 'danger',
	        icon: 'circle-close',
	        permission: ['TOGGLE_SWITCH', 'server_id'],
	        method: function method(swithc) {
	          return (0, _http.post)('api/v1/toggle/' + swithc.id, { state: 1 });
	        }
	      }, {
	        label: 'on',
	        type: 'success',
	        icon: 'caret-right',
	        permission: ['TOGGLE_SWITCH', 'server_id'],
	        method: function method(swithc) {
	          return (0, _http.post)('api/v1/toggle/' + swithc.id, { state: 2 });
	        }
	      }, {
	        label: 'toggle',
	        type: 'success',
	        icon: 'time',
	        permission: ['TOGGLE_SWITCH', 'server_id'],
	        method: function method(swithc) {
	          return (0, _http.post)('api/v1/toggle/' + swithc.id, { state: 3 });
	        }
	      }];
	    }
	  },
	  mixins: [(0, _findAll2.default)('switches', {
	    filter: function filter(_ref) {
	      var usage = _ref.usage;
	      return usage === 'entry-point' || usage === 'system';
	    },
	
	    map: function map(_ref2) {
	      var switchGroups = _ref2.switchGroups,
	          swithc = (0, _objectWithoutProperties3.default)(_ref2, ['switchGroups']);
	      return (0, _extends3.default)({}, swithc, {
	        switchGroupNames: switchGroups.map(function (g) {
	          return g.name;
	        }).join(', ')
	      });
	    }
	  })]
	};

/***/ }),
/* 529 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'system-parameter-list',
	  data: function data() {
	    return {
	      selected: null,
	      fields: {
	        'id': {
	          disabled: true
	        },
	        'value': {
	          required: true
	        }
	      }
	    };
	  },
	
	  methods: {
	    rowClick: function rowClick(row) {
	      this.selected = row;
	    }
	  }
	};

/***/ }),
/* 530 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'user-level-details',
	  data: function data() {
	    return {
	      relatedAppFunctions: [],
	      fields: {
	        'name': {
	          type: 'text',
	          rules: [{ required: true }, { max: 80 }]
	        }
	      }
	    };
	  },
	
	  computed: {
	    userLevel: function userLevel() {
	      var id = this.$route.params.id;
	
	      if (id === 'new') {
	        return { new: true };
	      }
	
	      return this.$store.getters['user-levels/findById'](id, this.$store.dispatch);
	    },
	    action: function action() {
	      return this.userLevel.new ? 'create' : 'edit';
	    }
	  },
	  watch: {
	    userLevel: function userLevel() {
	      this.$refs.functionTable.tableDataChanged = true;
	    }
	  },
	  methods: {
	    beforeSubmit: function beforeSubmit(formModel) {
	      formModel.relatedAppFunctions = this.relatedAppFunctions.map(function (i) {
	        return i.id;
	      });
	    },
	    afterSubmit: function afterSubmit(formModel) {
	      this.$router.back();
	    },
	    isAppFunctionSelected: function isAppFunctionSelected(appFunction) {
	      if (!this.userLevel.appFunctions) return false;
	      return this.userLevel.appFunctions.map(function (f) {
	        return f.id;
	      }).includes(appFunction.id);
	    },
	    appFunctionSelectChanged: function appFunctionSelectChanged(selection) {
	      this.relatedAppFunctions = selection;
	    }
	  }
	};

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseList = __webpack_require__(46);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'user-level-list',
	  components: { BaseList: _BaseList2.default }
	};

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _defineProperty2 = __webpack_require__(52);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(13);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _slicedToArray2 = __webpack_require__(102);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(201);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _UserForm = __webpack_require__(961);
	
	var _UserForm2 = _interopRequireDefault(_UserForm);
	
	var _http = __webpack_require__(8);
	
	var _findAll = __webpack_require__(33);
	
	var _findAll2 = _interopRequireDefault(_findAll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'user-details',
	  data: function data() {
	    return {
	      currentTab: null,
	      selectedUserLevels: {},
	      isLoading: false,
	      query: null
	    };
	  },
	
	  computed: {
	    user: function user() {
	      var id = this.$route.params.id;
	
	      if (id === 'new') {
	        return { new: true };
	      }
	
	      return this.$store.getters['users/findById'](id, this.$store.dispatch);
	    },
	    action: function action() {
	      return this.user.new ? 'create' : 'edit';
	    },
	    serverAccessFields: function serverAccessFields() {
	      return {
	        'userLevelId': {
	          type: 'select',
	          options: this.userLevels.map(function (ul) {
	            return { value: ul.id, label: ul.name };
	          })
	        }
	      };
	    }
	  },
	  methods: {
	    submitUserLevels: function submitUserLevels() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                data = {
	                  userId: _this.user.id,
	                  userLevels: (0, _entries2.default)(_this.selectedUserLevels).reduce(function (acc, _ref) {
	                    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	                        key = _ref2[0],
	                        value = _ref2[1];
	
	                    return (0, _extends4.default)({}, acc, (0, _defineProperty3.default)({}, key, value.userLevelId));
	                  }, {})
	                };
	                _context.prev = 1;
	                _context.next = 4;
	                return (0, _http.post)('api/v1/users/set-user-levels', data);
	
	              case 4:
	                _this.showSuccess('user-levels-updated');
	                _context.next = 10;
	                break;
	
	              case 7:
	                _context.prev = 7;
	                _context.t0 = _context['catch'](1);
	
	                console.error(_context.t0);
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[1, 7]]);
	      }))();
	    },
	    userLevelSelected: function userLevelSelected(serverId, userLevelId) {
	      this.selectedUserLevels[serverId] = userLevelId;
	    },
	    recomputeSelectedUserLevels: function recomputeSelectedUserLevels() {
	      var _this2 = this;
	
	      this.servers.forEach(function (s) {
	        var userLevelId = ((_this2.user.serverAccesses || []).find(function (sa) {
	          return sa.server_id === s.id;
	        }) || {}).user_level_id;
	
	        _this2.selectedUserLevels[s.id] = { userLevelId: userLevelId };
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.recomputeSelectedUserLevels();
	  },
	
	  watch: {
	    servers: function servers() {
	      this.recomputeSelectedUserLevels();
	    },
	    user: function user() {
	      this.recomputeSelectedUserLevels();
	    }
	  },
	  mixins: [(0, _findAll2.default)('servers'), (0, _findAll2.default)('user-levels', 'userLevels')],
	  components: {
	    UserForm: _UserForm2.default
	  }
	};

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'user-form',
	  props: {
	    user: {
	      type: Object,
	      required: true
	    }
	  },
	  computed: {
	    fields: function fields() {
	      var fields = {
	        'email': {
	          type: 'email',
	          rules: [{ required: true }, { max: 254 }, { type: 'email' }]
	        },
	        'first_name': {
	          type: 'text',
	          rules: [{ required: true }, { max: 50 }]
	        },
	        'last_name': {
	          type: 'text',
	          rules: [{ required: true }, { max: 50 }]
	        },
	        'phone': {
	          type: 'text',
	          rules: [{ max: 16 }]
	        },
	        'password': {
	          type: 'password',
	          rules: [{ required: this.user.new }, { max: 254 }]
	        }
	      };
	
	      return fields;
	    }
	  },
	  methods: {
	    afterSubmit: function afterSubmit(formModel) {
	      this.$router.back();
	    }
	  }
	};

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseList = __webpack_require__(46);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'user-list',
	  components: { BaseList: _BaseList2.default }
	};

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _http = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IP_PATTERN = '/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/';
	
	exports.default = {
	  name: 'controller-wifi-setting',
	  props: {
	    controller: {
	      type: Object,
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      formModel: {
	        manualDhcp: false,
	        securityType: 1
	      }
	    };
	  },
	
	  computed: {
	    fields: function fields() {
	      var fields = {
	        'ssid': {
	          rules: [{ required: true }]
	        },
	        'securityType': {
	          type: 'select',
	          options: [{
	            value: 1,
	            label: 'secType.none'
	          }, {
	            value: 2,
	            label: 'secType.WEP'
	          }, {
	            value: 3,
	            label: 'secType.WPA'
	          }, {
	            value: 4,
	            label: 'secType.WPA2'
	          }],
	          rules: [{ required: true }]
	        },
	        'password': {
	          type: 'password',
	          rules: [{ required: this.formModel.securityType !== 1 }]
	        },
	        'serverHost': {
	          rules: [{
	            type: 'regexp',
	            pattern: IP_PATTERN
	          }]
	        },
	        'serverPort': {},
	        'serverShortCode': {},
	        'manualDhcp': {
	          type: 'checkbox'
	        }
	      };
	
	      var dhcpFields = void 0;
	
	      if (this.formModel.manualDhcp) {
	        dhcpFields = {
	          'controllerIp': {
	            rules: [{
	              type: 'regexp',
	              pattern: IP_PATTERN
	            }]
	          },
	          'gatewayIp': {
	            rules: [{
	              type: 'regexp',
	              pattern: IP_PATTERN
	            }]
	          },
	          'subnetMask': {
	            rules: [{
	              type: 'regexp',
	              pattern: IP_PATTERN
	            }]
	          }
	        };
	      }
	
	      return (0, _extends3.default)({}, fields, dhcpFields);
	    }
	  },
	  methods: {
	    onChange: function onChange(formModel) {
	      this.formModel = formModel;
	    },
	    onSubmit: function onSubmit(formModel) {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var id;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                id = _this.controller.id;
	                _context.prev = 1;
	                _context.next = 4;
	                return (0, _http.post)('api/v1/controllers/set-wifi/' + id, formModel);
	
	              case 4:
	                _context.next = 9;
	                break;
	
	              case 6:
	                _context.prev = 6;
	                _context.t0 = _context['catch'](1);
	
	                console.error(_context.t0);
	
	              case 9:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[1, 6]]);
	      }))();
	    }
	  }
	};

/***/ }),
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 844 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 847 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 848 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 853 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 856 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 859 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 860 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 861 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 862 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 863 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 864 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 865 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 866 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 868 */,
/* 869 */,
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 273,
		"./af.js": 273,
		"./ar": 280,
		"./ar-dz": 274,
		"./ar-dz.js": 274,
		"./ar-kw": 275,
		"./ar-kw.js": 275,
		"./ar-ly": 276,
		"./ar-ly.js": 276,
		"./ar-ma": 277,
		"./ar-ma.js": 277,
		"./ar-sa": 278,
		"./ar-sa.js": 278,
		"./ar-tn": 279,
		"./ar-tn.js": 279,
		"./ar.js": 280,
		"./az": 281,
		"./az.js": 281,
		"./be": 282,
		"./be.js": 282,
		"./bg": 283,
		"./bg.js": 283,
		"./bm": 284,
		"./bm.js": 284,
		"./bn": 285,
		"./bn.js": 285,
		"./bo": 286,
		"./bo.js": 286,
		"./br": 287,
		"./br.js": 287,
		"./bs": 288,
		"./bs.js": 288,
		"./ca": 289,
		"./ca.js": 289,
		"./cs": 290,
		"./cs.js": 290,
		"./cv": 291,
		"./cv.js": 291,
		"./cy": 292,
		"./cy.js": 292,
		"./da": 293,
		"./da.js": 293,
		"./de": 296,
		"./de-at": 294,
		"./de-at.js": 294,
		"./de-ch": 295,
		"./de-ch.js": 295,
		"./de.js": 296,
		"./dv": 297,
		"./dv.js": 297,
		"./el": 298,
		"./el.js": 298,
		"./en-au": 299,
		"./en-au.js": 299,
		"./en-ca": 300,
		"./en-ca.js": 300,
		"./en-gb": 301,
		"./en-gb.js": 301,
		"./en-ie": 302,
		"./en-ie.js": 302,
		"./en-il": 303,
		"./en-il.js": 303,
		"./en-in": 304,
		"./en-in.js": 304,
		"./en-nz": 305,
		"./en-nz.js": 305,
		"./en-sg": 306,
		"./en-sg.js": 306,
		"./eo": 307,
		"./eo.js": 307,
		"./es": 310,
		"./es-do": 308,
		"./es-do.js": 308,
		"./es-us": 309,
		"./es-us.js": 309,
		"./es.js": 310,
		"./et": 311,
		"./et.js": 311,
		"./eu": 312,
		"./eu.js": 312,
		"./fa": 313,
		"./fa.js": 313,
		"./fi": 314,
		"./fi.js": 314,
		"./fil": 315,
		"./fil.js": 315,
		"./fo": 316,
		"./fo.js": 316,
		"./fr": 319,
		"./fr-ca": 317,
		"./fr-ca.js": 317,
		"./fr-ch": 318,
		"./fr-ch.js": 318,
		"./fr.js": 319,
		"./fy": 320,
		"./fy.js": 320,
		"./ga": 321,
		"./ga.js": 321,
		"./gd": 322,
		"./gd.js": 322,
		"./gl": 323,
		"./gl.js": 323,
		"./gom-deva": 324,
		"./gom-deva.js": 324,
		"./gom-latn": 325,
		"./gom-latn.js": 325,
		"./gu": 326,
		"./gu.js": 326,
		"./he": 327,
		"./he.js": 327,
		"./hi": 328,
		"./hi.js": 328,
		"./hr": 329,
		"./hr.js": 329,
		"./hu": 330,
		"./hu.js": 330,
		"./hy-am": 331,
		"./hy-am.js": 331,
		"./id": 332,
		"./id.js": 332,
		"./is": 333,
		"./is.js": 333,
		"./it": 335,
		"./it-ch": 334,
		"./it-ch.js": 334,
		"./it.js": 335,
		"./ja": 336,
		"./ja.js": 336,
		"./jv": 337,
		"./jv.js": 337,
		"./ka": 338,
		"./ka.js": 338,
		"./kk": 339,
		"./kk.js": 339,
		"./km": 340,
		"./km.js": 340,
		"./kn": 341,
		"./kn.js": 341,
		"./ko": 342,
		"./ko.js": 342,
		"./ku": 343,
		"./ku.js": 343,
		"./ky": 344,
		"./ky.js": 344,
		"./lb": 345,
		"./lb.js": 345,
		"./lo": 346,
		"./lo.js": 346,
		"./lt": 347,
		"./lt.js": 347,
		"./lv": 348,
		"./lv.js": 348,
		"./me": 349,
		"./me.js": 349,
		"./mi": 350,
		"./mi.js": 350,
		"./mk": 351,
		"./mk.js": 351,
		"./ml": 352,
		"./ml.js": 352,
		"./mn": 353,
		"./mn.js": 353,
		"./mr": 354,
		"./mr.js": 354,
		"./ms": 356,
		"./ms-my": 355,
		"./ms-my.js": 355,
		"./ms.js": 356,
		"./mt": 357,
		"./mt.js": 357,
		"./my": 358,
		"./my.js": 358,
		"./nb": 359,
		"./nb.js": 359,
		"./ne": 360,
		"./ne.js": 360,
		"./nl": 362,
		"./nl-be": 361,
		"./nl-be.js": 361,
		"./nl.js": 362,
		"./nn": 363,
		"./nn.js": 363,
		"./oc-lnc": 364,
		"./oc-lnc.js": 364,
		"./pa-in": 365,
		"./pa-in.js": 365,
		"./pl": 366,
		"./pl.js": 366,
		"./pt": 368,
		"./pt-br": 367,
		"./pt-br.js": 367,
		"./pt.js": 368,
		"./ro": 369,
		"./ro.js": 369,
		"./ru": 370,
		"./ru.js": 370,
		"./sd": 371,
		"./sd.js": 371,
		"./se": 372,
		"./se.js": 372,
		"./si": 373,
		"./si.js": 373,
		"./sk": 374,
		"./sk.js": 374,
		"./sl": 375,
		"./sl.js": 375,
		"./sq": 376,
		"./sq.js": 376,
		"./sr": 378,
		"./sr-cyrl": 377,
		"./sr-cyrl.js": 377,
		"./sr.js": 378,
		"./ss": 379,
		"./ss.js": 379,
		"./sv": 380,
		"./sv.js": 380,
		"./sw": 381,
		"./sw.js": 381,
		"./ta": 382,
		"./ta.js": 382,
		"./te": 383,
		"./te.js": 383,
		"./tet": 384,
		"./tet.js": 384,
		"./tg": 385,
		"./tg.js": 385,
		"./th": 386,
		"./th.js": 386,
		"./tl-ph": 387,
		"./tl-ph.js": 387,
		"./tlh": 388,
		"./tlh.js": 388,
		"./tr": 389,
		"./tr.js": 389,
		"./tzl": 390,
		"./tzl.js": 390,
		"./tzm": 392,
		"./tzm-latn": 391,
		"./tzm-latn.js": 391,
		"./tzm.js": 392,
		"./ug-cn": 393,
		"./ug-cn.js": 393,
		"./uk": 394,
		"./uk.js": 394,
		"./ur": 395,
		"./ur.js": 395,
		"./uz": 397,
		"./uz-latn": 396,
		"./uz-latn.js": 396,
		"./uz.js": 397,
		"./vi": 398,
		"./vi.js": 398,
		"./x-pseudo": 399,
		"./x-pseudo.js": 399,
		"./yo": 400,
		"./yo.js": 400,
		"./zh-cn": 401,
		"./zh-cn.js": 401,
		"./zh-hk": 402,
		"./zh-hk.js": 402,
		"./zh-mo": 403,
		"./zh-mo.js": 403,
		"./zh-tw": 404,
		"./zh-tw.js": 404
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 870;


/***/ }),
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(855)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(459),
	  /* template */
	  __webpack_require__(996),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(847)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(462),
	  /* template */
	  __webpack_require__(968),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(464),
	  /* template */
	  __webpack_require__(1028),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(858)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(465),
	  /* template */
	  __webpack_require__(1008),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(466),
	  /* template */
	  __webpack_require__(1011),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(853)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(467),
	  /* template */
	  __webpack_require__(991),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(468),
	  /* template */
	  __webpack_require__(1021),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(469),
	  /* template */
	  __webpack_require__(1019),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(470),
	  /* template */
	  __webpack_require__(992),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(473),
	  /* template */
	  __webpack_require__(986),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(474),
	  /* template */
	  __webpack_require__(985),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(475),
	  /* template */
	  __webpack_require__(998),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(476),
	  /* template */
	  __webpack_require__(1033),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(477),
	  /* template */
	  __webpack_require__(1002),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(478),
	  /* template */
	  __webpack_require__(1007),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(479),
	  /* template */
	  __webpack_require__(965),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(480),
	  /* template */
	  __webpack_require__(1025),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(845)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(481),
	  /* template */
	  __webpack_require__(966),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(848)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(482),
	  /* template */
	  __webpack_require__(973),
	  /* scopeId */
	  "data-v-13c44213",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(862)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(483),
	  /* template */
	  __webpack_require__(1023),
	  /* scopeId */
	  "data-v-975891ea",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(484),
	  /* template */
	  __webpack_require__(980),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(485),
	  /* template */
	  __webpack_require__(984),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(849)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(486),
	  /* template */
	  __webpack_require__(978),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(867)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(487),
	  /* template */
	  __webpack_require__(1039),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(488),
	  /* template */
	  __webpack_require__(970),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(491),
	  /* template */
	  __webpack_require__(1020),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(492),
	  /* template */
	  __webpack_require__(997),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(493),
	  /* template */
	  __webpack_require__(982),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(494),
	  /* template */
	  __webpack_require__(1029),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(495),
	  /* template */
	  __webpack_require__(1040),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(496),
	  /* template */
	  __webpack_require__(979),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(497),
	  /* template */
	  __webpack_require__(994),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(498),
	  /* template */
	  __webpack_require__(971),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(499),
	  /* template */
	  __webpack_require__(1015),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(846)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(500),
	  /* template */
	  __webpack_require__(967),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(850)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(501),
	  /* template */
	  __webpack_require__(981),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(861)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(502),
	  /* template */
	  __webpack_require__(1022),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(503),
	  /* template */
	  __webpack_require__(1017),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(851)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(504),
	  /* template */
	  __webpack_require__(988),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(505),
	  /* template */
	  __webpack_require__(972),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(506),
	  /* template */
	  __webpack_require__(1030),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(507),
	  /* template */
	  __webpack_require__(1016),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(508),
	  /* template */
	  __webpack_require__(1026),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(509),
	  /* template */
	  __webpack_require__(976),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(510),
	  /* template */
	  __webpack_require__(990),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(511),
	  /* template */
	  __webpack_require__(1014),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(512),
	  /* template */
	  __webpack_require__(995),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(513),
	  /* template */
	  __webpack_require__(1027),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(514),
	  /* template */
	  __webpack_require__(977),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(515),
	  /* template */
	  __webpack_require__(987),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(860)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(516),
	  /* template */
	  __webpack_require__(1010),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(859)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(517),
	  /* template */
	  __webpack_require__(1009),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(857)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(518),
	  /* template */
	  __webpack_require__(1001),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(844)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(519),
	  /* template */
	  __webpack_require__(964),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(863)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(520),
	  /* template */
	  __webpack_require__(1032),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(864)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(521),
	  /* template */
	  __webpack_require__(1034),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(852)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(522),
	  /* template */
	  __webpack_require__(989),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(523),
	  /* template */
	  __webpack_require__(1012),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(524),
	  /* template */
	  __webpack_require__(969),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(526),
	  /* template */
	  __webpack_require__(1031),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(528),
	  /* template */
	  __webpack_require__(1005),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(529),
	  /* template */
	  __webpack_require__(1024),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(530),
	  /* template */
	  __webpack_require__(1006),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(531),
	  /* template */
	  __webpack_require__(1037),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(532),
	  /* template */
	  __webpack_require__(975),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(533),
	  /* template */
	  __webpack_require__(1004),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(534),
	  /* template */
	  __webpack_require__(1038),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(535),
	  /* template */
	  __webpack_require__(1013),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 964 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    attrs: {
	      "model": "owners",
	      "entity": _vm.model,
	      "fields": _vm.ownerFields,
	      "after-submit": _vm.afterSubmit,
	      "cancel": false
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 965 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "controller-list"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('title.controllers')))]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "size": "large"
	    },
	    on: {
	      "click": _vm.emergency
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.emergency')))]), _vm._v(" "), _c('data-table', {
	    attrs: {
	      "model": "controllers",
	      "columns": ['name', 'ip', 'rssi', 'status'],
	      "operations": _vm.operations,
	      "disable-loading-indicator": ""
	    }
	  }), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.$t('title.activate-controller'),
	      "visible": _vm.showActivateDialog
	    }
	  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.$t('question.controllerCertificate')) + "\n    ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.controllerToActivate.readeableHash))])]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "loading": _vm.loading
	    },
	    on: {
	      "click": _vm.activateController
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.accept')))]), _vm._v(" "), _c('el-button', {
	    on: {
	      "click": _vm.cancelActivation
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))])], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.$t('title.remove'),
	      "visible": !!_vm.modelToDelete,
	      "width": "30%",
	      "before-close": function () {
	        _vm.modelToDelete = null
	      }
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('remove.message')))]), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.modelToDelete = null
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm._deleteOperation
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.confirm')))])], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-button-group', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sendEmergency(23)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.openAll')))]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sendEmergency(24)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.normal')))]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sendEmergency(25)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.disableAll')))])], 1)
	},staticRenderFns: []}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.restore-mobile-access')))]), _vm._v(" "), _c('data-form', {
	    attrs: {
	      "entity": _vm.entity,
	      "fields": _vm.fields
	    },
	    on: {
	      "submit": _vm.submit
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 968 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "data-form"
	  }, [_c('el-form', {
	    ref: "form",
	    attrs: {
	      "disabled": _vm.disabled,
	      "model": _vm.formModel,
	      "rules": _vm.cachedRules,
	      "label-position": _vm.labelPosition,
	      "label-width": _vm.labelWidth,
	      "size": _vm.size
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.validate($event)
	      }
	    }
	  }, [_vm._l((_vm.visibleFormFields), function(props) {
	    return _c('el-form-item', {
	      key: props.key,
	      attrs: {
	        "label": props.type !== 'hidden' ? _vm.$t('label.' + (props.label || props.key)) : '',
	        "prop": props.key
	      }
	    }, [(props.type === 'radio') ? _c('el-radio-group', {
	      attrs: {
	        "disabled": props.disabled
	      },
	      on: {
	        "change": _vm.change
	      },
	      model: {
	        value: (_vm.formModel[props.key]),
	        callback: function($$v) {
	          _vm.$set(_vm.formModel, props.key, $$v)
	        },
	        expression: "formModel[props.key]"
	      }
	    }, _vm._l((props.options), function(item) {
	      return _c('el-radio', {
	        key: item.value,
	        attrs: {
	          "border": "",
	          "label": item.value
	        }
	      }, [_vm._v(_vm._s(_vm.$t(item.label)))])
	    }), 1) : (props.type === 'select') ? _c('el-select', {
	      attrs: {
	        "filterable": "",
	        "remote": !(!_vm.remoteMethod(props.key)),
	        "multiple": props.multiple,
	        "remote-method": _vm.remoteMethod(props.key),
	        "placeholder": props.placeholder && _vm.$t('placeholder.' + props.key),
	        "disabled": props.disabled,
	        "clearable": true
	      },
	      on: {
	        "change": function () {
	          var args = [], len = arguments.length;
	          while ( len-- ) args[ len ] = arguments[ len ];
	
	          _vm.change.apply(void 0, args);
	          props.change && props.change.apply(props, args);
	        }
	      },
	      model: {
	        value: (_vm.formModel[props.key]),
	        callback: function($$v) {
	          _vm.$set(_vm.formModel, props.key, $$v)
	        },
	        expression: "formModel[props.key]"
	      }
	    }, _vm._l((props.options), function(item) {
	      return _c('el-option', {
	        key: item.value,
	        attrs: {
	          "label": _vm.$t(item.label),
	          "value": item.value
	        }
	      })
	    }), 1) : (props.type === 'checkbox') ? _c('el-checkbox', {
	      attrs: {
	        "disabled": props.disabled
	      },
	      on: {
	        "change": _vm.change
	      },
	      model: {
	        value: (_vm.formModel[props.key]),
	        callback: function($$v) {
	          _vm.$set(_vm.formModel, props.key, $$v)
	        },
	        expression: "formModel[props.key]"
	      }
	    }) : (props.type === 'switch') ? _c('el-switch', {
	      attrs: {
	        "disabled": props.disabled
	      },
	      on: {
	        "change": _vm.change
	      },
	      model: {
	        value: (_vm.formModel[props.key]),
	        callback: function($$v) {
	          _vm.$set(_vm.formModel, props.key, $$v)
	        },
	        expression: "formModel[props.key]"
	      }
	    }) : (props.type === 'datetime' || props.type === 'date') ? _c('el-date-picker', {
	      attrs: {
	        "disabled": props.disabled,
	        "format": props.format,
	        "type": props.type,
	        "placeholder": props.placeholder && _vm.$t('placeholder.' + props.key),
	        "time-arrow-control": ""
	      },
	      on: {
	        "change": _vm.change
	      },
	      model: {
	        value: (_vm.formModel[props.key]),
	        callback: function($$v) {
	          _vm.$set(_vm.formModel, props.key, $$v)
	        },
	        expression: "formModel[props.key]"
	      }
	    }) : (props.type === 'time') ? _c('el-time-picker', {
	      attrs: {
	        "disabled": props.disabled,
	        "is-range": "",
	        "format": props.format,
	        "picker-options": props.options,
	        "placeholder": props.placeholder && _vm.$t('placeholder.' + props.key)
	      },
	      on: {
	        "change": _vm.change
	      },
	      model: {
	        value: (_vm.formModel[props.key]),
	        callback: function($$v) {
	          _vm.$set(_vm.formModel, props.key, $$v)
	        },
	        expression: "formModel[props.key]"
	      }
	    }) : (props.type === 'number') ? _c('el-input-number', {
	      attrs: {
	        "max": props.max,
	        "min": props.min,
	        "step": props.step,
	        "disabled": props.disabled
	      },
	      on: {
	        "change": function($event) {
	          return _vm.changeNum(props.key)
	        }
	      },
	      model: {
	        value: (_vm.formModel[props.key]),
	        callback: function($$v) {
	          _vm.$set(_vm.formModel, props.key, $$v)
	        },
	        expression: "formModel[props.key]"
	      }
	    }) : (props.type === 'file') ? _c('el-upload', {
	      attrs: {
	        "auto-upload": false,
	        "action": "asd",
	        "file-list": [],
	        "drag": "",
	        "show-file-list": false,
	        "disabled": props.disabled,
	        "on-change": function (file) { return _vm.handleFileChange(props.key, file); },
	        "multiple": props.multiple
	      }
	    }, [_c('img', {
	      staticClass: "avatar",
	      attrs: {
	        "src": _vm.getPreview(props.key)
	      }
	    }), _vm._v(" "), (!_vm.getPreview(props.key)) ? _c('i', {
	      staticClass: "el-icon-upload"
	    }) : _vm._e(), _vm._v(" "), (!_vm.getPreview(props.key)) ? _c('div', {
	      staticClass: "el-upload__text"
	    }, [_vm._v("Drop file here or "), _c('em', [_vm._v("click to upload")])]) : _vm._e()]) : _c('el-input', {
	      attrs: {
	        "type": props.type,
	        "disabled": props.disabled,
	        "placeholder": props.placeholder && _vm.$t('placeholder.' + props.key)
	      },
	      on: {
	        "change": function($event) {
	          props.type === 'number' ? _vm.changeNum(props.key) : _vm.change()
	        }
	      },
	      model: {
	        value: (_vm.formModel[props.key]),
	        callback: function($$v) {
	          _vm.$set(_vm.formModel, props.key, $$v)
	        },
	        expression: "formModel[props.key]"
	      }
	    })], 1)
	  }), _vm._v(" "), _c('div', {
	    style: ({
	      marginLeft: _vm.hideButtons ? _vm.labelWidth : 0
	    })
	  }, [_vm._t("default")], 2), _vm._v(" "), (!_vm.hideButtons) ? _c('el-form-item', [(!_vm.buttons) ? [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "size": "large",
	      "loading": _vm.isLoading
	    },
	    on: {
	      "click": function($event) {
	        return _vm.validate()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.' + _vm.submitLabel)))])] : _vm._l((_vm.buttons), function(b) {
	    return _c('el-button', {
	      attrs: {
	        "type": b.type || 'primary',
	        "size": b.size || 'large',
	        "icon": b.icon && 'el-icon-' + b.icon,
	        "loading": _vm.isLoading
	      },
	      on: {
	        "click": function($event) {
	          return _vm.validate(b)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('button.' + b.label)))])
	  }), _vm._v(" "), (_vm.cancel) ? _c('el-button', {
	    attrs: {
	      "type": "default",
	      "size": "large",
	      "plain": true
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))]) : _vm._e()], 2) : _vm._e()], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 969 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.switch-groups')))]), _vm._v(" "), _c('base-list', {
	    attrs: {
	      "model": "switch-groups",
	      "columns": ['name', 'description'],
	      "sModel": "switch-group"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 970 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    attrs: {
	      "entity": _vm.filters,
	      "fields": _vm.fields,
	      "hideButtons": true
	    },
	    on: {
	      "change": _vm.filtersChanged
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 971 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', {
	    staticStyle: {
	      "display": "inline"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('title.edit-mobile')))]), _vm._v(" "), _c('el-tabs', {
	    model: {
	      value: (_vm.currentTab),
	      callback: function($$v) {
	        _vm.currentTab = $$v
	      },
	      expression: "currentTab"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('tab.details')
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 40
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 12
	    }
	  }, [_c('data-form', {
	    attrs: {
	      "model": "mobiles",
	      "entity": _vm.mobile,
	      "fields": _vm.fields
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('tab.notifications')
	    }
	  }, [_c('notification-settings', {
	    attrs: {
	      "mobile": _vm.mobile
	    }
	  })], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 972 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.owners')))]), _vm._v(" "), _c('base-list', {
	    attrs: {
	      "model": "owners",
	      "columns": ['name', 'contact_name'],
	      "s-model": "owner"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 973 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "mb"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v(_vm._s(_vm.$t('label.ipAddress')) + ":")]), _vm._v(" " + _vm._s(_vm.status.address))]), _vm._v(" "), _c('div', {
	    staticClass: "mb"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v(_vm._s(_vm.$t('label.hostName')) + ":")]), _vm._v(" " + _vm._s(_vm.status.hostName))]), _vm._v(" "), _c('div', {
	    staticClass: "mb"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v(_vm._s(_vm.$t('label.gatewayIp')) + ":")]), _vm._v(" " + _vm._s(_vm.status.gatewayIp))]), _vm._v(" "), _c('div', {
	    staticClass: "mb"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v(_vm._s(_vm.$t('label.isGatewayAlive')) + ":")]), _vm._v(" " + _vm._s(_vm.status.isGatewayAlive))]), _vm._v(" "), _c('div', {
	    staticClass: "mb"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v(_vm._s(_vm.$t('label.publicIp')) + ":")]), _vm._v(" " + _vm._s(_vm.status.publicIp))]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "float": "right"
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "disabled": _vm.loading
	    },
	    on: {
	      "click": _vm.updateStatus
	    }
	  }, [_c('fa-icon', {
	    attrs: {
	      "icon": "refresh",
	      "animated": _vm.loading
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 974 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    attrs: {
	      "entity": _vm.formValue,
	      "fields": _vm.fields,
	      "model": "switches"
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 975 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '.user')))]), _vm._v(" "), _c('el-tabs', {
	    model: {
	      value: (_vm.currentTab),
	      callback: function($$v) {
	        _vm.currentTab = $$v
	      },
	      expression: "currentTab"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('tab.details')
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 40
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12,
	      "md": 12,
	      "sm": 24,
	      "xs": 24
	    }
	  }, [_c('user-form', {
	    attrs: {
	      "user": _vm.user
	    }
	  })], 1)], 1)], 1), _vm._v(" "), (!_vm.user.new) ? _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('tab.serverAccesses')
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 40
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12,
	      "md": 12,
	      "sm": 24,
	      "xs": 24
	    }
	  }, [_c('el-table', {
	    attrs: {
	      "data": _vm.servers,
	      "border": "",
	      "width": "100%"
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "fqdn",
	      "label": _vm.$t('header.fqdn')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('header.userLevel')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(_vm.selectedUserLevels[scope.row.id]) ? _c('data-form', {
	          attrs: {
	            "entity": _vm.selectedUserLevels[scope.row.id],
	            "fields": _vm.serverAccessFields,
	            "hide-buttons": ""
	          },
	          on: {
	            "change": function (userLevelId) { return _vm.userLevelSelected(scope.row.id, userLevelId); }
	          }
	        }) : _vm._e()]
	      }
	    }], null, false, 48480750)
	  })], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "15px"
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "size": "large",
	      "loading": _vm.isLoading
	    },
	    on: {
	      "click": _vm.submitUserLevels
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.submit')))])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 976 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    attrs: {
	      "entity": _vm.reader,
	      "fields": _vm.fields,
	      "model": "readers",
	      "cancel": false
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 977 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    attrs: {
	      "entity": _vm.server,
	      "model": "servers",
	      "fields": _vm.fields,
	      "cancel": false
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 978 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "event-list"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('title.events')))]), _vm._v(" "), _c('div', {
	    staticClass: "filters"
	  }, [_c('el-collapse', {
	    model: {
	      value: (_vm.collapse),
	      callback: function($$v) {
	        _vm.collapse = $$v
	      },
	      expression: "collapse"
	    }
	  }, [_c('el-collapse-item', {
	    attrs: {
	      "title": _vm.$t('title.custom-filters'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 12
	    }
	  }, [_c('event-list-config', {
	    attrs: {
	      "hide-event-type-id": ""
	    },
	    on: {
	      "filtersChanged": _vm.filtersChanged
	    }
	  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('event-table', {
	    attrs: {
	      "filters": _vm.mergedFilters,
	      "showSearch": false,
	      "profile": _vm.profile
	    }
	  })], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 979 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '.mobile-group')))]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 40
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24,
	      "md": 18,
	      "lg": 12
	    }
	  }, [_c('data-form', {
	    attrs: {
	      "model": "mobile-groups",
	      "entity": _vm.mobileGroup,
	      "fields": _vm.fields,
	      "beforeSubmit": _vm.beforeSubmit,
	      "after-submit": _vm.afterSubmit
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('related-mobiles')))]), _vm._v(" "), _c('data-table', {
	    attrs: {
	      "model": "mobiles",
	      "columns": ['contact_name', 'contact_refid'],
	      "isSelected": _vm.isMobileSelected
	    },
	    on: {
	      "selection-change": _vm.mobileSelectChanged
	    }
	  })], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 980 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._v("\n" + _vm._s(_vm.serverLocation) + "\n")])
	},staticRenderFns: []}

/***/ }),
/* 981 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-row', {
	    attrs: {
	      "gutter": 40
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12,
	      "md": 12,
	      "sm": 24,
	      "xs": 24
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "type": "default",
	      "size": "large",
	      "plain": true
	    },
	    on: {
	      "click": function () { return _vm.setSelectedSetting(); }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.new')))]), _vm._v(" "), _c('data-table', {
	    attrs: {
	      "model": _vm.settings,
	      "columns": ['eventTypeNames'],
	      "operations": _vm.operations,
	      "order": {
	        sortBy: 'id'
	      }
	    },
	    on: {
	      "row-click": function (row) { return _vm.setSelectedSetting(row); }
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12,
	      "md": 12,
	      "sm": 24,
	      "xs": 24
	    }
	  }, [(_vm.selectedSettings) ? _c('data-form', {
	    attrs: {
	      "model": "mobile-notification-settings",
	      "entity": _vm.selectedSettings,
	      "fields": _vm.fields,
	      "beforeSubmit": _vm.beforeSubmit,
	      "afterSubmit": _vm.afterSubmit
	    },
	    on: {
	      "change": _vm.onFormChange
	    }
	  }) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 982 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    attrs: {
	      "entity": _vm.mappedInput,
	      "fields": _vm.fields,
	      "model": "inputs",
	      "cancel": false
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    attrs: {
	      "entity": _vm.formValue,
	      "fields": _vm.fields,
	      "model": "switches",
	      "buttons": _vm.buttons,
	      "cancel": false
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 984 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._v("\n  " + _vm._s(_vm.actualServerTime) + "\n")])
	},staticRenderFns: []}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.accesses-for')) + " | Controller: " + _vm._s(_vm.swithc.controllerName) + " | Switch: " + _vm._s(_vm.swithc.name))]), _vm._v(" "), _c('single-access', {
	    attrs: {
	      "access-holders": _vm.accessHolders,
	      "unprocessed-accesses": _vm.unprocessedAccesses,
	      "columns": ['contact_name', 'contact_refid'],
	      "switch-id": _vm.switchId
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.accesses-for')) + " | Mobile: " + _vm._s(_vm.mobile.contact_name))]), _vm._v(" "), _c('single-access', {
	    attrs: {
	      "access-holders": _vm.accessHolders,
	      "unprocessed-accesses": _vm.unprocessedAccesses,
	      "columns": ['controllerName', 'name'],
	      "mobile-id": _vm.mobileId
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 987 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    attrs: {
	      "model": "users",
	      "entity": _vm.currentUser,
	      "fields": _vm.fields,
	      "after-submit": _vm.afterSubmit,
	      "cancel": false
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 988 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '.owner')))]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 40
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('data-form', {
	    attrs: {
	      "model": "owners",
	      "entity": _vm.owner,
	      "fields": _vm.fields,
	      "before-submit": _vm.beforeSubmit,
	      "after-submit": _vm.afterSubmit
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('related-organizations')))]), _vm._v(" "), _c('data-table', {
	    attrs: {
	      "model": "organizations",
	      "columns": ['name', 'id'],
	      "isSelected": _vm.isOrganizationSelected
	    },
	    on: {
	      "selection-change": _vm.organizationSelectChanged
	    }
	  })], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 989 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "welcome"
	  }, [_vm._l((_vm.steps), function(step, i) {
	    return (_vm.active === i) ? _c(step, {
	      tag: "component",
	      on: {
	        "next": _vm.next
	      }
	    }) : _vm._e()
	  }), _vm._v(" "), _c('el-steps', {
	    attrs: {
	      "space": 50,
	      "active": _vm.active,
	      "direction": "vertical",
	      "finish-status": "success"
	    }
	  }, _vm._l((_vm.steps), function(step) {
	    return _c('el-step', {
	      attrs: {
	        "title": _vm.$t('step.' + step)
	      }
	    })
	  }), 1)], 2)
	},staticRenderFns: []}

/***/ }),
/* 990 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "licence-uploader"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('title.add-licence')))]), _vm._v(" "), _c('data-form', {
	    attrs: {
	      "entity": _vm.server,
	      "fields": _vm.fields,
	      "cancel": false
	    },
	    on: {
	      "submit": _vm.submit
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 991 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "navigation-bar"
	  }, [_c('el-menu', {
	    attrs: {
	      "theme": "dark",
	      "default-active": _vm.defaultRoute.name,
	      "mode": "horizontal",
	      "router": true
	    }
	  }, [_c('li', {
	    staticClass: "brand"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('ulockme')))])], 1), _vm._v(" "), _vm._l((_vm.routes), function(route) {
	    return [(route.routes) ? _c('el-submenu', {
	      attrs: {
	        "index": route.name
	      }
	    }, [_c('template', {
	      slot: "title"
	    }, [_vm._v(_vm._s(_vm.$t('nav.' + route.name)))]), _vm._v(" "), _vm._l((route.routes), function(route) {
	      return _c('el-menu-item', {
	        attrs: {
	          "route": route,
	          "index": route.name
	        }
	      }, [_vm._v(_vm._s(_vm.$t('nav.' + route.name)))])
	    })], 2) : _c('el-menu-item', {
	      attrs: {
	        "route": route,
	        "index": route.name
	      }
	    }, [_vm._v(_vm._s(_vm.$t('nav.' + route.name)))])]
	  }), _vm._v(" "), _c('el-menu-item', {
	    staticClass: "right",
	    attrs: {
	      "index": "logout"
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.logout($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('nav.logout')))]), _vm._v(" "), _c('el-submenu', {
	    staticClass: "right",
	    attrs: {
	      "index": "lang"
	    }
	  }, [_c('template', {
	    slot: "title"
	  }, [_vm._v(_vm._s(_vm.$t('nav.' + 'changeLanguage')))]), _vm._v(" "), _c('el-menu-item', {
	    attrs: {
	      "route": _vm.currentRoute,
	      "index": _vm.currentRoute.name
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.changeLang('hu')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('lang.hungarian')))]), _vm._v(" "), _c('el-menu-item', {
	    attrs: {
	      "route": _vm.currentRoute,
	      "index": _vm.currentRoute.name
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.changeLang('en')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('lang.english')))])], 2)], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 992 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.access-schemes')))]), _vm._v(" "), _c('base-list', {
	    attrs: {
	      "model": "access-schemes",
	      "columns": ['name'],
	      "s-model": "access-scheme"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 993 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-row', {
	    attrs: {
	      "gutter": 30
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12,
	      "xs": 24
	    }
	  }, [_c('el-tabs', {
	    on: {
	      "tab-click": function($event) {
	        _vm.selectedAccess = null
	      }
	    },
	    model: {
	      value: (_vm.regStatusFilter),
	      callback: function($$v) {
	        _vm.regStatusFilter = $$v
	      },
	      expression: "regStatusFilter"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "name": "none",
	      "label": _vm.$t('regStatus.none')
	    }
	  }), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "name": "pending",
	      "label": _vm.$t('regStatus.pending')
	    }
	  }), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "name": "active",
	      "label": _vm.$t('regStatus.active')
	    }
	  }), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "name": "disabled",
	      "label": _vm.$t('regStatus.disabled')
	    }
	  }), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "name": "inprogress",
	      "label": _vm.$t('regStatus.inprogress')
	    }
	  })], 1), _vm._v(" "), _c('data-table', {
	    attrs: {
	      "model": _vm.visibleAccessHolders,
	      "columns": _vm.extendedColumns,
	      "operations": _vm.operations,
	      "single-select": ""
	    },
	    on: {
	      "row-click": _vm.accessHolderSelected
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12,
	      "xs": 24
	    }
	  }, [(!!_vm.selectedAccess) ? _c('access-form', {
	    attrs: {
	      "access": _vm.selectedAccess,
	      "disabled": _vm.regStatusFilter === 'inprogress'
	    },
	    on: {
	      "submit": _vm.onSubmit
	    }
	  }) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 994 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.mobile-groups')))]), _vm._v(" "), _c('base-list', {
	    attrs: {
	      "model": "mobile-groups",
	      "columns": ['name', 'description'],
	      "sModel": "mobile-group"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 995 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', {
	    staticStyle: {
	      "display": "inline"
	    }
	  }, [_vm._v(_vm._s(_vm.server.fqdn) + " ")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "display": "inline"
	    }
	  }, [_vm._v(_vm._s(_vm.server.description))]), _vm._v(" "), _c('el-tabs', {
	    model: {
	      value: (_vm.currentTab),
	      callback: function($$v) {
	        _vm.currentTab = $$v
	      },
	      expression: "currentTab"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('tab.dashboard')
	    }
	  }, [_c('dashboard')], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('tab.settings')
	    }
	  }, [_c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 12,
	      "xs": 24,
	      "sm": 12
	    }
	  }, [_c('server-settings', {
	    attrs: {
	      "server": _vm.server
	    }
	  }), _vm._v(" "), _c('licence-uploader', {
	    attrs: {
	      "server": _vm.server
	    }
	  })], 1)], 1)], 1), _vm._v(" "), (_vm.childServers.length) ? _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('tab.child-servers')
	    }
	  }, [_c('server-list', {
	    attrs: {
	      "servers": _vm.childServers
	    }
	  })], 1) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 996 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('notification'), _vm._v(" "), (_vm.loggedIn) ? _c('navigation-bar') : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "content"
	    }
	  }, [_c('router-view')], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 997 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.external-services')))]), _vm._v(" "), _c('base-list', {
	    attrs: {
	      "model": "external-services",
	      "columns": ['id', 'type', 'url'],
	      "sModel": "external-service"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 998 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    attrs: {
	      "entity": _vm.message,
	      "fields": _vm.fields,
	      "buttons": _vm.buttons,
	      "cancelAction": _vm.stopTimer
	    },
	    on: {
	      "submit": _vm.submit
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 999 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "data-table"
	  }, [_c('div', {
	    attrs: {
	      "id": "search"
	    }
	  }, [(_vm.showSearch) ? _c('el-input', {
	    attrs: {
	      "placeholder": _vm.$t('placeholder.search'),
	      "icon": "el-icon-search"
	    },
	    model: {
	      value: (_vm.searchText),
	      callback: function($$v) {
	        _vm.searchText = $$v
	      },
	      expression: "searchText"
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('el-popover', {
	    staticClass: "column-selector top",
	    attrs: {
	      "placement": "left"
	    },
	    model: {
	      value: (_vm.isColumSelectorVisible),
	      callback: function($$v) {
	        _vm.isColumSelectorVisible = $$v
	      },
	      expression: "isColumSelectorVisible"
	    }
	  }, [_c('el-checkbox-group', {
	    model: {
	      value: (_vm.selectedColumns),
	      callback: function($$v) {
	        _vm.selectedColumns = $$v
	      },
	      expression: "selectedColumns"
	    }
	  }, _vm._l((_vm.normalizedColumns), function(col) {
	    return _c('el-checkbox', {
	      staticClass: "column-selector-checkbox",
	      attrs: {
	        "label": col,
	        "value": col
	      }
	    }, [_vm._v(_vm._s(_vm.$t('header.' + col)))])
	  }), 1), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "slot": "reference",
	      "type": "primary",
	      "circle": "",
	      "icon": "el-icon-more"
	    },
	    on: {
	      "click": function($event) {
	        _vm.isColumSelectorVisible = true
	      }
	    },
	    slot: "reference"
	  })], 1), _vm._v(" "), (_vm.pagination.includes('top')) ? _c('el-pagination', {
	    staticClass: "pagination top",
	    attrs: {
	      "layout": "sizes, prev, pager, next",
	      "total": _vm.total,
	      "page-size": _vm.localSize,
	      "current-page": _vm.currentPage
	    },
	    on: {
	      "size-change": _vm.handleSizeChange,
	      "current-change": _vm.handleCurrentChange
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading.body",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "body": true
	      }
	    }],
	    ref: "table",
	    attrs: {
	      "data": _vm.translatedData,
	      "row-key": _vm.rowKey,
	      "border": "",
	      "stripe": "",
	      "highlight-current-row": _vm.singleSelect,
	      "empty-text": _vm.$t('empty-table')
	    },
	    on: {
	      "selection-change": _vm.handleSelectionChange,
	      "sort-change": _vm.handleSortChange,
	      "row-click": _vm.rowClick
	    }
	  }, [(_vm.isSelected) ? _c('el-table-column', {
	    attrs: {
	      "type": "selection",
	      "width": "49",
	      "reserve-selection": true
	    }
	  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.orderedSelectedColumns), function(col) {
	    return _c('el-table-column', {
	      attrs: {
	        "prop": col,
	        "label": _vm.$t('header.' + col),
	        "sortable": "",
	        "sort-method": _vm.sortMethod
	      }
	    })
	  }), _vm._v(" "), _vm._l((_vm.plusCells), function(cell) {
	    return _c('el-table-column', {
	      scopedSlots: _vm._u([{
	        key: "default",
	        fn: function(scope) {
	          return [_c(cell, {
	            tag: "component",
	            attrs: {
	              "row": scope.row
	            }
	          })]
	        }
	      }], null, true)
	    })
	  }), _vm._v(" "), (_vm.showOperationsColumn()) ? _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('header.operations')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-button-group', _vm._l((_vm.operations), function(op) {
	          return (_vm.isOperationVisible(op, scope.row)) ? _c('el-button', {
	            key: op.label,
	            attrs: {
	              "size": "mini",
	              "disabled": op.disabled && op.disabled(scope.row),
	              "type": op.type,
	              "icon": op.icon && 'el-icon-' + op.icon
	            },
	            on: {
	              "click": function($event) {
	                return op.method(scope.row)
	              }
	            }
	          }, [_vm._v(_vm._s(op.label ? _vm.$t('operation.' + op.label) : ''))]) : _vm._e()
	        }), 1)]
	      }
	    }], null, false, 2684773214)
	  }) : _vm._e()], 2), _vm._v(" "), (_vm.pagination.includes('bottom')) ? _c('el-pagination', {
	    staticClass: "pagination bottom",
	    attrs: {
	      "layout": "sizes, prev, pager, next",
	      "total": _vm.total,
	      "page-size": _vm.localSize,
	      "current-page": _vm.currentPage
	    },
	    on: {
	      "size-change": _vm.handleSizeChange,
	      "current-change": _vm.handleCurrentChange
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    attrs: {
	      "entity": _vm.filters,
	      "fields": _vm.fields,
	      "hideButtons": true
	    },
	    on: {
	      "change": _vm.filtersChanged
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    attrs: {
	      "entity": _vm.formModel,
	      "fields": _vm.fields,
	      "cancel": false
	    },
	    on: {
	      "change": _vm.onChange,
	      "submit": _vm.onSubmit
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-row', {
	    attrs: {
	      "gutter": 30
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('data-form', {
	    attrs: {
	      "entity": _vm.formData,
	      "fields": {
	        'version': {
	          disabled: true
	        },
	        'commitHash': {
	          disabled: true
	        },
	        'espVersion': {
	          disabled: true
	        },
	        'ifVersion': {
	          disabled: true
	        },
	        'ip': {
	          disabled: true
	        },
	        'rssi': {
	          disabled: true
	        },
	        'lastHeartbeat': {
	          disabled: true,
	          type: 'datetime'
	        },
	        'lastWifiReconnect': {
	          disabled: true,
	          type: 'datetime'
	        },
	        'lastMqttReconnect': {
	          disabled: true,
	          type: 'datetime'
	        }
	      },
	      "buttons": [],
	      "cancel": false
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('event-table', {
	    attrs: {
	      "filters": _vm.eventFilters,
	      "columns": ['occured', '[T]name'],
	      "showSearch": false
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "access-form"
	  }, [_vm._t("default"), _vm._v(" "), _c('data-form', {
	    attrs: {
	      "entity": _vm.formModel,
	      "fields": _vm.fields,
	      "hide-buttons": "",
	      "disabled": _vm.disabled
	    },
	    on: {
	      "change": _vm.onChange
	    }
	  }, [(!_vm.buttons) ? [(!_vm.unlocked) ? _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "disabled": !!_vm.access.pending_access_id || !!_vm.access.hasOwnProperty('attempts')
	    },
	    on: {
	      "click": function($event) {
	        _vm.unlocked = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.edit')))]) : [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.saveAccess
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save-scheduled')))]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "warning"
	    },
	    on: {
	      "click": _vm.sendAccess
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.send')))]), _vm._v(" "), _c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.unlocked = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))])], _vm._v(" "), (_vm.access.pending_access_id) ? _c('span', [_vm._v(_vm._s(_vm.$t('label.has-pending-access')))]) : _vm._e()] : _vm._l((_vm.buttons), function(b) {
	    return _c('el-button', {
	      on: {
	        "click": function () { return b.action(_vm.formModel); }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('button.' + b.title)))])
	  })], 2)], 2)
	},staticRenderFns: []}

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    attrs: {
	      "model": "users",
	      "entity": _vm.user,
	      "fields": _vm.fields,
	      "after-submit": _vm.afterSubmit,
	      "ignoreEntityChanges": ""
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.switches')))]), _vm._v(" "), _c('data-table', {
	    attrs: {
	      "model": _vm.switches,
	      "columns": ['controllerName', 'switchGroupNames', 'name'],
	      "operations": _vm.operations,
	      "custom-sort": _vm.sort
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '.user-level')))]), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('data-form', {
	    attrs: {
	      "model": "user-levels",
	      "entity": _vm.userLevel,
	      "fields": _vm.fields,
	      "before-submit": _vm.beforeSubmit,
	      "after-submit": _vm.afterSubmit
	    }
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('related-app-functions')))]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-bottom": "50px"
	    }
	  }, [_c('data-table', {
	    ref: "functionTable",
	    attrs: {
	      "model": "app-functions",
	      "columns": ['[T]name'],
	      "isSelected": _vm.isAppFunctionSelected,
	      "size": 30
	    },
	    on: {
	      "selection-change": _vm.appFunctionSelectChanged
	    }
	  })], 1)])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    attrs: {
	      "entity": _vm.controller,
	      "fields": _vm.fields,
	      "model": "controllers",
	      "buttons": _vm.buttons,
	      "cancel": false,
	      "ignoreEntityChanges": ""
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "live-edit",
	    on: {
	      "click": _vm.textClicked,
	      "keypress": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.finalize($event)
	      },
	      "focusout": _vm.finalize
	    }
	  }, [(_vm.isEditing) ? _c('el-input', {
	    directives: [{
	      name: "focus",
	      rawName: "v-focus"
	    }],
	    attrs: {
	      "autofocus": true,
	      "placeholder": _vm.placeholder
	    },
	    on: {
	      "blur": _vm.finalize
	    },
	    model: {
	      value: (_vm.modelvalue),
	      callback: function($$v) {
	        _vm.modelvalue = $$v
	      },
	      expression: "modelvalue"
	    }
	  }) : _c('span', [_vm._v(_vm._s(_vm.modelvalue || _vm.placeholder))])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    attrs: {
	      "model": "locations",
	      "entity": _vm.model,
	      "fields": _vm.locationFields,
	      "after-submit": _vm.afterSubmit,
	      "cancel": false
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    attrs: {
	      "entity": _vm.formModel,
	      "fields": _vm.fields,
	      "cancel": false
	    },
	    on: {
	      "change": _vm.onChange,
	      "submit": _vm.onSubmit
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-row', {
	    attrs: {
	      "justify": "center",
	      "type": "flex"
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 12
	    }
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('login.welcome')))]), _vm._v(" "), _c('data-form', {
	    attrs: {
	      "entity": _vm.model,
	      "fields": _vm.fields,
	      "cancel": false,
	      "loading": _vm.$store.state.progress > 0,
	      "submit-label": "login"
	    },
	    on: {
	      "submit": _vm.submit
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '.switch-group')))]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 40
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24,
	      "md": 18,
	      "lg": 12
	    }
	  }, [_c('data-form', {
	    attrs: {
	      "model": "switch-groups",
	      "entity": _vm.switchGroup,
	      "fields": _vm.fields,
	      "beforeSubmit": _vm.beforeSubmit,
	      "after-submit": _vm.afterSubmit
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('related-switches')))]), _vm._v(" "), _c('data-table', {
	    attrs: {
	      "model": "switches",
	      "columns": ['controllerName', 'name'],
	      "isSelected": _vm.isSwitchSelected
	    },
	    on: {
	      "selection-change": _vm.switchSelectChanged
	    }
	  })], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    attrs: {
	      "entity": _vm.formModel,
	      "fields": _vm.fields
	    },
	    on: {
	      "change": _vm.onChange,
	      "submit": _vm.onSubmit
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "parent-server-setup"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('title.set-parent-server')))]), _vm._v(" "), _c('data-form', {
	    attrs: {
	      "entity": _vm.server,
	      "fields": _vm.fields,
	      "cancel": false
	    },
	    on: {
	      "submit": _vm.submit
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.mobiles')))]), _vm._v(" "), _c('data-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading.body",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "body": true
	      }
	    }],
	    attrs: {
	      "model": _vm.mappedMobiles,
	      "columns": ['contact_name', 'personName', 'mobileGroupNames', 'controllerNames'],
	      "operations": _vm.operations
	    }
	  }), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.$t('title.remove'),
	      "visible": !!_vm.modelToDelete,
	      "width": "30%",
	      "before-close": function () {
	        _vm.modelToDelete = null
	      }
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('remove.message')))]), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.modelToDelete = null
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.deleteModel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.confirm')))])], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    attrs: {
	      "model": "persons",
	      "entity": _vm.person,
	      "fields": _vm.fields,
	      "ignoreEntityChanges": "",
	      "after-submit": _vm.afterSubmit
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.organizations')))]), _vm._v(" "), _c('base-list', {
	    attrs: {
	      "model": "organizations",
	      "columns": ['name', 'owner'],
	      "sModel": "organization"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading.body",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "body": true
	      }
	    }],
	    attrs: {
	      "model": _vm.mappedEvents,
	      "columns": _vm.computedColumns,
	      "show-search": _vm.showSearch,
	      "order": {
	        ascending: false,
	        sortBy: 'occured'
	      }
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '-access-scheme')))]), _vm._v(" "), _c('el-tabs', {
	    model: {
	      value: (_vm.currentTab),
	      callback: function($$v) {
	        _vm.currentTab = $$v
	      },
	      expression: "currentTab"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('tab.details')
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 40
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12,
	      "md": 12,
	      "sm": 24,
	      "xs": 24
	    }
	  }, [_c('access-form', {
	    attrs: {
	      "access": _vm.accessScheme,
	      "additional-fields": {
	        'name': {
	          type: 'text'
	        }
	      },
	      "buttons": [{
	        title: 'submit',
	        action: _vm.submit
	      }, {
	        title: 'cancel',
	        action: _vm.cancel
	      }]
	    }
	  })], 1)], 1)], 1), _vm._v(" "), (!_vm.accessScheme.new) ? _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('tab.groups')
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 40
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('related-groups')))]), _vm._v(" "), _c('div', [_c('el-select', {
	    attrs: {
	      "filterable": "",
	      "remote": "",
	      "remote-method": _vm.filterSwitchGroups,
	      "placeholder": _vm.$t('placeholder.switch_group')
	    },
	    on: {
	      "change": _vm.switchGroupSelected
	    },
	    model: {
	      value: (_vm.selectedSwitchGroupId),
	      callback: function($$v) {
	        _vm.selectedSwitchGroupId = $$v
	      },
	      expression: "selectedSwitchGroupId"
	    }
	  }, _vm._l((_vm.filterSwitchGroups()), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": _vm.$t(item.label),
	        "value": item.value
	      }
	    })
	  }), 1), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "filterable": "",
	      "remote": "",
	      "remote-method": _vm.filterMobileGroups,
	      "placeholder": _vm.$t('placeholder.mobile_group')
	    },
	    on: {
	      "change": _vm.mobileGroupSelected
	    },
	    model: {
	      value: (_vm.selectedMobileGroupId),
	      callback: function($$v) {
	        _vm.selectedMobileGroupId = $$v
	      },
	      expression: "selectedMobileGroupId"
	    }
	  }, _vm._l((_vm.filterMobileGroups()), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": _vm.$t(item.label),
	        "value": item.value
	      }
	    })
	  }), 1), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "size": "large",
	      "loading": _vm.isLoading
	    },
	    on: {
	      "click": _vm.submitGroups
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.add-new')))])], 1), _vm._v(" "), _c('data-table', {
	    attrs: {
	      "model": _vm.groups,
	      "columns": ['switchGroupName', 'mobileGroupName'],
	      "showSearch": false,
	      "operations": [{
	        label: 'delete',
	        permission: 'DELETE_MOBILE_ACCESS_GROUP',
	        type: 'danger',
	        icon: 'delete',
	        method: _vm.deleteMobileAccessGroup
	      }]
	    }
	  })], 1)], 1)], 1) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '-external-service')))]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 40
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('data-form', {
	    attrs: {
	      "model": "external-services",
	      "entity": _vm.externalService,
	      "fields": _vm.fields,
	      "beforeSubmit": _vm.mapBeforeSubmit,
	      "after-submit": _vm.afterSubmit
	    },
	    on: {
	      "change": _vm.onChange
	    }
	  })], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('vue-progress-bar')
	},staticRenderFns: []}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '.organization')))]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 40
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('data-form', {
	    attrs: {
	      "model": "organizations",
	      "entity": _vm.organization,
	      "fields": _vm.fields,
	      "before-submit": _vm.beforeSubmit,
	      "after-submit": _vm.afterSubmit
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('related-users')))]), _vm._v(" "), _c('data-table', {
	    attrs: {
	      "model": "users",
	      "columns": ['email'],
	      "isSelected": _vm.isUserSelected
	    },
	    on: {
	      "selection-change": _vm.userSelectChanged
	    }
	  })], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', _vm._l((_vm.switchGroups), function(group, index) {
	    return _c('div', {
	      key: group.id,
	      class: {
	        'mb': index < (_vm.switchGroups.length - 1)
	      }
	    }, [_c('h4', [_vm._v(_vm._s(group.name))]), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('label.emergencyControll')) + ":")]), _vm._v(" "), _c('el-button-group', [_c('el-button', {
	      attrs: {
	        "type": "primary"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleGroup(group, 23)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('button.openAll')))]), _vm._v(" "), _c('el-button', {
	      attrs: {
	        "type": "primary"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleGroup(group, 24)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('button.normal')))]), _vm._v(" "), _c('el-button', {
	      attrs: {
	        "type": "primary"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleGroup(group, 25)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('button.disableAll')))])], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._l((group.switches), function(switchx, index) {
	      return _c('div', {
	        key: switchx.id,
	        staticClass: "switch-box",
	        class: {
	          'mb': index < (group.switches.length - 1)
	        }
	      }, [_c('div', {
	        staticClass: "switch"
	      }, [_vm._v(_vm._s(switchx.name))]), _vm._v(" "), _c('el-button', {
	        on: {
	          "click": function($event) {
	            return _vm.toggleSwitch(switchx, 3)
	          }
	        }
	      }, [_vm._v(_vm._s(_vm.$t('button.open')))])], 1)
	    })], 2)
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.system-parameters')))]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 40
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12,
	      "md": 12,
	      "sm": 24,
	      "xs": 24
	    }
	  }, [_c('data-table', {
	    attrs: {
	      "model": "system-parameters",
	      "columns": ['id', 'value']
	    },
	    on: {
	      "row-click": _vm.rowClick
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12,
	      "md": 12,
	      "sm": 24,
	      "xs": 24
	    }
	  }, [(_vm.selected) ? _c('data-form', {
	    attrs: {
	      "entity": _vm.selected,
	      "model": "system-parameters",
	      "fields": _vm.fields,
	      "cancel": false
	    }
	  }) : _vm._e()], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    attrs: {
	      "entity": _vm.controller,
	      "fields": _vm.fields,
	      "cancel": false,
	      "ignoreEntityChanges": ""
	    },
	    on: {
	      "submit": _vm.submit
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.persons')))]), _vm._v(" "), _c('base-list', {
	    attrs: {
	      "model": "persons",
	      "columns": ['name', 'address', 'workplace'],
	      "s-model": "person"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "server-list"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('title.servers')))]), _vm._v(" "), _c('data-table', {
	    attrs: {
	      "model": _vm.servers,
	      "columns": ['fqdn', 'description'],
	      "operations": _vm.operations
	    }
	  }), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.$t('title.activate-server')
	    },
	    model: {
	      value: (_vm.showActivateDialog),
	      callback: function($$v) {
	        _vm.showActivateDialog = $$v
	      },
	      expression: "showActivateDialog"
	    }
	  }, [_c('data-form', {
	    attrs: {
	      "entity": _vm.serverToActivate,
	      "fields": _vm.activateFields,
	      "cancelAction": _vm.cancelActivation
	    },
	    on: {
	      "submit": _vm.activateServer
	    }
	  })], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.$t('title.inactivate-server')
	    },
	    model: {
	      value: (_vm.showInactivateDialog),
	      callback: function($$v) {
	        _vm.showInactivateDialog = $$v
	      },
	      expression: "showInactivateDialog"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('message.incativate-server')))]), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "danger"
	    },
	    on: {
	      "click": _vm.inactivateServer
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.inactivate')))]), _vm._v(" "), _c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.showInactivateDialog = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))])], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('i', {
	    class: _vm.klass,
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '.location')))]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 40
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 12
	    }
	  }, [_c('data-form', {
	    attrs: {
	      "model": "locations",
	      "entity": _vm.location,
	      "fields": _vm.fields,
	      "before-submit": _vm.beforeSubmit,
	      "after-submit": _vm.afterSubmit
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 12
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('related-servers')))]), _vm._v(" "), _c('data-table', {
	    attrs: {
	      "model": "servers",
	      "columns": ['fqdn'],
	      "isSelected": _vm.isServerSelected
	    },
	    on: {
	      "selection-change": _vm.serverSelectChanged
	    }
	  })], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '.person')))]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 40
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12,
	      "md": 12,
	      "sm": 24,
	      "xs": 24
	    }
	  }, [_c('person-form', {
	    attrs: {
	      "person": _vm.person
	    }
	  })], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('title.edit-switch')))])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('switch-form', {
	    attrs: {
	      "switchx": _vm.switchx
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('server-switch-form', {
	    attrs: {
	      "switchx": _vm.switchx
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    attrs: {
	      "entity": _vm.formModel,
	      "fields": _vm.fields,
	      "cancel": false
	    },
	    on: {
	      "change": _vm.onChange,
	      "submit": _vm.onSubmit
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', {
	    staticStyle: {
	      "display": "inline"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('title.controller-details')) + ": " + _vm._s(_vm.controller.name) + " ")]), _vm._v(" "), _c('el-tabs', [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('tab.controller-details')
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 30
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('controller-form', {
	    attrs: {
	      "controller": _vm.controller
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('tab.controller-diagnosis')
	    }
	  }, [_c('controller-diagnosis', {
	    attrs: {
	      "controller": _vm.controller
	    }
	  })], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('tab.switches')
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 30
	    }
	  }, _vm._l((_vm.switches), function(switchx, i) {
	    return _c('el-col', {
	      attrs: {
	        "span": 12
	      }
	    }, [_c('h2', [_vm._v(_vm._s(i + 1) + ". " + _vm._s(_vm.$t('switch')))]), _vm._v(" "), _c('switch-form', {
	      attrs: {
	        "switchx": switchx
	      }
	    }), _vm._v(" "), _c('server-switch-form', {
	      attrs: {
	        "switchx": switchx
	      }
	    })], 1)
	  }), 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('tab.controller-wifi-settings')
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 30
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('controller-wifi-setting', {
	    attrs: {
	      "controller": _vm.controller
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('tab.readers')
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 30
	    }
	  }, _vm._l((_vm.relatedReaders), function(reader) {
	    return _c('el-col', {
	      attrs: {
	        "span": 12
	      }
	    }, [_c('reader-form', {
	      attrs: {
	        "reader": reader
	      }
	    })], 1)
	  }), 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('tab.inputs')
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 30
	    }
	  }, _vm._l((_vm.relatedInputs), function(input) {
	    return _c('el-col', {
	      key: input.id,
	      attrs: {
	        "span": 12
	      }
	    }, [_c('input-form', {
	      attrs: {
	        "input": input
	      }
	    })], 1)
	  }), 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('tab.in-progress-accesses')
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 30
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('data-table', {
	    attrs: {
	      "model": _vm.unprocessedAccesses,
	      "columns": ['contact_name', 'switch.name', 'attempts', '[T]key_type']
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('tab.tx-power')
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 30
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('controller-tx-power', {
	    attrs: {
	      "controller": _vm.controller
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('tab.command')
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 30
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('command-builder', {
	    attrs: {
	      "controller": _vm.controller
	    }
	  })], 1)], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('data-form', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    attrs: {
	      "entity": _vm.formModel,
	      "fields": _vm.fields,
	      "cancel": false
	    },
	    on: {
	      "change": _vm.onChange,
	      "submit": _vm.onSubmit
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "base-list"
	  }, [(!_vm.hideAddNew && _vm.hasPermission(_vm.createPermission)) ? _c('el-button', {
	    staticClass: "add-button",
	    attrs: {
	      "type": "primary",
	      "icon": "el-icon-plus"
	    },
	    on: {
	      "click": _vm.addNew
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.new')))]) : _vm._e(), _vm._v(" "), _c('data-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading.body",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "body": true
	      }
	    }],
	    attrs: {
	      "model": _vm.model,
	      "columns": _vm.columns,
	      "size": 10,
	      "operations": _vm.operations
	    }
	  }), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.$t('title.remove'),
	      "visible": !!_vm.modelToDelete,
	      "width": "30%",
	      "before-close": function () {
	        _vm.modelToDelete = null
	      }
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('remove.message')))]), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.modelToDelete = null
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.deleteModel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.confirm')))])], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": _vm.$t('placeholder.selectComponent')
	    },
	    model: {
	      value: (_vm.selectedComponent),
	      callback: function($$v) {
	        _vm.selectedComponent = $$v
	      },
	      expression: "selectedComponent"
	    }
	  }, _vm._l((_vm.options), function(item) {
	    return _c('el-option', {
	      key: item.label,
	      attrs: {
	        "label": _vm.$t(item.label),
	        "value": item.value
	      }
	    })
	  }), 1), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "disabled": !_vm.selectedComponent
	    },
	    on: {
	      "click": _vm.addDashoardItem
	    }
	  }, [_vm._v("Add new")]), _vm._v(" "), _c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.frozen = !_vm.frozen
	      }
	    }
	  }, [_vm._v("Lock")]), _vm._v(" "), _c('grid-layout', {
	    attrs: {
	      "layout": _vm.layout,
	      "col-num": 4,
	      "row-height": 1,
	      "is-draggable": !_vm.frozen,
	      "is-resizable": !_vm.frozen,
	      "vertical-compact": false,
	      "margin": [10, 10],
	      "use-css-transforms": true
	    }
	  }, _vm._l((_vm.layout), function(item) {
	    return _c('grid-item', {
	      attrs: {
	        "x": item.x,
	        "y": item.y,
	        "w": item.w,
	        "h": item.h,
	        "i": item.i
	      }
	    }, [(item.component) ? _c('div', {
	      staticClass: "card card--small"
	    }, [(item.component.title || item.component.configName) ? _c('div', {
	      staticClass: "header"
	    }, [_c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (!_vm.frozen),
	        expression: "!frozen"
	      }],
	      staticClass: "config-icon",
	      on: {
	        "click": function($event) {
	          return _vm.removeComponent(item.i)
	        }
	      }
	    }, [_c('fa-icon', {
	      attrs: {
	        "icon": "trash-o"
	      }
	    })], 1), _vm._v(" "), (item.component.configName) ? _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (!_vm.frozen),
	        expression: "!frozen"
	      }],
	      staticClass: "config-icon",
	      on: {
	        "click": function($event) {
	          item.component.isConfiguring = !item.component.isConfiguring
	        }
	      }
	    }, [_c('fa-icon', {
	      attrs: {
	        "icon": item.component.isConfiguring ? 'floppy-o' : 'cog'
	      }
	    })], 1) : _vm._e(), _vm._v(" "), _c('h4', {
	      staticClass: "title"
	    }, [_c('live-edit', {
	      attrs: {
	        "editable": !_vm.frozen
	      },
	      model: {
	        value: (item.component.title),
	        callback: function($$v) {
	          _vm.$set(item.component, "title", $$v)
	        },
	        expression: "item.component.title"
	      }
	    })], 1)]) : _vm._e(), _vm._v(" "), (item.component.isConfiguring) ? _c('div', {
	      staticClass: "config-box"
	    }, [_c(item.component.configName, _vm._b({
	      tag: "component",
	      on: {
	        "propertiesChanged": function($event) {
	          return _vm.updateComponent(item.component, $event)
	        }
	      }
	    }, 'component', item.component.properties, false))], 1) : _c('div', {
	      staticClass: "body",
	      class: {
	        'padded-body': item.component.needsPadding
	      }
	    }, [_c(item.component.name, _vm._b({
	      ref: "item.component.ref",
	      refInFor: true,
	      tag: "component"
	    }, 'component', item.component.properties, false))], 1)]) : _vm._e()])
	  }), 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.user-levels')))]), _vm._v(" "), _c('base-list', {
	    attrs: {
	      "model": "user-levels",
	      "columns": ['name'],
	      "s-model": "user-level"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.users')))]), _vm._v(" "), _c('base-list', {
	    attrs: {
	      "model": "users",
	      "columns": ['first_name', 'email'],
	      "s-model": "user"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "chart-container",
	    staticStyle: {
	      "position": "relative",
	      "width": "100%"
	    }
	  }, [(_vm.chartData) ? _c('bar-chart', {
	    attrs: {
	      "chartData": _vm.chartData
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.locations')))]), _vm._v(" "), _c('base-list', {
	    attrs: {
	      "model": "locations",
	      "columns": ['name', 'contact_name'],
	      "sModel": "location"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.300a46cd1e05f12d5180.js